!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("UV", [], t) : "object" == typeof exports ? exports.UV = t() : e.UV = t();
}(window, function () {
  return function (e) {
    function t(t) {
      for (var n, r, o = t[0], a = t[1], s = 0, u = []; s < o.length; s++) r = o[s], Object.prototype.hasOwnProperty.call(i, r) && i[r] && u.push(i[r][0]), i[r] = 0;

      for (n in a) Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);

      for (c && c(t); u.length;) u.shift()();
    }

    var n = {},
        i = {
      14: 0
    };

    function r(t) {
      if (n[t]) return n[t].exports;
      var i = n[t] = {
        i: t,
        l: !1,
        exports: {}
      };
      return e[t].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
    }

    r.e = function (e) {
      var t = [],
          n = i[e];
      if (0 !== n) if (n) t.push(n[2]);else {
        var o = new Promise(function (t, r) {
          n = i[e] = [t, r];
        });
        t.push(n[2] = o);
        var a,
            s = document.createElement("script");
        s.charset = "utf-8", s.timeout = 120, r.nc && s.setAttribute("nonce", r.nc), s.src = function (e) {
          return r.p + "" + ({
            2: "uv-aleph-extension~uv-default-extension~uv-ebook-extension~uv-mediaelement-extension~uv-model-viewer~d066739a",
            3: "vendors~uv-aleph-extension~uv-default-extension~uv-ebook-extension~uv-mediaelement-extension~uv-mode~d6e026a8",
            4: "vendors~uv-model-viewer-extension~uv-openseadragon-extension",
            15: "pdfjs",
            16: "pdfobject",
            17: "uv-aleph-extension",
            18: "uv-default-extension",
            19: "uv-ebook-extension",
            20: "uv-mediaelement-extension",
            21: "uv-model-viewer-extension",
            22: "uv-openseadragon-extension",
            23: "uv-pdf-extension",
            24: "vendors~pdfjs",
            25: "vendors~uv-aleph-extension",
            26: "vendors~uv-ebook-extension",
            27: "vendors~uv-mediaelement-extension",
            28: "vendors~uv-model-viewer-extension",
            29: "vendors~uv-openseadragon-extension"
          }[e] || e) + "." + {
            0: "900d29e6034c358ee3bc",
            1: "2467be55579605fdc204",
            2: "f045c85925b4016b0238",
            3: "7e9db1249752c0aa2af4",
            4: "ca3a8a9366c374cb639b",
            5: "b2d0261457ae0eb83715",
            6: "8706dc4a2c1eba561edc",
            7: "dd083381effb4473c5dc",
            8: "ec202bf834b899dce191",
            9: "d6c928481973405dc329",
            10: "7ff28efc0d8086c56da9",
            11: "bdf7700dfb9a19b54b14",
            12: "0f8d46b45db746f3c1c7",
            13: "0738e40e4a967c9559e4",
            15: "ea7c6bfa899760a49306",
            16: "8768ccc7e79353f4ede1",
            17: "2955f03e50ccfe488282",
            18: "670943ad48891da7f809",
            19: "42c82869f6c44654504b",
            20: "43027e2a382f6f8781e1",
            21: "fe4c794cfc3fd723dbd8",
            22: "516846765ad6a7ddf1ff",
            23: "94acbfc1fd26fb618577",
            24: "7b890fc29f3a8d5ca1cd",
            25: "45233331a0fb606dc6d2",
            26: "91b006e14ebf30bcfbcb",
            27: "6eb41197d5210db77311",
            28: "296162d4ef1e7b2791c0",
            29: "48a46434a34ecdbff01b",
            30: "bf61d003257dcfb4cf4e",
            31: "eb02173728b916596d45",
            32: "5e92d9276268fd126ff1",
            33: "e2c3d99d53b9ba42c40a",
            34: "a989dd5b6bdae0465c52",
            35: "d5d7f53ccdd1bba60739",
            36: "c15db79187dfb02d78b8",
            37: "f9d31ff086869d941679",
            38: "45911311fdc20a69c3c1",
            39: "b51fc182a8d33e344043",
            40: "3b342516ca36b9be0843",
            41: "84c0c566585256ad2001",
            42: "f051dc1f7401b2ce0ca3",
            43: "dcd473b2392611e2b3a7",
            44: "22c66f607de98dc1ffd2",
            45: "ed9c2308cf0200a6660f",
            46: "a44884463c9148babb60",
            47: "2593217416527aafaab5",
            48: "886381523808e23f2b4b",
            49: "cb183df5a049a1d62b23",
            50: "4ff9aa082174a8b907e4",
            51: "1cf754a9e428896322b9",
            52: "bb9392f884afa64f72f4",
            53: "db3022b9fc02200064c2",
            54: "be491f95fd0919104fa3",
            55: "bab6e9de0cb071537536",
            56: "09f6de6c50bd9cac69af",
            57: "fc9814755d27a4203190",
            58: "584006610d5aa5b96eca",
            59: "aa62dd4b713949c4bbc5",
            60: "1bdf98fe216251e7d795",
            61: "6db1bb5cac22ed253150",
            62: "eabc21752c0da9f81c4d",
            63: "bb34ad3755f541b6adbc",
            64: "e0dc8db2c14fd9ae74de",
            65: "5e776adb8b04ba4c795a",
            66: "257ec5a0a8b00d35b164",
            67: "a94cf35e478d7909a698",
            68: "7e7c59682c8126523cec",
            69: "236f1c9b87e03847383b",
            70: "3dfaedcd381e8b1f39e7",
            71: "d1debed226a9c4065742",
            72: "c930d79d2153d18e1b42",
            73: "7e3768b5842a57177d93",
            74: "b136dbeaf5432aa70794",
            75: "5e0cb5f2feebc9615c75",
            76: "abde4cd9f573c910a5c9",
            77: "340e70a83e4ec5361647",
            78: "538f2491ed50a3d606a0",
            79: "a2065a17ff8897a9ee20",
            80: "c56924eb0759c77d646c",
            81: "e50536b51e9565c62525",
            82: "d8b9aa3e1de674027099",
            83: "db054b8f0c5c5cef4b50",
            84: "ce3eb1ca155eb2acd05f",
            85: "cdaf58b7bd4a34cc8ec5",
            86: "da438bcf715a84484230",
            87: "bbcd2cd3ff9c5676e948",
            88: "e8c41039d4b0bf6eeef6",
            89: "f10b34406826d59456aa",
            90: "b3c03edce7c8b5a4f5e8",
            91: "92c84fe688b712b0e4f6",
            92: "b34b3ef2a30a9e6ea3a2",
            93: "3089b00c6e84841f4416",
            94: "fe0b4be5033cb46b7b64",
            95: "3eafb1ea960511ee005c",
            96: "c9209685b247b60230d0",
            97: "f4adcaaa12438ab8ce44",
            98: "de2baeea9a4884e0307a",
            99: "8f907c67faa601f2cf98",
            100: "9b4af64b9cb50e2198be",
            101: "f619c0109583baff3d8c",
            102: "89db49046e183e00717c",
            103: "76f78b2b58bdc78968b1",
            104: "e30495d48072a189f770",
            105: "6f273a7b5414e065256e",
            106: "850dd1f36dccee41dfb3",
            107: "99a0a953dc65b947ff11",
            108: "c814ce68a6b6ed30c32e",
            109: "d612c2c02f7305b5c5b6",
            110: "0a247c0c0a77988a7611",
            111: "99d7078f4a119bb6da41",
            112: "20b8b11be19b916a8afb",
            113: "8c68b40c846f52053c64",
            114: "e173faa04034dbfb8fd6",
            115: "eddd968005f0fddfc77e",
            116: "094bac47c70c9234ab17",
            117: "2c66cf6bc49501e8f344",
            118: "0d6b31d760b5349cb3a5",
            119: "38a0b85790d1b8758edb",
            120: "892394c4352a1c9bb237",
            121: "8ca6c2e4947ae06214eb",
            122: "38a393be5c1d323c1d2f",
            123: "1a537bf88997af9f9c12",
            124: "e87079adea526d05657b",
            125: "0c7d012310066f1b3244",
            126: "d5df9232a8ea0688b83a",
            127: "4b75ebdaf6df6c869c8f",
            128: "0d5466d4e8b5fa6d98d3",
            129: "1bcb7c1a90065bdaf84e",
            130: "b0e27b2134a82a16c826",
            131: "0f88d5b16cedd21a5aeb",
            132: "a4704091d3c9112b4e15",
            133: "153228548e5655177cfe",
            134: "b839ed19b1c9c8610c99",
            135: "53f4f844c584c3a4bef4",
            136: "211a2cbc8583dafb9afd",
            137: "16e75065decfdfda9989",
            138: "f54d9cf118fb04ed78cc",
            139: "4f10e5986fb8cce0d4da",
            140: "f4fd8c86e9c7c1369144",
            141: "c5f2cd7934595949ae23",
            142: "662e6b41c6e35bf77e8d",
            143: "239e5e93fd690d1b7b8f",
            144: "c2aa22439e403e6f9627",
            145: "90596803ef1cfef0a254",
            146: "131b6a4a0b91086b30c2",
            147: "ba5b742429c6406b4fb1",
            148: "f5f9e097887452119200",
            149: "9f7711a9ff1a1ac5442e",
            150: "eeedbaa993b69fc931ce",
            151: "2f333422e2c0b8733090",
            152: "ccf1921c5839cfe5da80",
            153: "d282509d86e36edae253",
            154: "e3c2e3875249b1e52935",
            155: "a651b16101b11beb81b7",
            156: "e608b79ab316f4a512b9",
            157: "b5ea8a43a572bd586243",
            158: "9600dd1fc13a8f287a86",
            159: "7c6aa46b641c8b5e4e3d",
            160: "2256d9302a891044a7b6",
            161: "7da9409d799688f277d4",
            162: "4f2a61650fae851285fc",
            163: "8f3667609c48d3f38b32",
            164: "174892526bfecfd8e6be",
            165: "f80c0c2a475472b41e9b",
            166: "8b03dc7989a23346fdbb",
            167: "3d9df23071116ec38e9b"
          }[e] + ".js";
        }(e);
        var c = new Error();

        a = function a(t) {
          s.onerror = s.onload = null, clearTimeout(u);
          var n = i[e];

          if (0 !== n) {
            if (n) {
              var r = t && ("load" === t.type ? "missing" : t.type),
                  o = t && t.target && t.target.src;
              c.message = "Loading chunk " + e + " failed.\n(" + r + ": " + o + ")", c.name = "ChunkLoadError", c.type = r, c.request = o, n[1](c);
            }

            i[e] = void 0;
          }
        };

        var u = setTimeout(function () {
          a({
            type: "timeout",
            target: s
          });
        }, 12e4);
        s.onerror = s.onload = a, document.head.appendChild(s);
      }
      return Promise.all(t);
    }, r.m = e, r.c = n, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var i in e) r.d(n, i, function (t) {
        return e[t];
      }.bind(null, i));
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "uv-dist-umd/", r.oe = function (e) {
      throw console.error(e), e;
    };
    var o = window.webpackJsonpUV = window.webpackJsonpUV || [],
        a = o.push.bind(o);
    o.push = t, o = o.slice();

    for (var s = 0; s < o.length; s++) t(o[s]);

    var c = a;
    return r(r.s = 14);
  }([function (e, t, n) {
    "use strict";

    var i, r, o, a, s, c, u, l, f;
    n.d(t, "a", function () {
      return o;
    }), n.d(t, "b", function () {
      return a;
    }), n.d(t, "c", function () {
      return s;
    }), n.d(t, "d", function () {
      return c;
    }), n.d(t, "e", function () {
      return u;
    }), n.d(t, "f", function () {
      return l;
    }), n.d(t, "g", function () {
      return f;
    }), function (e) {
      e.BOOKMARKING = "oa:bookmarking", e.CLASSIFYING = "oa:classifying", e.COMMENTING = "oa:commenting", e.DESCRIBING = "oa:describing", e.EDITING = "oa:editing", e.HIGHLIGHTING = "oa:highlighting", e.IDENTIFYING = "oa:identifying", e.LINKING = "oa:linking", e.MODERATING = "oa:moderating", e.PAINTING = "sc:painting", e.QUESTIONING = "oa:questioning", e.REPLYING = "oa:replying", e.TAGGING = "oa:tagging", e.TRANSCRIBING = "oad:transcribing";
    }(i || (i = {})), function (e) {
      e.AUTO_ADVANCE = "auto-advance", e.CONTINUOUS = "continuous", e.FACING_PAGES = "facing-pages", e.HIDDEN = "hidden", e.INDIVIDUALS = "individuals", e.MULTI_PART = "multi-part", e.NO_NAV = "no-nav", e.NON_PAGED = "non-paged", e.PAGED = "paged", e.REPEAT = "repeat", e.SEQUENCE = "sequence", e.THUMBNAIL_NAV = "thumbnail-nav", e.TOGETHER = "together", e.UNORDERED = "unordered";
    }(r || (r = {})), function (e) {
      e.CANVAS = "canvas", e.CHOICE = "choice", e.CONTENT_AS_TEXT = "contentastext", e.DATASET = "dataset", e.DOCUMENT = "document", e.IMAGE = "image", e.MODEL = "model", e.MOVING_IMAGE = "movingimage", e.PDF = "pdf", e.PHYSICAL_OBJECT = "physicalobject", e.SOUND = "sound", e.TEXT = "text", e.TEXTUALBODY = "textualbody", e.VIDEO = "video";
    }(o || (o = {})), function (e) {
      e.ANNOTATION = "annotation", e.CANVAS = "canvas", e.COLLECTION = "collection", e.MANIFEST = "manifest", e.RANGE = "range", e.SEQUENCE = "sequence";
    }(a || (a = {})), function (e) {
      e.AUDIO_MP4 = "audio/mp4", e.CORTO = "application/corto", e.DRACO = "application/draco", e.EPUB = "application/epub+zip", e.GLB = "model/gltf-binary", e.GLTF = "model/gltf+json", e.JPG = "image/jpeg", e.M3U8 = "application/vnd.apple.mpegurl", e.MP3 = "audio/mp3", e.MPEG_DASH = "application/dash+xml", e.OBJ = "text/plain", e.OPF = "application/oebps-package+xml", e.PDF = "application/pdf", e.PLY = "application/ply", e.THREEJS = "application/vnd.threejs+json", e.USDZ = "model/vnd.usd+zip", e.VIDEO_MP4 = "video/mp4", e.WEBM = "video/webm";
    }(s || (s = {})), function (e) {
      e.DOC = "application/msword", e.DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document", e.PDF = "application/pdf";
    }(c || (c = {})), function (e) {
      e.IMAGE_0_COMPLIANCE_LEVEL_0 = "http://library.stanford.edu/iiif/image-api/compliance.html#level0", e.IMAGE_0_COMPLIANCE_LEVEL_1 = "http://library.stanford.edu/iiif/image-api/compliance.html#level1", e.IMAGE_0_COMPLIANCE_LEVEL_2 = "http://library.stanford.edu/iiif/image-api/compliance.html#level2", e.IMAGE_0_CONFORMANCE_LEVEL_0 = "http://library.stanford.edu/iiif/image-api/conformance.html#level0", e.IMAGE_0_CONFORMANCE_LEVEL_1 = "http://library.stanford.edu/iiif/image-api/conformance.html#level1", e.IMAGE_0_CONFORMANCE_LEVEL_2 = "http://library.stanford.edu/iiif/image-api/conformance.html#level2", e.IMAGE_1_COMPLIANCE_LEVEL_0 = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0", e.IMAGE_1_COMPLIANCE_LEVEL_1 = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level1", e.IMAGE_1_COMPLIANCE_LEVEL_2 = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level2", e.IMAGE_1_CONFORMANCE_LEVEL_0 = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level0", e.IMAGE_1_CONFORMANCE_LEVEL_1 = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level1", e.IMAGE_1_CONFORMANCE_LEVEL_2 = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level2", e.IMAGE_1_LEVEL_0 = "http://iiif.io/api/image/1/level0.json", e.IMAGE_1_PROFILE_LEVEL_0 = "http://iiif.io/api/image/1/profiles/level0.json", e.IMAGE_1_LEVEL_1 = "http://iiif.io/api/image/1/level1.json", e.IMAGE_1_PROFILE_LEVEL_1 = "http://iiif.io/api/image/1/profiles/level1.json", e.IMAGE_1_LEVEL_2 = "http://iiif.io/api/image/1/level2.json", e.IMAGE_1_PROFILE_LEVEL_2 = "http://iiif.io/api/image/1/profiles/level2.json", e.IMAGE_2_LEVEL_0 = "http://iiif.io/api/image/2/level0.json", e.IMAGE_2_PROFILE_LEVEL_0 = "http://iiif.io/api/image/2/profiles/level0.json", e.IMAGE_2_LEVEL_1 = "http://iiif.io/api/image/2/level1.json", e.IMAGE_2_PROFILE_LEVEL_1 = "http://iiif.io/api/image/2/profiles/level1.json", e.IMAGE_2_LEVEL_2 = "http://iiif.io/api/image/2/level2.json", e.IMAGE_2_PROFILE_LEVEL_2 = "http://iiif.io/api/image/2/profiles/level2.json", e.AUTH_0_CLICK_THROUGH = "http://iiif.io/api/auth/0/login/clickthrough", e.AUTH_0_LOGIN = "http://iiif.io/api/auth/0/login", e.AUTH_0_LOGOUT = "http://iiif.io/api/auth/0/logout", e.AUTH_0_RESTRICTED = "http://iiif.io/api/auth/0/login/restricted", e.AUTH_0_TOKEN = "http://iiif.io/api/auth/0/token", e.AUTH_1_CLICK_THROUGH = "http://iiif.io/api/auth/1/clickthrough", e.AUTH_1_EXTERNAL = "http://iiif.io/api/auth/1/external", e.AUTH_1_KIOSK = "http://iiif.io/api/auth/1/kiosk", e.AUTH_1_LOGIN = "http://iiif.io/api/auth/1/login", e.AUTH_1_LOGOUT = "http://iiif.io/api/auth/1/logout", e.AUTH_1_PROBE = "http://iiif.io/api/auth/1/probe", e.AUTH_1_TOKEN = "http://iiif.io/api/auth/1/token", e.SEARCH_0 = "http://iiif.io/api/search/0/search", e.SEARCH_0_AUTO_COMPLETE = "http://iiif.io/api/search/0/autocomplete", e.SEARCH_1 = "http://iiif.io/api/search/1/search", e.SEARCH_1_AUTO_COMPLETE = "http://iiif.io/api/search/1/autocomplete", e.TRACKING_EXTENSIONS = "http://universalviewer.io/tracking-extensions-profile", e.UI_EXTENSIONS = "http://universalviewer.io/ui-extensions-profile", e.PRINT_EXTENSIONS = "http://universalviewer.io/print-extensions-profile", e.SHARE_EXTENSIONS = "http://universalviewer.io/share-extensions-profile", e.OTHER_MANIFESTATIONS = "http://iiif.io/api/otherManifestations.json", e.IXIF = "http://wellcomelibrary.org/ld/ixif/0/alpha.json";
    }(u || (u = {})), function (e) {
      e.BOTTOM_TO_TOP = "bottom-to-top", e.LEFT_TO_RIGHT = "left-to-right", e.RIGHT_TO_LEFT = "right-to-left", e.TOP_TO_BOTTOM = "top-to-bottom";
    }(l || (l = {})), function (e) {
      e.CONTINUOUS = "continuous", e.INDIVIDUALS = "individuals", e.NON_PAGED = "non-paged", e.PAGED = "paged", e.TOP = "top";
    }(f || (f = {}));
  }, function (e, t, n) {
    "undefined" != typeof self && self, e.exports = function (e) {
      var t = {};

      function n(i) {
        if (t[i]) return t[i].exports;
        var r = t[i] = {
          i: i,
          l: !1,
          exports: {}
        };
        return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
      }

      return n.m = e, n.c = t, n.d = function (e, t, i) {
        n.o(e, t) || Object.defineProperty(e, t, {
          enumerable: !0,
          get: i
        });
      }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, n.t = function (e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var i = Object.create(null);
        if (n.r(i), Object.defineProperty(i, "default", {
          enumerable: !0,
          value: e
        }), 2 & t && "string" != typeof e) for (var r in e) n.d(i, r, function (t) {
          return e[t];
        }.bind(null, r));
        return i;
      }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return n.d(t, "a", t), t;
      }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, n.p = "", n(n.s = 4);
    }([function (e, t, n) {
      "use strict";

      function i(e) {
        for (var n in e) t.hasOwnProperty(n) || (t[n] = e[n]);
      }

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), i(n(6)), i(n(7)), i(n(8)), i(n(9)), i(n(10)), i(n(11)), i(n(12)), i(n(13)), i(n(14)), i(n(15)), i(n(16)), i(n(17)), i(n(18)), i(n(19)), i(n(20)), i(n(21)), i(n(22)), i(n(23)), i(n(24)), i(n(25)), i(n(26)), i(n(27)), i(n(28)), i(n(29)), i(n(30)), i(n(31)), i(n(32)), i(n(2));
    }, function (e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), function (e) {
        e.BOOKMARKING = "oa:bookmarking", e.CLASSIFYING = "oa:classifying", e.COMMENTING = "oa:commenting", e.DESCRIBING = "oa:describing", e.EDITING = "oa:editing", e.HIGHLIGHTING = "oa:highlighting", e.IDENTIFYING = "oa:identifying", e.LINKING = "oa:linking", e.MODERATING = "oa:moderating", e.PAINTING = "sc:painting", e.QUESTIONING = "oa:questioning", e.REPLYING = "oa:replying", e.TAGGING = "oa:tagging", e.TRANSCRIBING = "oad:transcribing";
      }(t.AnnotationMotivation || (t.AnnotationMotivation = {})), function (e) {
        e.AUTO_ADVANCE = "auto-advance", e.CONTINUOUS = "continuous", e.FACING_PAGES = "facing-pages", e.HIDDEN = "hidden", e.INDIVIDUALS = "individuals", e.MULTI_PART = "multi-part", e.NO_NAV = "no-nav", e.NON_PAGED = "non-paged", e.PAGED = "paged", e.REPEAT = "repeat", e.SEQUENCE = "sequence", e.THUMBNAIL_NAV = "thumbnail-nav", e.TOGETHER = "together", e.UNORDERED = "unordered";
      }(t.Behavior || (t.Behavior = {})), function (e) {
        e.CANVAS = "canvas", e.CHOICE = "choice", e.CONTENT_AS_TEXT = "contentastext", e.DOCUMENT = "document", e.IMAGE = "image", e.MOVING_IMAGE = "movingimage", e.PDF = "pdf", e.PHYSICAL_OBJECT = "physicalobject", e.SOUND = "sound", e.TEXTUALBODY = "textualbody", e.VIDEO = "video";
      }(t.ExternalResourceType || (t.ExternalResourceType = {})), function (e) {
        e.ANNOTATION = "annotation", e.CANVAS = "canvas", e.COLLECTION = "collection", e.MANIFEST = "manifest", e.RANGE = "range", e.SEQUENCE = "sequence";
      }(t.IIIFResourceType || (t.IIIFResourceType = {})), function (e) {
        e.AUDIO_MP4 = "audio/mp4", e.CORTO = "application/corto", e.DRACO = "application/draco", e.GLTF = "model/gltf+json", e.JPG = "image/jpeg", e.M3U8 = "application/vnd.apple.mpegurl", e.MP3 = "audio/mp3", e.MPEG_DASH = "application/dash+xml", e.OBJ = "text/plain", e.PDF = "application/pdf", e.PLY = "application/ply", e.THREEJS = "application/vnd.threejs+json", e.VIDEO_MP4 = "video/mp4", e.WEBM = "video/webm";
      }(t.MediaType || (t.MediaType = {})), function (e) {
        e.DOC = "application/msword", e.DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document", e.PDF = "application/pdf";
      }(t.RenderingFormat || (t.RenderingFormat = {})), function (e) {
        e.IMAGE_0_COMPLIANCE_LEVEL_0 = "http://library.stanford.edu/iiif/image-api/compliance.html#level0", e.IMAGE_0_COMPLIANCE_LEVEL_1 = "http://library.stanford.edu/iiif/image-api/compliance.html#level1", e.IMAGE_0_COMPLIANCE_LEVEL_2 = "http://library.stanford.edu/iiif/image-api/compliance.html#level2", e.IMAGE_0_CONFORMANCE_LEVEL_0 = "http://library.stanford.edu/iiif/image-api/conformance.html#level0", e.IMAGE_0_CONFORMANCE_LEVEL_1 = "http://library.stanford.edu/iiif/image-api/conformance.html#level1", e.IMAGE_0_CONFORMANCE_LEVEL_2 = "http://library.stanford.edu/iiif/image-api/conformance.html#level2", e.IMAGE_1_COMPLIANCE_LEVEL_0 = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level0", e.IMAGE_1_COMPLIANCE_LEVEL_1 = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level1", e.IMAGE_1_COMPLIANCE_LEVEL_2 = "http://library.stanford.edu/iiif/image-api/1.1/compliance.html#level2", e.IMAGE_1_CONFORMANCE_LEVEL_0 = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level0", e.IMAGE_1_CONFORMANCE_LEVEL_1 = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level1", e.IMAGE_1_CONFORMANCE_LEVEL_2 = "http://library.stanford.edu/iiif/image-api/1.1/conformance.html#level2", e.IMAGE_1_LEVEL_0 = "http://iiif.io/api/image/1/level0.json", e.IMAGE_1_PROFILE_LEVEL_0 = "http://iiif.io/api/image/1/profiles/level0.json", e.IMAGE_1_LEVEL_1 = "http://iiif.io/api/image/1/level1.json", e.IMAGE_1_PROFILE_LEVEL_1 = "http://iiif.io/api/image/1/profiles/level1.json", e.IMAGE_1_LEVEL_2 = "http://iiif.io/api/image/1/level2.json", e.IMAGE_1_PROFILE_LEVEL_2 = "http://iiif.io/api/image/1/profiles/level2.json", e.IMAGE_2_LEVEL_0 = "http://iiif.io/api/image/2/level0.json", e.IMAGE_2_PROFILE_LEVEL_0 = "http://iiif.io/api/image/2/profiles/level0.json", e.IMAGE_2_LEVEL_1 = "http://iiif.io/api/image/2/level1.json", e.IMAGE_2_PROFILE_LEVEL_1 = "http://iiif.io/api/image/2/profiles/level1.json", e.IMAGE_2_LEVEL_2 = "http://iiif.io/api/image/2/level2.json", e.IMAGE_2_PROFILE_LEVEL_2 = "http://iiif.io/api/image/2/profiles/level2.json", e.AUTH_0_CLICK_THROUGH = "http://iiif.io/api/auth/0/login/clickthrough", e.AUTH_0_LOGIN = "http://iiif.io/api/auth/0/login", e.AUTH_0_LOGOUT = "http://iiif.io/api/auth/0/logout", e.AUTH_0_RESTRICTED = "http://iiif.io/api/auth/0/login/restricted", e.AUTH_0_TOKEN = "http://iiif.io/api/auth/0/token", e.AUTH_1_CLICK_THROUGH = "http://iiif.io/api/auth/1/clickthrough", e.AUTH_1_EXTERNAL = "http://iiif.io/api/auth/1/external", e.AUTH_1_KIOSK = "http://iiif.io/api/auth/1/kiosk", e.AUTH_1_LOGIN = "http://iiif.io/api/auth/1/login", e.AUTH_1_LOGOUT = "http://iiif.io/api/auth/1/logout", e.AUTH_1_PROBE = "http://iiif.io/api/auth/1/probe", e.AUTH_1_TOKEN = "http://iiif.io/api/auth/1/token", e.SEARCH_0 = "http://iiif.io/api/search/0/search", e.SEARCH_0_AUTO_COMPLETE = "http://iiif.io/api/search/0/autocomplete", e.SEARCH_1 = "http://iiif.io/api/search/1/search", e.SEARCH_1_AUTO_COMPLETE = "http://iiif.io/api/search/1/autocomplete", e.TRACKING_EXTENSIONS = "http://universalviewer.io/tracking-extensions-profile", e.UI_EXTENSIONS = "http://universalviewer.io/ui-extensions-profile", e.PRINT_EXTENSIONS = "http://universalviewer.io/print-extensions-profile", e.SHARE_EXTENSIONS = "http://universalviewer.io/share-extensions-profile", e.OTHER_MANIFESTATIONS = "http://iiif.io/api/otherManifestations.json", e.IXIF = "http://wellcomelibrary.org/ld/ixif/0/alpha.json";
      }(t.ServiceProfile || (t.ServiceProfile = {})), function (e) {
        e.BOTTOM_TO_TOP = "bottom-to-top", e.LEFT_TO_RIGHT = "left-to-right", e.RIGHT_TO_LEFT = "right-to-left", e.TOP_TO_BOTTOM = "top-to-bottom";
      }(t.ViewingDirection || (t.ViewingDirection = {})), function (e) {
        e.CONTINUOUS = "continuous", e.INDIVIDUALS = "individuals", e.NON_PAGED = "non-paged", e.PAGED = "paged", e.TOP = "top";
      }(t.ViewingHint || (t.ViewingHint = {}));
    }, function (e, t, n) {
      "use strict";

      var i = this && this.__awaiter || function (e, t, n, i) {
        return new (n || (n = Promise))(function (r, o) {
          function a(e) {
            try {
              c(i.next(e));
            } catch (e) {
              o(e);
            }
          }

          function s(e) {
            try {
              c(i.throw(e));
            } catch (e) {
              o(e);
            }
          }

          function c(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
              e(t);
            })).then(a, s);
          }

          c((i = i.apply(e, t || [])).next());
        });
      },
          r = this && this.__generator || function (e, t) {
        var n,
            i,
            r,
            o,
            a = {
          label: 0,
          sent: function sent() {
            if (1 & r[0]) throw r[1];
            return r[1];
          },
          trys: [],
          ops: []
        };
        return o = {
          next: s(0),
          throw: s(1),
          return: s(2)
        }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
          return this;
        }), o;

        function s(o) {
          return function (s) {
            return function (o) {
              if (n) throw new TypeError("Generator is already executing.");

              for (; a;) try {
                if (n = 1, i && (r = 2 & o[0] ? i.return : o[0] ? i.throw || ((r = i.return) && r.call(i), 0) : i.next) && !(r = r.call(i, o[1])).done) return r;

                switch (i = 0, r && (o = [2 & o[0], r.value]), o[0]) {
                  case 0:
                  case 1:
                    r = o;
                    break;

                  case 4:
                    return a.label++, {
                      value: o[1],
                      done: !1
                    };

                  case 5:
                    a.label++, i = o[1], o = [0];
                    continue;

                  case 7:
                    o = a.ops.pop(), a.trys.pop();
                    continue;

                  default:
                    if (!(r = (r = a.trys).length > 0 && r[r.length - 1]) && (6 === o[0] || 2 === o[0])) {
                      a = 0;
                      continue;
                    }

                    if (3 === o[0] && (!r || o[1] > r[0] && o[1] < r[3])) {
                      a.label = o[1];
                      break;
                    }

                    if (6 === o[0] && a.label < r[1]) {
                      a.label = r[1], r = o;
                      break;
                    }

                    if (r && a.label < r[2]) {
                      a.label = r[2], a.ops.push(o);
                      break;
                    }

                    r[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }

                o = t.call(e, a);
              } catch (e) {
                o = [6, e], i = 0;
              } finally {
                n = r = 0;
              }

              if (5 & o[0]) throw o[1];
              return {
                value: o[0] ? o[1] : void 0,
                done: !0
              };
            }([o, s]);
          };
        }
      };

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var o = n(0),
          a = n(1),
          s = n(33);
      n(34);

      var c = function () {
        function e() {}

        return e.getMediaType = function (e) {
          return (e = (e = e.toLowerCase()).split(";")[0]).trim();
        }, e.getImageQuality = function (e) {
          return e === a.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_1 || e === a.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_2 || e === a.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_1 || e === a.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_2 || e === a.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_1 || e === a.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_2 || e === a.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_1 || e === a.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_2 || e === a.ServiceProfile.IMAGE_1_LEVEL_1 || e === a.ServiceProfile.IMAGE_1_PROFILE_LEVEL_1 || e === a.ServiceProfile.IMAGE_1_LEVEL_2 || e === a.ServiceProfile.IMAGE_1_PROFILE_LEVEL_2 ? "native" : "default";
        }, e.getInexactLocale = function (e) {
          return -1 !== e.indexOf("-") ? e.substr(0, e.indexOf("-")) : e;
        }, e.getLocalisedValue = function (e, t) {
          if (!Array.isArray(e)) return e;

          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            if (t === i["@language"]) return i["@value"];
          }

          var r = t.substr(0, t.indexOf("-"));

          for (n = 0; n < e.length; n++) {
            var o = e[n];
            if (o["@language"] === r) return o["@value"];
          }

          return null;
        }, e.generateTreeNodeIds = function (t, n) {
          var i;
          void 0 === n && (n = 0), i = t.parentNode ? t.parentNode.id + "-" + n : "0", t.id = i;

          for (var r = 0; r < t.nodes.length; r++) {
            var o = t.nodes[r];
            e.generateTreeNodeIds(o, r);
          }
        }, e.normaliseType = function (e) {
          return -1 !== (e = e.toLowerCase()).indexOf(":") ? e.split(":")[1] : e;
        }, e.normaliseUrl = function (e) {
          return -1 !== (e = e.substr(e.indexOf("://"))).indexOf("#") && (e = e.split("#")[0]), e;
        }, e.normalisedUrlsMatch = function (t, n) {
          return e.normaliseUrl(t) === e.normaliseUrl(n);
        }, e.isImageProfile = function (t) {
          return !!(e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_PROFILE_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_PROFILE_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_PROFILE_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_PROFILE_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_PROFILE_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_PROFILE_LEVEL_2));
        }, e.isLevel0ImageProfile = function (t) {
          return !!(e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_PROFILE_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_LEVEL_0) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_PROFILE_LEVEL_0));
        }, e.isLevel1ImageProfile = function (t) {
          return !!(e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_PROFILE_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_LEVEL_1) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_PROFILE_LEVEL_1));
        }, e.isLevel2ImageProfile = function (t) {
          return !!(e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_COMPLIANCE_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_COMPLIANCE_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_0_CONFORMANCE_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_CONFORMANCE_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_1_PROFILE_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_LEVEL_2) || e.normalisedUrlsMatch(t, a.ServiceProfile.IMAGE_2_PROFILE_LEVEL_2));
        }, e.parseManifest = function (e, t) {
          return o.Deserialiser.parse(e, t);
        }, e.checkStatus = function (e) {
          if (e.ok) return e;
          var t = new Error(e.statusText);
          return t.response = e, Promise.reject(t);
        }, e.loadManifest = function (t) {
          return new Promise(function (n) {
            fetch(t).then(e.checkStatus).then(function (e) {
              return e.json();
            }).then(function (e) {
              n(e);
            });
          });
        }, e.loadExternalResourcesAuth1 = function (t, n, i, r, o, a, s, c) {
          return new Promise(function (u, l) {
            var f = t.map(function (t) {
              return e.loadExternalResourceAuth1(t, n, i, r, o, a, s, c);
            });
            Promise.all(f).then(function () {
              u(t);
            }).catch(function (e) {
              l(e);
            });
          });
        }, e.loadExternalResourceAuth1 = function (t, n, o, a, c, u, l, f) {
          return i(this, void 0, void 0, function () {
            var i;
            return r(this, function (r) {
              switch (r.label) {
                case 0:
                  return [4, a(t)];

                case 1:
                  return (i = r.sent()) ? [4, t.getData(i)] : [3, 6];

                case 2:
                  return r.sent(), t.status !== s.OK ? [3, 3] : [2, t];

                case 3:
                  return [4, e.doAuthChain(t, n, o, c, u, l, f)];

                case 4:
                  r.sent(), r.label = 5;

                case 5:
                  if (t.status === s.OK || t.status === s.MOVED_TEMPORARILY) return [2, t];
                  throw e.createAuthorizationFailedError();

                case 6:
                  return [4, t.getData()];

                case 7:
                  return r.sent(), t.status !== s.MOVED_TEMPORARILY && t.status !== s.UNAUTHORIZED ? [3, 9] : [4, e.doAuthChain(t, n, o, c, u, l, f)];

                case 8:
                  r.sent(), r.label = 9;

                case 9:
                  if (t.status === s.OK || t.status === s.MOVED_TEMPORARILY) return [2, t];
                  throw e.createAuthorizationFailedError();
              }
            });
          });
        }, e.doAuthChain = function (t, n, o, a, c, u, l) {
          return i(this, void 0, void 0, function () {
            var i, f, p, h, d, g, v, _;

            return r(this, function (r) {
              switch (r.label) {
                case 0:
                  return t.isAccessControlled() ? ((i = t.externalService) && (i.options = t.options), (f = t.kioskService) && (f.options = t.options), (p = t.clickThroughService) && (p.options = t.options), (h = t.loginService) && (h.options = t.options), t.isResponseHandled || t.status !== s.MOVED_TEMPORARILY ? [3, 2] : [4, u(t)]) : [2, t];

                case 1:
                  return r.sent(), [2, t];

                case 2:
                  return d = null, g = null, (d = i) ? (g = d, [4, e.attemptResourceWithToken(t, o, d)]) : [3, 4];

                case 3:
                  return r.sent(), [2, t];

                case 4:
                  return (d = f) ? (g = d, (v = n(d)) ? [4, a(v)] : [3, 7]) : [3, 7];

                case 5:
                  return r.sent(), [4, e.attemptResourceWithToken(t, o, d)];

                case 6:
                  return r.sent(), [2, t];

                case 7:
                  return (d = p) ? (g = d, [4, c(t, d)]) : [3, 11];

                case 8:
                  return (_ = r.sent()) ? [4, a(_)] : [3, 11];

                case 9:
                  return r.sent(), [4, e.attemptResourceWithToken(t, o, d)];

                case 10:
                  return r.sent(), [2, t];

                case 11:
                  return (d = h) ? (g = d, [4, c(t, d)]) : [3, 15];

                case 12:
                  return (_ = r.sent()) ? [4, a(_)] : [3, 15];

                case 13:
                  return r.sent(), [4, e.attemptResourceWithToken(t, o, d)];

                case 14:
                  return r.sent(), [2, t];

                case 15:
                  return g && l(t, g), [2];
              }
            });
          });
        }, e.attemptResourceWithToken = function (e, t, n) {
          return i(this, void 0, void 0, function () {
            var i, o;
            return r(this, function (r) {
              switch (r.label) {
                case 0:
                  return (i = n.getService(a.ServiceProfile.AUTH_1_TOKEN)) ? [4, t(e, i)] : [3, 3];

                case 1:
                  return (o = r.sent()) && o.accessToken ? [4, e.getData(o)] : [3, 3];

                case 2:
                  return r.sent(), [2, e];

                case 3:
                  return [2];
              }
            });
          });
        }, e.loadExternalResourcesAuth09 = function (t, n, i, r, o, a, s, c, u, l) {
          return new Promise(function (f, p) {
            var h = t.map(function (t) {
              return e.loadExternalResourceAuth09(t, n, i, r, o, a, s, c, u, l);
            });
            Promise.all(h).then(function () {
              f(t);
            }).catch(function (e) {
              p(e);
            });
          });
        }, e.loadExternalResourceAuth09 = function (t, n, i, r, o, a, c, u, l, f) {
          return new Promise(function (p, h) {
            f && f.pessimisticAccessControl ? t.getData().then(function () {
              t.isAccessControlled() ? t.clickThroughService ? (p(i(t)), p(r(t))) : o(t).then(function () {
                a(t, !0).then(function (n) {
                  t.getData(n).then(function () {
                    p(l(t));
                  }).catch(function (t) {
                    h(e.createInternalServerError(t));
                  });
                }).catch(function (t) {
                  h(e.createInternalServerError(t));
                });
              }).catch(function (t) {
                h(e.createInternalServerError(t));
              }) : p(t);
            }).catch(function (t) {
              h(e.createInternalServerError(t));
            }) : u(t, n).then(function (f) {
              f ? t.getData(f).then(function () {
                t.status === s.OK ? p(l(t)) : e.authorize(t, n, i, r, o, a, c, u).then(function () {
                  p(l(t));
                }).catch(function (t) {
                  h(e.createAuthorizationFailedError());
                });
              }).catch(function (t) {
                h(e.createAuthorizationFailedError());
              }) : e.authorize(t, n, i, r, o, a, c, u).then(function () {
                p(l(t));
              }).catch(function (t) {
                h(e.createAuthorizationFailedError());
              });
            }).catch(function (t) {
              h(e.createAuthorizationFailedError());
            });
          });
        }, e.createError = function (e, t) {
          var n = new Error();
          return n.message = t, n.name = String(e), n;
        }, e.createAuthorizationFailedError = function () {
          return e.createError(o.StatusCode.AUTHORIZATION_FAILED, "Authorization failed");
        }, e.createRestrictedError = function () {
          return e.createError(o.StatusCode.RESTRICTED, "Restricted");
        }, e.createInternalServerError = function (t) {
          return e.createError(o.StatusCode.INTERNAL_SERVER_ERROR, t);
        }, e.authorize = function (t, n, i, r, o, a, c, u) {
          return new Promise(function (l, f) {
            t.getData().then(function () {
              t.isAccessControlled() ? u(t, n).then(function (u) {
                u ? t.getData(u).then(function () {
                  t.status === s.OK ? l(t) : e.showAuthInteraction(t, n, i, r, o, a, c, l, f);
                }).catch(function (t) {
                  f(e.createInternalServerError(t));
                }) : a(t, !1).then(function (u) {
                  u ? c(t, u, n).then(function () {
                    t.getData(u).then(function () {
                      t.status === s.OK ? l(t) : e.showAuthInteraction(t, n, i, r, o, a, c, l, f);
                    }).catch(function (t) {
                      f(e.createInternalServerError(t));
                    });
                  }).catch(function (t) {
                    f(e.createInternalServerError(t));
                  }) : e.showAuthInteraction(t, n, i, r, o, a, c, l, f);
                });
              }).catch(function (t) {
                f(e.createInternalServerError(t));
              }) : l(t);
            });
          });
        }, e.showAuthInteraction = function (t, n, i, r, o, a, c, u, l) {
          t.status !== s.MOVED_TEMPORARILY || t.isResponseHandled ? t.clickThroughService && !t.isResponseHandled ? i(t).then(function () {
            a(t, !0).then(function (i) {
              c(t, i, n).then(function () {
                t.getData(i).then(function () {
                  u(t);
                }).catch(function (t) {
                  l(e.createInternalServerError(t));
                });
              }).catch(function (t) {
                l(e.createInternalServerError(t));
              });
            }).catch(function (t) {
              l(e.createInternalServerError(t));
            });
          }) : o(t).then(function () {
            a(t, !0).then(function (i) {
              c(t, i, n).then(function () {
                t.getData(i).then(function () {
                  u(t);
                }).catch(function (t) {
                  l(e.createInternalServerError(t));
                });
              }).catch(function (t) {
                l(e.createInternalServerError(t));
              });
            }).catch(function (t) {
              l(e.createInternalServerError(t));
            });
          }) : u(t);
        }, e.getService = function (e, t) {
          for (var n = this.getServices(e), i = 0; i < n.length; i++) {
            var r = n[i];
            if (r.getProfile() === t) return r;
          }

          return null;
        }, e.getResourceById = function (t, n) {
          return e.traverseAndFind(t.__jsonld, "@id", n);
        }, e.traverseAndFind = function (t, n, i) {
          if (t.hasOwnProperty(n) && t[n] === i) return t;

          for (var r = 0; r < Object.keys(t).length; r++) if ("object" == typeof t[Object.keys(t)[r]]) {
            var o = e.traverseAndFind(t[Object.keys(t)[r]], n, i);
            if (null != o) return o;
          }
        }, e.getServices = function (e) {
          var t,
              n = [];
          if (!(t = e.__jsonld ? e.__jsonld.service : e.service)) return n;
          Array.isArray(t) || (t = [t]);

          for (var i = 0; i < t.length; i++) {
            var r = t[i];

            if ("string" == typeof r) {
              var a = this.getResourceById(e.options.resource, r);
              a && n.push(new o.Service(a.__jsonld || a, e.options));
            } else n.push(new o.Service(r, e.options));
          }

          return n;
        }, e.getTemporalComponent = function (e) {
          var t = /t=([^&]+)/g.exec(e),
              n = null;
          return t && t[1] && (n = t[1].split(",")), n;
        }, e;
      }();

      t.Utils = c;
    }, function (e, t, n) {
      "use strict";

      n.r(t), t.default = function (e, t) {
        return t = t || {}, new Promise(function (n, i) {
          var r = new XMLHttpRequest(),
              o = [],
              a = [],
              s = {},
              c = function c() {
            return {
              ok: 2 == (r.status / 100 | 0),
              statusText: r.statusText,
              status: r.status,
              url: r.responseURL,
              text: function text() {
                return Promise.resolve(r.responseText);
              },
              json: function json() {
                return Promise.resolve(JSON.parse(r.responseText));
              },
              blob: function blob() {
                return Promise.resolve(new Blob([r.response]));
              },
              clone: c,
              headers: {
                keys: function keys() {
                  return o;
                },
                entries: function entries() {
                  return a;
                },
                get: function get(e) {
                  return s[e.toLowerCase()];
                },
                has: function has(e) {
                  return e.toLowerCase() in s;
                }
              }
            };
          };

          for (var u in r.open(t.method || "get", e, !0), r.onload = function () {
            r.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (e, t, n) {
              o.push(t = t.toLowerCase()), a.push([t, n]), s[t] = s[t] ? s[t] + "," + n : n;
            }), n(c());
          }, r.onerror = i, r.withCredentials = "include" == t.credentials, t.headers) r.setRequestHeader(u, t.headers[u]);

          r.send(t.body || null);
        });
      };
    }, function (e, t, n) {
      e.exports = n(5);
    }, function (e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), function (e) {
        for (var n in e) t.hasOwnProperty(n) || (t[n] = e[n]);
      }(n(0));
      var i = n(2);
      t.loadManifest = function (e) {
        return i.Utils.loadManifest(e);
      }, t.parseManifest = function (e, t) {
        return i.Utils.parseManifest(e, t);
      };
    }, function (e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = function () {
        function e(e) {
          this.__jsonld = e, this.context = this.getProperty("context"), this.id = this.getProperty("id");
        }

        return e.prototype.getProperty = function (e) {
          var t = null;
          return this.__jsonld && ((t = this.__jsonld[e]) || (t = this.__jsonld["@" + e])), t;
        }, e;
      }();

      t.JSONLDResource = i;
    }, function (e, t, n) {
      "use strict";

      var _i,
          r = this && this.__extends || (_i = function i(e, t) {
        return (_i = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var o = n(0),
          a = n(1),
          s = function (e) {
        function t(t, n) {
          var i = e.call(this, t) || this;
          return i.options = n, i;
        }

        return r(t, e), t.prototype.getIIIFResourceType = function () {
          return o.Utils.normaliseType(this.getProperty("type"));
        }, t.prototype.getLabel = function () {
          var e = this.getProperty("label");
          return e ? o.LanguageMap.parse(e, this.options.locale) : [];
        }, t.prototype.getDefaultLabel = function () {
          return o.LanguageMap.getValue(this.getLabel());
        }, t.prototype.getMetadata = function () {
          var e = this.getProperty("metadata"),
              t = [];
          if (!e) return t;

          for (var n = 0; n < e.length; n++) {
            var i = e[n],
                r = new o.LabelValuePair(this.options.locale);
            r.parse(i), t.push(r);
          }

          return t;
        }, t.prototype.getRendering = function (e) {
          for (var t = this.getRenderings(), n = 0; n < t.length; n++) {
            var i = t[n];
            if (i.getFormat() === e) return i;
          }

          return null;
        }, t.prototype.getRenderings = function () {
          var e,
              t = [];
          if (!(e = this.__jsonld ? this.__jsonld.rendering : this.rendering)) return t;
          Array.isArray(e) || (e = [e]);

          for (var n = 0; n < e.length; n++) {
            var i = e[n];
            t.push(new o.Rendering(i, this.options));
          }

          return t;
        }, t.prototype.getService = function (e) {
          return o.Utils.getService(this, e);
        }, t.prototype.getServices = function () {
          return o.Utils.getServices(this);
        }, t.prototype.getThumbnail = function () {
          var e = this.getProperty("thumbnail");
          return Array.isArray(e) && (e = e[0]), e ? new o.Thumbnail(e, this.options) : null;
        }, t.prototype.isAnnotation = function () {
          return this.getIIIFResourceType() === a.IIIFResourceType.ANNOTATION;
        }, t.prototype.isCanvas = function () {
          return this.getIIIFResourceType() === a.IIIFResourceType.CANVAS;
        }, t.prototype.isCollection = function () {
          return this.getIIIFResourceType() === a.IIIFResourceType.COLLECTION;
        }, t.prototype.isManifest = function () {
          return this.getIIIFResourceType() === a.IIIFResourceType.MANIFEST;
        }, t.prototype.isRange = function () {
          return this.getIIIFResourceType() === a.IIIFResourceType.RANGE;
        }, t.prototype.isSequence = function () {
          return this.getIIIFResourceType() === a.IIIFResourceType.SEQUENCE;
        }, t;
      }(o.JSONLDResource);

      t.ManifestResource = s;
    }, function (e, t, n) {
      "use strict";

      var _i2,
          r = this && this.__extends || (_i2 = function i(e, t) {
        return (_i2 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _i2(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var o = n(0),
          a = function (e) {
        function t(t, n) {
          return e.call(this, t, n) || this;
        }

        return r(t, e), t.prototype.getFormat = function () {
          var e = this.getProperty("format");
          return e ? e.toLowerCase() : null;
        }, t.prototype.getResources = function () {
          var e = [];
          if (!this.__jsonld.resources) return e;

          for (var t = 0; t < this.__jsonld.resources.length; t++) {
            var n = this.__jsonld.resources[t],
                i = new o.Annotation(n, this.options);
            e.push(i);
          }

          return e;
        }, t.prototype.getType = function () {
          var e = this.getProperty("type");
          return e ? o.Utils.normaliseType(e) : null;
        }, t.prototype.getWidth = function () {
          return this.getProperty("width");
        }, t.prototype.getHeight = function () {
          return this.getProperty("height");
        }, t.prototype.getMaxWidth = function () {
          return this.getProperty("maxWidth");
        }, t.prototype.getMaxHeight = function () {
          return this.getProperty("maxHeight") ? null : this.getMaxWidth();
        }, t;
      }(o.ManifestResource);

      t.Resource = a;
    }, function (e, t, n) {
      "use strict";

      var _i3,
          r = this && this.__extends || (_i3 = function i(e, t) {
        return (_i3 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _i3(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var o = n(0),
          a = n(1),
          s = function (e) {
        function t(t, n) {
          var i = e.call(this, t, n) || this;
          i.index = -1, i.isLoaded = !1;
          var r = {
            defaultLabel: "-",
            locale: "en-GB",
            resource: i,
            pessimisticAccessControl: !1
          };
          return i.options = Object.assign(r, n), i;
        }

        return r(t, e), t.prototype.getAttribution = function () {
          var e = this.getProperty("attribution");
          return e ? o.LanguageMap.parse(e, this.options.locale) : [];
        }, t.prototype.getDescription = function () {
          var e = this.getProperty("description");
          return e ? o.LanguageMap.parse(e, this.options.locale) : [];
        }, t.prototype.getIIIFResourceType = function () {
          return o.Utils.normaliseType(this.getProperty("type"));
        }, t.prototype.getLogo = function () {
          var e = this.getProperty("logo");
          return e ? "string" == typeof e ? e : (Array.isArray(e) && e.length && (e = e[0]), e["@id"] || e.id) : null;
        }, t.prototype.getLicense = function () {
          return o.Utils.getLocalisedValue(this.getProperty("license"), this.options.locale);
        }, t.prototype.getNavDate = function () {
          return new Date(this.getProperty("navDate"));
        }, t.prototype.getRelated = function () {
          return this.getProperty("related");
        }, t.prototype.getSeeAlso = function () {
          return this.getProperty("seeAlso");
        }, t.prototype.getTrackingLabel = function () {
          var e = this.getService(a.ServiceProfile.TRACKING_EXTENSIONS);
          return e ? e.getProperty("trackingLabel") : "";
        }, t.prototype.getDefaultTree = function () {
          return this.defaultTree = new o.TreeNode("root"), this.defaultTree.data = this, this.defaultTree;
        }, t.prototype.getRequiredStatement = function () {
          var e = null,
              t = this.getProperty("requiredStatement");
          if (t) (e = new o.LabelValuePair(this.options.locale)).parse(t);else {
            var n = this.getAttribution();
            n && ((e = new o.LabelValuePair(this.options.locale)).value = n);
          }
          return e;
        }, t.prototype.isCollection = function () {
          return this.getIIIFResourceType() === a.IIIFResourceType.COLLECTION;
        }, t.prototype.isManifest = function () {
          return this.getIIIFResourceType() === a.IIIFResourceType.MANIFEST;
        }, t.prototype.load = function () {
          var e = this;
          return new Promise(function (t) {
            if (e.isLoaded) t(e);else {
              var n = e.options;
              n.navDate = e.getNavDate();
              var i = e.__jsonld.id;
              i || (i = e.__jsonld["@id"]), o.Utils.loadManifest(i).then(function (i) {
                e.parentLabel = o.LanguageMap.getValue(e.getLabel(), n.locale);
                var r = o.Deserialiser.parse(i, n);
                (e = Object.assign(e, r)).index = n.index, t(e);
              });
            }
          });
        }, t;
      }(o.ManifestResource);

      t.IIIFResource = s;
    }, function (e, t, n) {
      "use strict";

      var _i4,
          r = this && this.__extends || (_i4 = function i(e, t) {
        return (_i4 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _i4(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var o = n(0),
          a = function (e) {
        function t(t, n) {
          return e.call(this, t, n) || this;
        }

        return r(t, e), t.prototype.getBody = function () {
          var e = [],
              t = this.getProperty("body");
          if (t) if (Array.isArray(t)) {
            for (var n = 0; n < t.length; n++) if ((a = t[n]).items) for (var i = 0; i < a.items.length; i++) {
              var r = a.items[i];
              e.push(new o.AnnotationBody(r, this.options));
            } else e.push(new o.AnnotationBody(a, this.options));
          } else if (t.items) for (n = 0; n < t.items.length; n++) {
            var a = t.items[n];
            e.push(new o.AnnotationBody(a, this.options));
          } else e.push(new o.AnnotationBody(t, this.options));
          return e;
        }, t.prototype.getMotivation = function () {
          return this.getProperty("motivation") || null;
        }, t.prototype.getOn = function () {
          return this.getProperty("on");
        }, t.prototype.getTarget = function () {
          return this.getProperty("target");
        }, t.prototype.getResource = function () {
          return new o.Resource(this.getProperty("resource"), this.options);
        }, t;
      }(o.ManifestResource);

      t.Annotation = a;
    }, function (e, t, n) {
      "use strict";

      var _i5,
          r = this && this.__extends || (_i5 = function i(e, t) {
        return (_i5 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _i5(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var o = n(0),
          a = function (e) {
        function t(t, n) {
          return e.call(this, t, n) || this;
        }

        return r(t, e), t.prototype.getFormat = function () {
          var e = this.getProperty("format");
          return e ? o.Utils.getMediaType(e) : null;
        }, t.prototype.getType = function () {
          return this.getProperty("type") ? o.Utils.normaliseType(this.getProperty("type")) : null;
        }, t.prototype.getWidth = function () {
          return this.getProperty("width");
        }, t.prototype.getHeight = function () {
          return this.getProperty("height");
        }, t;
      }(o.ManifestResource);

      t.AnnotationBody = a;
    }, function (e, t, n) {
      "use strict";

      var _i6,
          r = this && this.__extends || (_i6 = function i(e, t) {
        return (_i6 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _i6(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var o = n(0),
          a = function (e) {
        function t(t, n, i) {
          var r = e.call(this, n) || this;
          return r.label = t, r.options = i, r;
        }

        return r(t, e), t.prototype.getIIIFResourceType = function () {
          return o.Utils.normaliseType(this.getProperty("type"));
        }, t.prototype.getLabel = function () {
          return this.label;
        }, t.prototype.getResources = function () {
          var e = this;
          return this.getProperty("resources").map(function (t) {
            return new o.Annotation(t, e.options);
          });
        }, t.prototype.load = function () {
          var e = this;
          return new Promise(function (t, n) {
            if (e.isLoaded) t(e);else {
              var i = e.__jsonld.id;
              i || (i = e.__jsonld["@id"]), o.Utils.loadManifest(i).then(function (n) {
                e.__jsonld = n, e.context = e.getProperty("context"), e.id = e.getProperty("id"), e.isLoaded = !0, t(e);
              }).catch(n);
            }
          });
        }, t;
      }(o.JSONLDResource);

      t.AnnotationList = a;
    }, function (e, t, n) {
      "use strict";

      var _i7,
          r = this && this.__extends || (_i7 = function i(e, t) {
        return (_i7 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _i7(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var o = function (e) {
        function t(t, n) {
          return e.call(this, t, n) || this;
        }

        return r(t, e), t.prototype.getItems = function () {
          return this.getProperty("items");
        }, t;
      }(n(0).ManifestResource);

      t.AnnotationPage = o;
    }, function (e, t, n) {
      "use strict";

      var _i8,
          r = this && this.__extends || (_i8 = function i(e, t) {
        return (_i8 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _i8(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var o = n(0),
          a = function (e) {
        function t(t, n) {
          return e.call(this, t, n) || this;
        }

        return r(t, e), t.prototype.getCanonicalImageUri = function (e) {
          var t,
              n = null,
              i = "default",
              r = e;
          if (this.externalResource && this.externalResource.data && this.externalResource.data["@id"]) n = this.externalResource.data["@id"], r || (r = this.externalResource.data.width), this.externalResource.data["@context"] && (this.externalResource.data["@context"].indexOf("/1.0/context.json") > -1 || this.externalResource.data["@context"].indexOf("/1.1/context.json") > -1 || this.externalResource.data["@context"].indexOf("/1/context.json") > -1) && (i = "native");else {
            var a = this.getImages();

            if (a && a.length) {
              var s = a[0].getResource(),
                  c = s.getServices();

              if (r || (r = s.getWidth()), c.length) {
                var u = c[0];
                n = u.id, i = o.Utils.getImageQuality(u.getProfile());
              } else if (r === s.getWidth()) return s.id;
            }

            if (!n) {
              var l = this.getProperty("thumbnail");

              if (l) {
                if ("string" == typeof l) return l;
                if (l["@id"]) return l["@id"];
                if (l.length) return l[0].id;
              }
            }
          }
          return t = r + ",", n && n.endsWith("/") && (n = n.substr(0, n.length - 1)), [n, "full", t, 0, i + ".jpg"].join("/");
        }, t.prototype.getMaxDimensions = function () {
          var e,
              t = null;
          return this.externalResource && this.externalResource.data && this.externalResource.data.profile && (e = this.externalResource.data.profile, Array.isArray(e) && (e = e.filter(function (e) {
            return e.maxWidth;
          })[0]) && (t = new o.Size(e.maxWidth, e.maxHeight ? e.maxHeight : e.maxWidth))), t;
        }, t.prototype.getContent = function () {
          var e = [],
              t = this.__jsonld.items || this.__jsonld.content;
          if (!t) return e;
          var n = null;
          if (t.length && (n = new o.AnnotationPage(t[0], this.options)), !n) return e;

          for (var i = n.getItems(), r = 0; r < i.length; r++) {
            var a = i[r],
                s = new o.Annotation(a, this.options);
            e.push(s);
          }

          return e;
        }, t.prototype.getDuration = function () {
          return this.getProperty("duration");
        }, t.prototype.getImages = function () {
          var e = [];
          if (!this.__jsonld.images) return e;

          for (var t = 0; t < this.__jsonld.images.length; t++) {
            var n = this.__jsonld.images[t],
                i = new o.Annotation(n, this.options);
            e.push(i);
          }

          return e;
        }, t.prototype.getIndex = function () {
          return this.getProperty("index");
        }, t.prototype.getOtherContent = function () {
          var e = this,
              t = (Array.isArray(this.getProperty("otherContent")) ? this.getProperty("otherContent") : [this.getProperty("otherContent")]).filter(function (e) {
            return e && "string" == typeof (t = e["@type"]) && t.toLowerCase() == t.toLowerCase();
            var t;
          }).map(function (t, n) {
            return new o.AnnotationList(t.label || "Annotation list " + n, t, e.options);
          }).map(function (e) {
            return e.load();
          });
          return Promise.all(t);
        }, t.prototype.getWidth = function () {
          return this.getProperty("width");
        }, t.prototype.getHeight = function () {
          return this.getProperty("height");
        }, t;
      }(o.Resource);

      t.Canvas = a;
    }, function (e, t, n) {
      "use strict";

      var _i9,
          r = this && this.__extends || (_i9 = function i(e, t) {
        return (_i9 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _i9(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var o = n(1),
          a = n(0),
          s = function (e) {
        function t(t, n) {
          var i = e.call(this, t, n) || this;
          return i.items = [], i._collections = null, i._manifests = null, t.__collection = i, i;
        }

        return r(t, e), t.prototype.getCollections = function () {
          return this._collections ? this._collections : this._collections = this.items.filter(function (e) {
            return e.isCollection();
          });
        }, t.prototype.getManifests = function () {
          return this._manifests ? this._manifests : this._manifests = this.items.filter(function (e) {
            return e.isManifest();
          });
        }, t.prototype.getCollectionByIndex = function (e) {
          for (var t, n = this.getCollections(), i = 0; i < n.length; i++) {
            var r = n[i];
            r.index === e && (t = r);
          }

          if (t) return t.options.index = e, t.load();
          throw new Error("Collection index not found");
        }, t.prototype.getManifestByIndex = function (e) {
          for (var t, n = this.getManifests(), i = 0; i < n.length; i++) {
            var r = n[i];
            r.index === e && (t = r);
          }

          if (t) return t.options.index = e, t.load();
          throw new Error("Manifest index not found");
        }, t.prototype.getTotalCollections = function () {
          return this.getCollections().length;
        }, t.prototype.getTotalManifests = function () {
          return this.getManifests().length;
        }, t.prototype.getTotalItems = function () {
          return this.items.length;
        }, t.prototype.getViewingDirection = function () {
          return this.getProperty("viewingDirection") ? this.getProperty("viewingDirection") : o.ViewingDirection.LEFT_TO_RIGHT;
        }, t.prototype.getDefaultTree = function () {
          return e.prototype.getDefaultTree.call(this), this.defaultTree.data.type = a.Utils.normaliseType(a.TreeNodeType.COLLECTION), this._parseManifests(this), this._parseCollections(this), a.Utils.generateTreeNodeIds(this.defaultTree), this.defaultTree;
        }, t.prototype._parseManifests = function (e) {
          if (e.getManifests() && e.getManifests().length) for (var t = 0; t < e.getManifests().length; t++) {
            var n = e.getManifests()[t],
                i = n.getDefaultTree();
            i.label = n.parentLabel || a.LanguageMap.getValue(n.getLabel(), this.options.locale) || "manifest " + (t + 1), i.navDate = n.getNavDate(), i.data.id = n.id, i.data.type = a.Utils.normaliseType(a.TreeNodeType.MANIFEST), e.defaultTree.addNode(i);
          }
        }, t.prototype._parseCollections = function (e) {
          if (e.getCollections() && e.getCollections().length) for (var t = 0; t < e.getCollections().length; t++) {
            var n = e.getCollections()[t],
                i = n.getDefaultTree();
            i.label = n.parentLabel || a.LanguageMap.getValue(n.getLabel(), this.options.locale) || "collection " + (t + 1), i.navDate = n.getNavDate(), i.data.id = n.id, i.data.type = a.Utils.normaliseType(a.TreeNodeType.COLLECTION), e.defaultTree.addNode(i);
          }
        }, t;
      }(a.IIIFResource);

      t.Collection = s;
    }, function (e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = function () {
        function e(e, t) {
          this.start = e, this.end = t;
        }

        return e.prototype.getLength = function () {
          return this.end - this.start;
        }, e;
      }();

      t.Duration = i;
    }, function (e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(0),
          r = function () {
        function e(e) {
          this.defaultLocale = e;
        }

        return e.prototype.parse = function (e) {
          this.resource = e, this.label = i.LanguageMap.parse(this.resource.label, this.defaultLocale), this.value = i.LanguageMap.parse(this.resource.value, this.defaultLocale);
        }, e.prototype.getLabel = function () {
          return this.label ? i.LanguageMap.getValue(this.label, this.defaultLocale) : null;
        }, e.prototype.setLabel = function (e) {
          var t = this;

          if (this.label && this.label.length) {
            var n = this.label.filter(function (e) {
              return e.locale === t.defaultLocale || e.locale === i.Utils.getInexactLocale(t.defaultLocale);
            })[0];
            n && (n.value = e);
          }
        }, e.prototype.getValue = function () {
          if (this.value) {
            var e = this.defaultLocale;
            return this.label && this.label.length && this.label[0].locale && (e = this.label[0].locale), i.LanguageMap.getValue(this.value, e);
          }

          return null;
        }, e.prototype.setValue = function (e) {
          var t = this;

          if (this.value && this.value.length) {
            var n = this.value.filter(function (e) {
              return e.locale === t.defaultLocale || e.locale === i.Utils.getInexactLocale(t.defaultLocale);
            })[0];
            n && (n.value = e);
          }
        }, e;
      }();

      t.LabelValuePair = r;
    }, function (e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.Language = function (e, t) {
        Array.isArray(e) ? 1 === e.length ? this.value = e[0] : this.value = e.join("<br/>") : this.value = e, this.locale = t;
      };
    }, function (e, t, n) {
      "use strict";

      var _i10,
          r = this && this.__extends || (_i10 = function i(e, t) {
        return (_i10 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _i10(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var o = n(0),
          a = function (e) {
        function t() {
          return null !== e && e.apply(this, arguments) || this;
        }

        return r(t, e), t.parse = function (e, t) {
          var n,
              i = [];
          if (!e) return i;
          if (Array.isArray(e)) for (var r = 0; r < e.length; r++) {
            var a = e[r];
            n = "string" == typeof a ? new o.Language(a, t) : new o.Language(a["@value"], a["@language"] || t), i.push(n);
          } else {
            if ("string" == typeof e) return n = new o.Language(e, t), i.push(n), i;
            e["@value"] ? (n = new o.Language(e["@value"], e["@language"] || t), i.push(n)) : Object.keys(e).forEach(function (t) {
              if (!e[t].length) throw new Error("language must have a value");
              n = new o.Language(e[t], t), i.push(n);
            });
          }
          return i;
        }, t.getValue = function (e, t) {
          if (e.length) {
            if (t) {
              var n = e.filter(function (e) {
                return e.locale === t || o.Utils.getInexactLocale(e.locale) === o.Utils.getInexactLocale(t);
              })[0];
              if (n) return n.value;
            }

            return e[0].value;
          }

          return null;
        }, t;
      }(Array);

      t.LanguageMap = a;
    }, function (e, t, n) {
      "use strict";

      var _i11,
          r = this && this.__extends || (_i11 = function i(e, t) {
        return (_i11 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _i11(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var o = n(1),
          a = n(0),
          s = function (e) {
        function t(t, n) {
          var i = e.call(this, t, n) || this;
          if (i.index = 0, i._allRanges = null, i.items = [], i._topRanges = [], i.__jsonld.structures && i.__jsonld.structures.length) for (var r = i._getTopRanges(), o = 0; o < r.length; o++) {
            var a = r[o];

            i._parseRanges(a, String(o));
          }
          return i;
        }

        return r(t, e), t.prototype.getPosterCanvas = function () {
          var e = this.getProperty("posterCanvas");
          return e && (e = new a.Canvas(e, this.options)), e;
        }, t.prototype.getBehavior = function () {
          var e = this.getProperty("behavior");
          return Array.isArray(e) && (e = e[0]), e || null;
        }, t.prototype.getDefaultTree = function () {
          if (e.prototype.getDefaultTree.call(this), this.defaultTree.data.type = a.Utils.normaliseType(a.TreeNodeType.MANIFEST), !this.isLoaded) return this.defaultTree;
          var t = this.getTopRanges();
          return t.length && t[0].getTree(this.defaultTree), a.Utils.generateTreeNodeIds(this.defaultTree), this.defaultTree;
        }, t.prototype._getTopRanges = function () {
          var e = [];

          if (this.__jsonld.structures && this.__jsonld.structures.length) {
            for (var t = 0; t < this.__jsonld.structures.length; t++) {
              var n = this.__jsonld.structures[t];
              n.viewingHint === o.ViewingHint.TOP && e.push(n);
            }

            if (!e.length) {
              var i = {};
              i.ranges = this.__jsonld.structures, e.push(i);
            }
          }

          return e;
        }, t.prototype.getTopRanges = function () {
          return this._topRanges;
        }, t.prototype._getRangeById = function (e) {
          if (this.__jsonld.structures && this.__jsonld.structures.length) for (var t = 0; t < this.__jsonld.structures.length; t++) {
            var n = this.__jsonld.structures[t];
            if (n["@id"] === e || n.id === e) return n;
          }
          return null;
        }, t.prototype._parseRanges = function (e, t, n) {
          var i,
              r = null;

          if ("string" == typeof e && (r = e, e = this._getRangeById(r)), e) {
            (i = new a.Range(e, this.options)).parentRange = n, i.path = t, n ? n.items.push(i) : this._topRanges.push(i);
            var o = e.items || e.members;
            if (o) for (var s = 0; s < o.length; s++) {
              var c = o[s];
              if (c["@type"] && "sc:range" === c["@type"].toLowerCase() || c.type && "range" === c.type.toLowerCase()) this._parseRanges(c, t + "/" + s, i);else if (c["@type"] && "sc:canvas" === c["@type"].toLowerCase() || c.type && "canvas" === c.type.toLowerCase()) {
                i.canvases || (i.canvases = []);
                var u = c.id || c["@id"];
                i.canvases.push(u);
              }
            } else if (e.ranges) for (s = 0; s < e.ranges.length; s++) this._parseRanges(e.ranges[s], t + "/" + s, i);
          } else console.warn("Range:", r, "does not exist");
        }, t.prototype.getAllRanges = function () {
          if (null != this._allRanges) return this._allRanges;
          this._allRanges = [];

          for (var e = this.getTopRanges(), t = function t(_t) {
            var i = e[_t];
            i.id && n._allRanges.push(i);

            var r = function r(e, t) {
              e.add(t);
              var n = t.getRanges();
              return n.length ? n.reduce(r, e) : e;
            },
                o = Array.from(i.getRanges().reduce(r, new Set()));

            n._allRanges = n._allRanges.concat(o);
          }, n = this, i = 0; i < e.length; i++) t(i);

          return this._allRanges;
        }, t.prototype.getRangeById = function (e) {
          for (var t = this.getAllRanges(), n = 0; n < t.length; n++) {
            var i = t[n];
            if (i.id === e) return i;
          }

          return null;
        }, t.prototype.getRangeByPath = function (e) {
          for (var t = this.getAllRanges(), n = 0; n < t.length; n++) {
            var i = t[n];
            if (i.path === e) return i;
          }

          return null;
        }, t.prototype.getSequences = function () {
          if (this.items.length) return this.items;
          var e = this.__jsonld.mediaSequences || this.__jsonld.sequences;
          if (e) for (var t = 0; t < e.length; t++) {
            var n = e[t],
                i = new a.Sequence(n, this.options);
            this.items.push(i);
          } else this.__jsonld.items && (i = new a.Sequence(this.__jsonld.items, this.options), this.items.push(i));
          return this.items;
        }, t.prototype.getSequenceByIndex = function (e) {
          return this.getSequences()[e];
        }, t.prototype.getTotalSequences = function () {
          return this.getSequences().length;
        }, t.prototype.getManifestType = function () {
          var e = this.getService(o.ServiceProfile.UI_EXTENSIONS);
          return e ? e.getProperty("manifestType") : a.ManifestType.EMPTY;
        }, t.prototype.isMultiSequence = function () {
          return this.getTotalSequences() > 1;
        }, t.prototype.isPagingEnabled = function () {
          var e = this.getViewingHint();
          if (e) return e === o.ViewingHint.PAGED;
          var t = this.getBehavior();
          return !!t && t === o.Behavior.PAGED;
        }, t.prototype.getViewingDirection = function () {
          return this.getProperty("viewingDirection");
        }, t.prototype.getViewingHint = function () {
          return this.getProperty("viewingHint");
        }, t;
      }(a.IIIFResource);

      t.Manifest = s;
    }, function (e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), function (e) {
        e.EMPTY = "", e.MANUSCRIPT = "manuscript", e.MONOGRAPH = "monograph";
      }(t.ManifestType || (t.ManifestType = {}));
    }, function (e, t, n) {
      "use strict";

      var _i12,
          r = this && this.__extends || (_i12 = function i(e, t) {
        return (_i12 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _i12(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var o = n(0),
          a = n(1),
          s = function (e) {
        function t(t, n) {
          var i = e.call(this, t, n) || this;
          return i._ranges = null, i.canvases = null, i.items = [], i;
        }

        return r(t, e), t.prototype.getCanvasIds = function () {
          return this.__jsonld.canvases ? this.__jsonld.canvases : this.canvases ? this.canvases : [];
        }, t.prototype.getDuration = function () {
          var e, t;
          if (this.canvases && this.canvases.length) for (var n = 0; n < this.canvases.length; n++) {
            var i = this.canvases[n],
                r = o.Utils.getTemporalComponent(i);
            r && r.length > 1 && (0 === n && (e = Number(r[0])), n === this.canvases.length - 1 && (t = Number(r[1])));
          } else {
            var a = this.getRanges();

            for (n = 0; n < a.length; n++) {
              var s = a[n].getDuration();
              s && (0 === n && (e = s.start), n === a.length - 1 && (t = s.end));
            }
          }
          if (void 0 !== e && void 0 !== t) return new o.Duration(e, t);
        }, t.prototype.getRanges = function () {
          return this._ranges ? this._ranges : this._ranges = this.items.filter(function (e) {
            return e.isRange();
          });
        }, t.prototype.getBehavior = function () {
          var e = this.getProperty("behavior");
          return Array.isArray(e) && (e = e[0]), e || null;
        }, t.prototype.getViewingDirection = function () {
          return this.getProperty("viewingDirection");
        }, t.prototype.getViewingHint = function () {
          return this.getProperty("viewingHint");
        }, t.prototype.getTree = function (e) {
          e.data = this, this.treeNode = e;
          var t = this.getRanges();
          if (t && t.length) for (var n = 0; n < t.length; n++) {
            var i = t[n],
                r = new o.TreeNode();
            e.addNode(r), this._parseTreeNode(r, i);
          }
          return o.Utils.generateTreeNodeIds(e), e;
        }, t.prototype.spansTime = function (e) {
          var t = this.getDuration();
          return !!(t && e >= t.start && e <= t.end);
        }, t.prototype._parseTreeNode = function (e, t) {
          e.label = o.LanguageMap.getValue(t.getLabel(), this.options.locale), e.data = t, e.data.type = o.Utils.normaliseType(o.TreeNodeType.RANGE), t.treeNode = e;
          var n = t.getRanges();
          if (n && n.length) for (var i = 0; i < n.length; i++) {
            var r = n[i];

            if (r.getBehavior() !== a.Behavior.NO_NAV) {
              var s = new o.TreeNode();
              e.addNode(s), this._parseTreeNode(s, r);
            }
          }
        }, t;
      }(o.ManifestResource);

      t.Range = s;
    }, function (e, t, n) {
      "use strict";

      var _i13,
          r = this && this.__extends || (_i13 = function i(e, t) {
        return (_i13 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _i13(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var o = function (e) {
        function t(t, n) {
          return e.call(this, t, n) || this;
        }

        return r(t, e), t.prototype.getFormat = function () {
          return this.getProperty("format");
        }, t;
      }(n(0).ManifestResource);

      t.Rendering = o;
    }, function (e, t, n) {
      "use strict";

      var _i14,
          r = this && this.__extends || (_i14 = function i(e, t) {
        return (_i14 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _i14(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var o = n(1),
          a = n(0),
          s = function (e) {
        function t(t, n) {
          var i = e.call(this, t, n) || this;
          return i.items = [], i._thumbnails = null, i;
        }

        return r(t, e), t.prototype.getCanvases = function () {
          if (this.items.length) return this.items;
          var e = this.__jsonld.canvases || this.__jsonld.elements;
          if (e) for (var t = 0; t < e.length; t++) {
            var n = e[t];
            (i = new a.Canvas(n, this.options)).index = t, this.items.push(i);
          } else if (this.__jsonld) for (t = 0; t < this.__jsonld.length; t++) {
            var i;
            n = this.__jsonld[t], (i = new a.Canvas(n, this.options)).index = t, this.items.push(i);
          }
          return this.items;
        }, t.prototype.getCanvasById = function (e) {
          for (var t = 0; t < this.getTotalCanvases(); t++) {
            var n = this.getCanvasByIndex(t),
                i = a.Utils.normaliseUrl(n.id);
            if (a.Utils.normaliseUrl(e) === i) return n;
          }

          return null;
        }, t.prototype.getCanvasByIndex = function (e) {
          return this.getCanvases()[e];
        }, t.prototype.getCanvasIndexById = function (e) {
          for (var t = 0; t < this.getTotalCanvases(); t++) if (this.getCanvasByIndex(t).id === e) return t;

          return null;
        }, t.prototype.getCanvasIndexByLabel = function (e, t) {
          e = e.trim(), isNaN(e) || (e = parseInt(e, 10).toString(), t && (e += "r"));

          for (var n, i, r, o = /(\d*)\D+(\d*)/, s = 0; s < this.getTotalCanvases(); s++) {
            var c = this.getCanvasByIndex(s);
            if (a.LanguageMap.getValue(c.getLabel(), this.options.locale) === e) return s;
            if ((n = o.exec(e)) && (i = n[1], (r = n[2]) && new RegExp("^" + i + "\\D+" + r + "$").test(c.getLabel().toString()))) return s;
          }

          return -1;
        }, t.prototype.getLastCanvasLabel = function (e) {
          for (var t = this.getTotalCanvases() - 1; t >= 0; t--) {
            var n = this.getCanvasByIndex(t),
                i = a.LanguageMap.getValue(n.getLabel(), this.options.locale);

            if (e) {
              if (/^[a-zA-Z0-9]*$/.test(i)) return i;
            } else if (i) return i;
          }

          return this.options.defaultLabel;
        }, t.prototype.getLastPageIndex = function () {
          return this.getTotalCanvases() - 1;
        }, t.prototype.getNextPageIndex = function (e, t) {
          var n;

          if (t) {
            var i = this.getPagedIndices(e),
                r = this.getViewingDirection();
            n = r && r === o.ViewingDirection.RIGHT_TO_LEFT ? i[0] + 1 : i[i.length - 1] + 1;
          } else n = e + 1;

          return n > this.getLastPageIndex() ? -1 : n;
        }, t.prototype.getPagedIndices = function (e, t) {
          var n = [];

          if (t) {
            n = this.isFirstCanvas(e) || this.isLastCanvas(e) ? [e] : e % 2 ? [e, e + 1] : [e - 1, e];
            var i = this.getViewingDirection();
            i && i === o.ViewingDirection.RIGHT_TO_LEFT && (n = n.reverse());
          } else n.push(e);

          return n;
        }, t.prototype.getPrevPageIndex = function (e, t) {
          var n;

          if (t) {
            var i = this.getPagedIndices(e),
                r = this.getViewingDirection();
            n = r && r === o.ViewingDirection.RIGHT_TO_LEFT ? i[i.length - 1] - 1 : i[0] - 1;
          } else n = e - 1;

          return n;
        }, t.prototype.getStartCanvasIndex = function () {
          var e = this.getStartCanvas();
          if (e) for (var t = 0; t < this.getTotalCanvases(); t++) if (this.getCanvasByIndex(t).id === e) return t;
          return 0;
        }, t.prototype.getThumbs = function (e, t) {
          for (var n = [], i = this.getTotalCanvases(), r = 0; r < i; r++) {
            var o = this.getCanvasByIndex(r),
                s = new a.Thumb(e, o);
            n.push(s);
          }

          return n;
        }, t.prototype.getThumbnails = function () {
          if (null != this._thumbnails) return this._thumbnails;
          this._thumbnails = [];

          for (var e = this.getCanvases(), t = 0; t < e.length; t++) {
            var n = e[t].getThumbnail();
            n && this._thumbnails.push(n);
          }

          return this._thumbnails;
        }, t.prototype.getStartCanvas = function () {
          return this.getProperty("startCanvas");
        }, t.prototype.getTotalCanvases = function () {
          return this.getCanvases().length;
        }, t.prototype.getViewingDirection = function () {
          return this.getProperty("viewingDirection") ? this.getProperty("viewingDirection") : this.options.resource.getViewingDirection ? this.options.resource.getViewingDirection() : null;
        }, t.prototype.getViewingHint = function () {
          return this.getProperty("viewingHint");
        }, t.prototype.isCanvasIndexOutOfRange = function (e) {
          return e > this.getTotalCanvases() - 1;
        }, t.prototype.isFirstCanvas = function (e) {
          return 0 === e;
        }, t.prototype.isLastCanvas = function (e) {
          return e === this.getTotalCanvases() - 1;
        }, t.prototype.isMultiCanvas = function () {
          return this.getTotalCanvases() > 1;
        }, t.prototype.isPagingEnabled = function () {
          var e = this.getViewingHint();
          return !!e && e === o.ViewingHint.PAGED;
        }, t.prototype.isTotalCanvasesEven = function () {
          return this.getTotalCanvases() % 2 == 0;
        }, t;
      }(a.ManifestResource);

      t.Sequence = s;
    }, function (e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(0),
          r = function () {
        function e() {}

        return e.parse = function (e, t) {
          return "string" == typeof e && (e = JSON.parse(e)), this.parseJson(e, t);
        }, e.parseJson = function (e, t) {
          var n;
          if (t && t.navDate && !isNaN(t.navDate.getTime()) && (e.navDate = t.navDate.toString()), e["@type"]) switch (e["@type"]) {
            case "sc:Collection":
              n = this.parseCollection(e, t);
              break;

            case "sc:Manifest":
              n = this.parseManifest(e, t);
              break;

            default:
              return null;
          } else switch (e.type) {
            case "Collection":
              n = this.parseCollection(e, t);
              break;

            case "Manifest":
              n = this.parseManifest(e, t);
              break;

            default:
              return null;
          }
          return n.isLoaded = !0, n;
        }, e.parseCollection = function (e, t) {
          var n = new i.Collection(e, t);
          return t ? (n.index = t.index || 0, t.resource && (n.parentCollection = t.resource.parentCollection)) : n.index = 0, this.parseCollections(n, t), this.parseManifests(n, t), this.parseItems(n, t), n;
        }, e.parseCollections = function (e, t) {
          var n;
          if (e.__jsonld.collections ? n = e.__jsonld.collections : e.__jsonld.items && (n = e.__jsonld.items.filter(function (e) {
            return "collection" === e.type.toLowerCase();
          })), n) for (var i = 0; i < n.length; i++) {
            t && (t.index = i);
            var r = this.parseCollection(n[i], t);
            r.index = i, r.parentCollection = e, e.items.push(r);
          }
        }, e.parseManifest = function (e, t) {
          return new i.Manifest(e, t);
        }, e.parseManifests = function (e, t) {
          var n;
          if (e.__jsonld.manifests ? n = e.__jsonld.manifests : e.__jsonld.items && (n = e.__jsonld.items.filter(function (e) {
            return "manifest" === e.type.toLowerCase();
          })), n) for (var i = 0; i < n.length; i++) {
            var r = this.parseManifest(n[i], t);
            r.index = i, r.parentCollection = e, e.items.push(r);
          }
        }, e.parseItem = function (e, t) {
          if (e["@type"]) {
            if ("sc:manifest" === e["@type"].toLowerCase()) return this.parseManifest(e, t);
            if ("sc:collection" === e["@type"].toLowerCase()) return this.parseCollection(e, t);
          } else if (e.type) {
            if ("manifest" === e.type.toLowerCase()) return this.parseManifest(e, t);
            if ("collection" === e.type.toLowerCase()) return this.parseCollection(e, t);
          }

          return null;
        }, e.parseItems = function (e, t) {
          var n = e.__jsonld.members || e.__jsonld.items;
          if (n) for (var i = function i(_i15) {
            t && (t.index = _i15);
            var o = r.parseItem(n[_i15], t);
            return o ? e.items.filter(function (e) {
              return e.id === o.id;
            })[0] ? "continue" : (o.index = _i15, o.parentCollection = e, void e.items.push(o)) : {
              value: void 0
            };
          }, r = this, o = 0; o < n.length; o++) {
            var a = i(o);
            if ("object" == typeof a) return a.value;
          }
        }, e;
      }();

      t.Deserialiser = r;
    }, function (e, t, n) {
      "use strict";

      var _i16,
          r = this && this.__extends || (_i16 = function i(e, t) {
        return (_i16 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _i16(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var o = n(0),
          a = function (e) {
        function t(t, n) {
          return e.call(this, t, n) || this;
        }

        return r(t, e), t.prototype.getProfile = function () {
          var e = this.getProperty("profile");
          return e || (e = this.getProperty("dcterms:conformsTo")), Array.isArray(e) ? e[0] : e;
        }, t.prototype.getConfirmLabel = function () {
          return o.Utils.getLocalisedValue(this.getProperty("confirmLabel"), this.options.locale);
        }, t.prototype.getDescription = function () {
          return o.Utils.getLocalisedValue(this.getProperty("description"), this.options.locale);
        }, t.prototype.getFailureDescription = function () {
          return o.Utils.getLocalisedValue(this.getProperty("failureDescription"), this.options.locale);
        }, t.prototype.getFailureHeader = function () {
          return o.Utils.getLocalisedValue(this.getProperty("failureHeader"), this.options.locale);
        }, t.prototype.getHeader = function () {
          return o.Utils.getLocalisedValue(this.getProperty("header"), this.options.locale);
        }, t.prototype.getServiceLabel = function () {
          return o.Utils.getLocalisedValue(this.getProperty("label"), this.options.locale);
        }, t.prototype.getInfoUri = function () {
          var e = this.id;
          return e.endsWith("/") || (e += "/"), e + "info.json";
        }, t;
      }(o.ManifestResource);

      t.Service = a;
    }, function (e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.Size = function (e, t) {
        this.width = e, this.height = t;
      };
    }, function (e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), function (e) {
        e[e.AUTHORIZATION_FAILED = 1] = "AUTHORIZATION_FAILED", e[e.FORBIDDEN = 2] = "FORBIDDEN", e[e.INTERNAL_SERVER_ERROR = 3] = "INTERNAL_SERVER_ERROR", e[e.RESTRICTED = 4] = "RESTRICTED";
      }(t.StatusCode || (t.StatusCode = {}));
    }, function (e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });
      var i = n(0);

      t.Thumb = function (e, t) {
        this.data = t, this.index = t.index, this.width = e;
        var n = t.getHeight() / t.getWidth();
        this.height = n ? Math.floor(this.width * n) : e, this.uri = t.getCanonicalImageUri(e), this.label = i.LanguageMap.getValue(t.getLabel());
      };
    }, function (e, t, n) {
      "use strict";

      var _i17,
          r = this && this.__extends || (_i17 = function i(e, t) {
        return (_i17 = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        })(e, t);
      }, function (e, t) {
        function n() {
          this.constructor = e;
        }

        _i17(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
      });

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var o = function (e) {
        function t(t, n) {
          return e.call(this, t, n) || this;
        }

        return r(t, e), t;
      }(n(0).Resource);

      t.Thumbnail = o;
    }, function (e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      });

      var i = n(0),
          r = function () {
        function e(e, t) {
          this.label = e, this.data = t || {}, this.nodes = [];
        }

        return e.prototype.addNode = function (e) {
          this.nodes.push(e), e.parentNode = this;
        }, e.prototype.isCollection = function () {
          return this.data.type === i.Utils.normaliseType(i.TreeNodeType.COLLECTION);
        }, e.prototype.isManifest = function () {
          return this.data.type === i.Utils.normaliseType(i.TreeNodeType.MANIFEST);
        }, e.prototype.isRange = function () {
          return this.data.type === i.Utils.normaliseType(i.TreeNodeType.RANGE);
        }, e;
      }();

      t.TreeNode = r;
    }, function (e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), function (e) {
        e.COLLECTION = "collection", e.MANIFEST = "manifest", e.RANGE = "range";
      }(t.TreeNodeType || (t.TreeNodeType = {}));
    }, function (e, t, n) {
      window, e.exports = function (e) {
        var t = {};

        function n(i) {
          if (t[i]) return t[i].exports;
          var r = t[i] = {
            i: i,
            l: !1,
            exports: {}
          };
          return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
        }

        return n.m = e, n.c = t, n.d = function (e, t, i) {
          n.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: i
          });
        }, n.r = function (e) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(e, "__esModule", {
            value: !0
          });
        }, n.t = function (e, t) {
          if (1 & t && (e = n(e)), 8 & t) return e;
          if (4 & t && "object" == typeof e && e && e.__esModule) return e;
          var i = Object.create(null);
          if (n.r(i), Object.defineProperty(i, "default", {
            enumerable: !0,
            value: e
          }), 2 & t && "string" != typeof e) for (var r in e) n.d(i, r, function (t) {
            return e[t];
          }.bind(null, r));
          return i;
        }, n.n = function (e) {
          var t = e && e.__esModule ? function () {
            return e.default;
          } : function () {
            return e;
          };
          return n.d(t, "a", t), t;
        }, n.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = 0);
      }([function (e, t, n) {
        e.exports = n(1);
      }, function (e, t, n) {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.CONTINUE = 100, t.SWITCHING_PROTOCOLS = 101, t.PROCESSING = 102, t.OK = 200, t.CREATED = 201, t.ACCEPTED = 202, t.NON_AUTHORITATIVE_INFORMATION = 203, t.NO_CONTENT = 204, t.RESET_CONTENT = 205, t.PARTIAL_CONTENT = 206, t.MULTI_STATUS = 207, t.MULTIPLE_CHOICES = 300, t.MOVED_PERMANENTLY = 301, t.MOVED_TEMPORARILY = 302, t.SEE_OTHER = 303, t.NOT_MODIFIED = 304, t.USE_PROXY = 305, t.TEMPORARY_REDIRECT = 307, t.BAD_REQUEST = 400, t.UNAUTHORIZED = 401, t.PAYMENT_REQUIRED = 402, t.FORBIDDEN = 403, t.NOT_FOUND = 404, t.METHOD_NOT_ALLOWED = 405, t.NOT_ACCEPTABLE = 406, t.PROXY_AUTHENTICATION_REQUIRED = 407, t.REQUEST_TIME_OUT = 408, t.CONFLICT = 409, t.GONE = 410, t.LENGTH_REQUIRED = 411, t.PRECONDITION_FAILED = 412, t.REQUEST_ENTITY_TOO_LARGE = 413, t.REQUEST_URI_TOO_LARGE = 414, t.UNSUPPORTED_MEDIA_TYPE = 415, t.REQUESTED_RANGE_NOT_SATISFIABLE = 416, t.EXPECTATION_FAILED = 417, t.IM_A_TEAPOT = 418, t.UNPROCESSABLE_ENTITY = 422, t.LOCKED = 423, t.FAILED_DEPENDENCY = 424, t.UNORDERED_COLLECTION = 425, t.UPGRADE_REQUIRED = 426, t.PRECONDITION_REQUIRED = 428, t.TOO_MANY_REQUESTS = 429, t.REQUEST_HEADER_FIELDS_TOO_LARGE = 431, t.INTERNAL_SERVER_ERROR = 500, t.NOT_IMPLEMENTED = 501, t.BAD_GATEWAY = 502, t.SERVICE_UNAVAILABLE = 503, t.GATEWAY_TIME_OUT = 504, t.HTTP_VERSION_NOT_SUPPORTED = 505, t.VARIANT_ALSO_NEGOTIATES = 506, t.INSUFFICIENT_STORAGE = 507, t.BANDWIDTH_LIMIT_EXCEEDED = 509, t.NOT_EXTENDED = 510, t.NETWORK_AUTHENTICATION_REQUIRED = 511;
      }]);
    }, function (e, t, n) {
      e.exports = window.fetch || (window.fetch = n(3).default || n(3));
    }]);
  }, function (e, t, n) {
    window, e.exports = function (e) {
      var t = {};

      function n(i) {
        if (t[i]) return t[i].exports;
        var r = t[i] = {
          i: i,
          l: !1,
          exports: {}
        };
        return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
      }

      return n.m = e, n.c = t, n.d = function (e, t, i) {
        n.o(e, t) || Object.defineProperty(e, t, {
          enumerable: !0,
          get: i
        });
      }, n.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }, n.t = function (e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var i = Object.create(null);
        if (n.r(i), Object.defineProperty(i, "default", {
          enumerable: !0,
          value: e
        }), 2 & t && "string" != typeof e) for (var r in e) n.d(i, r, function (t) {
          return e[t];
        }.bind(null, r));
        return i;
      }, n.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return n.d(t, "a", t), t;
      }, n.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, n.p = "", n(n.s = 0);
    }([function (e, t, n) {
      e.exports = n(1);
    }, function (e, t, n) {
      "use strict";

      Object.defineProperty(t, "__esModule", {
        value: !0
      }), t.CONTINUE = 100, t.SWITCHING_PROTOCOLS = 101, t.PROCESSING = 102, t.OK = 200, t.CREATED = 201, t.ACCEPTED = 202, t.NON_AUTHORITATIVE_INFORMATION = 203, t.NO_CONTENT = 204, t.RESET_CONTENT = 205, t.PARTIAL_CONTENT = 206, t.MULTI_STATUS = 207, t.MULTIPLE_CHOICES = 300, t.MOVED_PERMANENTLY = 301, t.MOVED_TEMPORARILY = 302, t.SEE_OTHER = 303, t.NOT_MODIFIED = 304, t.USE_PROXY = 305, t.TEMPORARY_REDIRECT = 307, t.BAD_REQUEST = 400, t.UNAUTHORIZED = 401, t.PAYMENT_REQUIRED = 402, t.FORBIDDEN = 403, t.NOT_FOUND = 404, t.METHOD_NOT_ALLOWED = 405, t.NOT_ACCEPTABLE = 406, t.PROXY_AUTHENTICATION_REQUIRED = 407, t.REQUEST_TIME_OUT = 408, t.CONFLICT = 409, t.GONE = 410, t.LENGTH_REQUIRED = 411, t.PRECONDITION_FAILED = 412, t.REQUEST_ENTITY_TOO_LARGE = 413, t.REQUEST_URI_TOO_LARGE = 414, t.UNSUPPORTED_MEDIA_TYPE = 415, t.REQUESTED_RANGE_NOT_SATISFIABLE = 416, t.EXPECTATION_FAILED = 417, t.IM_A_TEAPOT = 418, t.UNPROCESSABLE_ENTITY = 422, t.LOCKED = 423, t.FAILED_DEPENDENCY = 424, t.UNORDERED_COLLECTION = 425, t.UPGRADE_REQUIRED = 426, t.PRECONDITION_REQUIRED = 428, t.TOO_MANY_REQUESTS = 429, t.REQUEST_HEADER_FIELDS_TOO_LARGE = 431, t.INTERNAL_SERVER_ERROR = 500, t.NOT_IMPLEMENTED = 501, t.BAD_GATEWAY = 502, t.SERVICE_UNAVAILABLE = 503, t.GATEWAY_TIME_OUT = 504, t.HTTP_VERSION_NOT_SUPPORTED = 505, t.VARIANT_ALSO_NEGOTIATES = 506, t.INSUFFICIENT_STORAGE = 507, t.BANDWIDTH_LIMIT_EXCEEDED = 509, t.NOT_EXTENDED = 510, t.NETWORK_AUTHENTICATION_REQUIRED = 511;
    }]);
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return r;
    }), n.d(t, "b", function () {
      return o;
    }), n.d(t, "c", function () {
      return a;
    }), n.d(t, "e", function () {
      return s;
    }), n.d(t, "f", function () {
      return c;
    }), n.d(t, "g", function () {
      return u;
    }), n.d(t, "h", function () {
      return l;
    }), n.d(t, "k", function () {
      return f;
    }), n.d(t, "d", function () {
      return p;
    }), n.d(t, "i", function () {
      return h;
    }), n.d(t, "j", function () {
      return d;
    }), n.d(t, "l", function () {
      return g;
    }), n.d(t, "m", function () {
      return i;
    }), n.d(t, "n", function () {
      return _;
    }), n.d(t, "o", function () {
      return E;
    });

    var i,
        r = function () {
      function e() {}

      return e.waitFor = function (t, n, i, r, o, a) {
        r || (r = 200), o || (o = 100), a || (a = 0), (a += 1) > o ? i && i() : t() ? n() : setTimeout(function () {
          e.waitFor(t, n, i, r, o, a);
        }, r);
      }, e;
    }(),
        o = function () {
      function e() {}

      return e.getBool = function (e, t) {
        return null == e ? t : e;
      }, e;
    }(),
        a = (function () {
      function e() {}

      e.supportsCopy = function () {
        return document.queryCommandSupported && document.queryCommandSupported("copy");
      }, e.copy = function (t) {
        t = e.convertBrToNewLine(t);
        var n = document.createElement("textarea");
        n.value = t, e.hideButKeepEnabled(n), document.body.appendChild(n), n.focus(), n.select(), document.execCommand("copy"), document.body.removeChild(n);
      }, e.hideButKeepEnabled = function (e) {
        e.style.position = "fixed", e.style.top = "0", e.style.left = "0", e.style.width = "2em", e.style.height = "2em", e.style.padding = "0", e.style.border = "none", e.style.outline = "none", e.style.boxShadow = "none", e.style.background = "transparent";
      }, e.convertBrToNewLine = function (e) {
        return e = e.replace(/<br\s*[\/]?>/gi, "\n");
      };
    }(), function () {
      function e() {}

      e.float32ColorToARGB = function (e) {
        return [(4278190080 & e) >>> 24, (16711680 & e) >>> 16, (65280 & e) >>> 8, 255 & e];
      }, e._componentToHex = function (e) {
        var t = e.toString(16);
        return 1 == t.length ? "0" + t : t;
      }, e.rgbToHexString = function (t) {
        return e.coalesce(t), "#" + e._componentToHex(t[0]) + e._componentToHex(t[1]) + e._componentToHex(t[2]);
      }, e.argbToHexString = function (t) {
        return "#" + e._componentToHex(t[0]) + e._componentToHex(t[1]) + e._componentToHex(t[2]) + e._componentToHex(t[3]);
      }, e.coalesce = function (e) {
        for (var t = 1; t < e.length; t++) void 0 === e[t] && (e[t] = e[t - 1]);
      };
    }(), function () {
      function e() {}

      return e.getTimeStamp = function () {
        return new Date().getTime();
      }, e;
    }()),
        s = (function () {
      function e() {}

      e.getPixelRatio = function (e) {
        return (window.devicePixelRatio || 1) / (e.webkitBackingStorePixelRatio || e.mozBackingStorePixelRatio || e.msBackingStorePixelRatio || e.oBackingStorePixelRatio || e.backingStorePixelRatio || 1);
      }, e.isTouch = function () {
        return !!("ontouchstart" in window) || window.navigator.msMaxTouchPoints > 0;
      };
    }(), function () {
      function e() {}

      return e.isInIFrame = function () {
        try {
          return window.self !== window.top;
        } catch (e) {
          return !0;
        }
      }, e.supportsFullscreen = function () {
        var e = document.documentElement;
        return void 0 !== (e.requestFullscreen || e.mozRequestFullScreen || e.webkitRequestFullScreen || e.msRequestFullscreen);
      }, e.isHidden = function () {
        return !!e.getHiddenProp();
      }, e.getHiddenProp = function () {
        var e = ["webkit", "moz", "ms", "o"];
        if ("hidden" in document) return "hidden";

        for (var t = 0; t < e.length; t++) if (e[t] + "Hidden" in document) return e[t] + "Hidden";

        return null;
      }, e;
    }()),
        c = (function () {
      function e() {}

      e.debounce = function (e, t) {
        return t = t || 100, function () {
          if (!e.debouncing) {
            var n = Array.prototype.slice.apply(arguments);
            e.lastReturnVal = e.apply(window, n), e.debouncing = !0;
          }

          return clearTimeout(e.debounceTimeout), e.debounceTimeout = setTimeout(function () {
            e.debouncing = !1;
          }, t), e.lastReturnVal;
        };
      };
    }(), function () {
      function e() {}

      return e.simplifyMimeType = function (e) {
        switch (e) {
          case "text/plain":
            return "txt";

          case "image/jpeg":
            return "jpg";

          case "application/msword":
            return "doc";

          case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
            return "docx";

          default:
            var t = e.split("/");
            return t[t.length - 1];
        }
      }, e;
    }()),
        u = function () {
      function e() {}

      return e.getCharCode = function (e) {
        return "number" == typeof e.which ? e.which : e.keyCode;
      }, e;
    }(),
        l = function () {
      function e() {}

      return e.normalise = function (e, t, n) {
        return (e - t) / (n - t);
      }, e.median = function (e) {
        e.sort(function (e, t) {
          return e - t;
        });
        var t = Math.floor(e.length / 2);
        return e.length % 2 ? e[t] : (e[t - 1] + e[t]) / 2;
      }, e.clamp = function (e, t, n) {
        return Math.min(Math.max(e, t), n);
      }, e;
    }(),
        f = function f(e, t) {
      this.width = e, this.height = t;
    },
        p = function () {
      function e() {}

      return e.fitRect = function (e, t, n, i) {
        var r,
            o = 0,
            a = 0;
        return t / e < i / n ? (o = e * (r = n / e), a = t * r) : (o = e * (r = i / t), a = t * r), new f(Math.floor(o), Math.floor(a));
      }, e.hitRect = function (e, t, n, i, r, o) {
        return r > e && r < e + n && o > t && o < t + i;
      }, e;
    }(),
        h = function () {
      function e() {}

      return e.numericalInput = function (e) {
        return 46 == e.keyCode || 8 == e.keyCode || 9 == e.keyCode || 27 == e.keyCode || 65 == e.keyCode && !0 === e.ctrlKey || e.keyCode >= 35 && e.keyCode <= 39 || !(e.shiftKey || (e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) || (e.preventDefault(), !1);
      }, e;
    }(),
        d = function () {
      function e() {}

      return e.toPlainObject = function (e) {
        e = Object(e);
        var t = {};

        for (var n in e) t[n] = e[n];

        return t;
      }, e;
    }(),
        g = function () {
      function e() {}

      return e.clear = function (e) {
        switch (void 0 === e && (e = i.MEMORY), e) {
          case i.MEMORY:
            this._memoryStorage = {};
            break;

          case i.SESSION:
            sessionStorage.clear();
            break;

          case i.LOCAL:
            localStorage.clear();
        }
      }, e.clearExpired = function (e) {
        void 0 === e && (e = i.MEMORY);

        for (var t = this.getItems(e), n = 0; n < t.length; n++) {
          var r = t[n];
          this._isExpired(r) && this.remove(r.key);
        }
      }, e.get = function (e, t) {
        void 0 === t && (t = i.MEMORY);
        var n = null;

        switch (t) {
          case i.MEMORY:
            n = this._memoryStorage[e];
            break;

          case i.SESSION:
            n = sessionStorage.getItem(e);
            break;

          case i.LOCAL:
            n = localStorage.getItem(e);
        }

        if (!n) return null;
        var r = null;

        try {
          r = JSON.parse(n);
        } catch (e) {
          return null;
        }

        return r ? this._isExpired(r) ? null : (r.key = e, r) : null;
      }, e._isExpired = function (e) {
        return !(new Date().getTime() < e.expiresAt);
      }, e.getItems = function (e) {
        void 0 === e && (e = i.MEMORY);
        var t = [];

        switch (e) {
          case i.MEMORY:
            for (var n = Object.keys(this._memoryStorage), r = 0; r < n.length; r++) {
              (a = this.get(n[r], i.MEMORY)) && t.push(a);
            }

            break;

          case i.SESSION:
            for (r = 0; r < sessionStorage.length; r++) {
              if (o = sessionStorage.key(r)) (a = this.get(o, i.SESSION)) && t.push(a);
            }

            break;

          case i.LOCAL:
            for (r = 0; r < localStorage.length; r++) {
              var o, a;
              if (o = localStorage.key(r)) (a = this.get(o, i.LOCAL)) && t.push(a);
            }

        }

        return t;
      }, e.remove = function (e, t) {
        switch (void 0 === t && (t = i.MEMORY), t) {
          case i.MEMORY:
            delete this._memoryStorage[e];
            break;

          case i.SESSION:
            sessionStorage.removeItem(e);
            break;

          case i.LOCAL:
            localStorage.removeItem(e);
        }
      }, e.set = function (e, t, n, r) {
        void 0 === r && (r = i.MEMORY);
        var o = 1e3 * n,
            a = new v();

        switch (a.value = t, a.expiresAt = new Date().getTime() + o, r) {
          case i.MEMORY:
            this._memoryStorage[e] = JSON.stringify(a);
            break;

          case i.SESSION:
            sessionStorage.setItem(e, JSON.stringify(a));
            break;

          case i.LOCAL:
            localStorage.setItem(e, JSON.stringify(a));
        }

        return a;
      }, e._memoryStorage = {}, e;
    }(),
        v = function v() {};

    !function (e) {
      e.MEMORY = "memory", e.SESSION = "session", e.LOCAL = "local";
    }(i || (i = {}));

    var _ = function () {
      function e() {}

      return e.ellipsis = function (e, t) {
        if (e.length <= t) return e;
        var n = e.substr(0, t),
            i = n.lastIndexOf(" ");
        return -1 != i && (n = n.substr(0, Math.min(n.length, i))), n + "&hellip;";
      }, e.htmlDecode = function (e) {
        var t = document.createElement("div");
        return t.innerHTML = e, t.firstChild.nodeValue;
      }, e.format = function (e) {
        for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];

        for (var i = 0; i < t.length; i++) {
          var r = new RegExp("\\{" + i + "\\}", "gm");
          e = e.replace(r, t[i]);
        }

        return e;
      }, e.isAlphanumeric = function (e) {
        return /^[a-zA-Z0-9]*$/.test(e);
      }, e.toCssClass = function (e) {
        return e.replace(/[^a-z0-9]/g, function (e) {
          var t = e.charCodeAt(0);
          return 32 == t ? "-" : t >= 65 && t <= 90 ? "_" + e.toLowerCase() : "__" + ("000" + t.toString(16)).slice(-4);
        });
      }, e.toFileName = function (e) {
        return e.replace(/[^a-z0-9]/gi, "_").toLowerCase();
      }, e.utf8_to_b64 = function (e) {
        return window.btoa(unescape(encodeURIComponent(e)));
      }, e;
    }(),
        E = function () {
      function e() {}

      return e.getHashParameter = function (e, t) {
        return t || (t = window.document), t && t.location ? this.getHashParameterFromString(e, t.location.hash) : null;
      }, e.getHashParameterFromString = function (e, t) {
        var n = new RegExp("#.*[?&]" + e + "=([^&]+)(&|$)").exec(t);
        return n ? decodeURIComponent(n[1].replace(/\+/g, " ")) : null;
      }, e.setHashParameter = function (e, t, n) {
        if (n || (n = window.document), n && n.location) {
          var i = "#?" + this.updateURIKeyValuePair(n.location.hash.replace("#?", ""), e, t),
              r = n.URL;
          -1 != r.indexOf("#") && (r = r.substr(0, r.indexOf("#"))), n.location.replace(r + i);
        }
      }, e.getQuerystringParameter = function (e, t) {
        return t || (t = window), this.getQuerystringParameterFromString(e, t.location.search);
      }, e.getQuerystringParameterFromString = function (e, t) {
        e = e.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var n = new RegExp("[\\?&]" + e + "=([^&#]*)").exec(t);
        return n ? decodeURIComponent(n[1].replace(/\+/g, " ")) : null;
      }, e.setQuerystringParameter = function (e, t, n) {
        if (n || (n = window.document), n && n.location) {
          var i = this.updateURIKeyValuePair(n.location.hash.replace("#?", ""), e, t);
          window.location.search = i;
        }
      }, e.updateURIKeyValuePair = function (e, t, n) {
        t = encodeURIComponent(t), n = encodeURIComponent(n);
        var i = e.split("&");
        "" == i[0] && i.shift();

        for (var r, o = i.length; o--;) if ((r = i[o].split("="))[0] == t) {
          r[1] = n, i[o] = r.join("=");
          break;
        }

        return o < 0 && (i[i.length] = [t, n].join("=")), i.join("&");
      }, e.getUrlParts = function (e) {
        var t = document.createElement("a");
        return t.href = e, t;
      }, e.convertToRelativeUrl = function (e) {
        var t = this.getUrlParts(e),
            n = t.pathname + t.searchWithin;
        return n.startsWith("/") || (n = "/" + n), n;
      }, e;
    }();
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return i;
    });

    var i = function () {
      function e() {}

      return e.ACCEPT_TERMS = "acceptTerms", e.ANNOTATION_CANVAS_CHANGED = "annotationCanvasChanged", e.ANNOTATION_CHANGED = "annotationChanged", e.ANNOTATIONS_CLEARED = "annotationsCleared", e.ANNOTATIONS_EMPTY = "annotationsEmpty", e.ANNOTATIONS = "annotations", e.BOOKMARK = "bookmark", e.CANVAS_INDEX_CHANGE_FAILED = "canvasIndexChangeFailed", e.CANVAS_INDEX_CHANGED = "canvasIndexChanged", e.CLEAR_ANNOTATIONS = "clearAnnotations", e.CLICKTHROUGH = "clickthrough", e.CLOSE_ACTIVE_DIALOGUE = "closeActiveDialogue", e.CLOSE_LEFT_PANEL = "closeLeftPanel", e.CLOSE_RIGHT_PANEL = "closeRightPanel", e.COLLECTION_INDEX_CHANGED = "collectionIndexChanged", e.CREATE = "create", e.CREATED = "created", e.DOWN_ARROW = "downArrow", e.DOWNLOAD = "download", e.DROP = "drop", e.END = "end", e.ERROR = "error", e.ESCAPE = "escape", e.EXIT_FULLSCREEN = "exitFullScreen", e.EXTERNAL_LINK_CLICKED = "externalLinkClicked", e.FEEDBACK = "feedback", e.FIRST = "first", e.FORBIDDEN = "forbidden", e.GALLERY_DECREASE_SIZE = "galleryDecreaseSize", e.GALLERY_INCREASE_SIZE = "galleryIncreaseSize", e.GALLERY_THUMB_SELECTED = "galleryThumbSelected", e.HIDE_AUTH_DIALOGUE = "hideAuthDialogue", e.HIDE_CLICKTHROUGH_DIALOGUE = "hideClickthroughDialogue", e.HIDE_DOWNLOAD_DIALOGUE = "hideDownloadDialogue", e.HIDE_EMBED_DIALOGUE = "hideEmbedDialogue", e.HIDE_EXTERNALCONTENT_DIALOGUE = "hideExternalContentDialogue", e.HIDE_GENERIC_DIALOGUE = "hideGenericDialogue", e.HIDE_HELP_DIALOGUE = "hideHelpDialogue", e.HIDE_INFORMATION = "hideInformation", e.HIDE_LOGIN_DIALOGUE = "hideLoginDialogue", e.HIDE_MOREINFO_DIALOGUE = "hideMoreInfoDialogue", e.HIDE_MULTISELECT_DIALOGUE = "hideMultiSelectDialogue", e.HIDE_OVERLAY = "hideOverlay", e.HIDE_RESTRICTED_DIALOGUE = "hideRestrictedDialogue", e.HIDE_SETTINGS_DIALOGUE = "hideSettingsDialogue", e.HIDE_SHARE_DIALOGUE = "hideShareDialogue", e.HOME = "home", e.LAST = "last", e.LEFT_ARROW = "leftArrow", e.LEFTPANEL_COLLAPSE_FULL_FINISH = "leftPanelCollapseFullFinish", e.LEFTPANEL_COLLAPSE_FULL_START = "leftPanelCollapseFullStart", e.LEFTPANEL_EXPAND_FULL_FINISH = "leftPanelExpandFullFinish", e.LEFTPANEL_EXPAND_FULL_START = "leftPanelExpandFullStart", e.LOAD_FAILED = "loadFailed", e.LOGIN_FAILED = "loginFailed", e.LOGIN = "login", e.LOGOUT = "logout", e.MANIFEST_INDEX_CHANGED = "manifestIndexChanged", e.METRIC_CHANGED = "metricChanged", e.MINUS = "minus", e.MULTISELECT_CHANGE = "multiSelectChange", e.MULTISELECTION_MADE = "multiSelectionMade", e.NEXT = "next", e.NOT_FOUND = "notFound", e.OPEN_EXTERNAL_RESOURCE = "openExternalResource", e.OPEN_LEFT_PANEL = "openLeftPanel", e.OPEN_RIGHT_PANEL = "openRightPanel", e.OPEN_THUMBS_VIEW = "openThumbsView", e.OPEN_TREE_VIEW = "openTreeView", e.OPEN = "open", e.OPENED_MEDIA = "openedMedia", e.PAGE_DOWN = "pageDown", e.PAGE_UP = "pageUp", e.PLUS = "plus", e.PREV = "prev", e.RANGE_CHANGED = "rangeChanged", e.REDIRECT = "redirect", e.REFRESH = "refresh", e.RELOAD = "reload", e.RESIZE = "resize", e.RESOURCE_DEGRADED = "resourceDegraded", e.RETRY = "retry", e.RETURN = "return", e.RIGHT_ARROW = "rightArrow", e.RIGHTPANEL_COLLAPSE_FULL_FINISH = "rightPanelCollapseFullFinish", e.RIGHTPANEL_COLLAPSE_FULL_START = "rightPanelCollapseFullStart", e.RIGHTPANEL_EXPAND_FULL_FINISH = "rightPanelExpandFullFinish", e.RIGHTPANEL_EXPAND_FULL_START = "rightPanelExpandFullStart", e.SEQUENCE_INDEX_CHANGED = "sequenceIndexChanged", e.SETTINGS_CHANGED = "settingsChanged", e.SHOW_AUTH_DIALOGUE = "showAuthDialogue", e.SHOW_CLICKTHROUGH_DIALOGUE = "showClickThroughDialogue", e.SHOW_DOWNLOAD_DIALOGUE = "showDownloadDialogue", e.SHOW_EMBED_DIALOGUE = "showEmbedDialogue", e.SHOW_EXTERNALCONTENT_DIALOGUE = "showExternalContentDialogue", e.SHOW_GENERIC_DIALOGUE = "showGenericDialogue", e.SHOW_HELP_DIALOGUE = "showHelpDialogue", e.SHOW_INFORMATION = "showInformation", e.SHOW_LOGIN_DIALOGUE = "showLoginDialogue", e.SHOW_MESSAGE = "showMessage", e.SHOW_MOREINFO_DIALOGUE = "showMoreInfoDialogue", e.SHOW_MULTISELECT_DIALOGUE = "showMultiSelectDialogue", e.SHOW_OVERLAY = "showOverlay", e.SHOW_RESTRICTED_DIALOGUE = "showRestrictedDialogue", e.SHOW_SETTINGS_DIALOGUE = "showSettingsDialogue", e.SHOW_SHARE_DIALOGUE = "showShareDialogue", e.SHOW_TERMS_OF_USE = "showTermsOfUse", e.THUMB_MULTISELECTED = "thumbMultiSelected", e.THUMB_SELECTED = "thumbSelected", e.TOGGLE_EXPAND_LEFT_PANEL = "toggleExpandLeftPanel", e.TOGGLE_EXPAND_RIGHT_PANEL = "toggleExpandRightPanel", e.TOGGLE_FULLSCREEN = "toggleFullScreen", e.TREE_NODE_MULTISELECTED = "treeNodeMultiSelected", e.TREE_NODE_SELECTED = "treeNodeSelected", e.UP_ARROW = "upArrow", e.UPDATE_SETTINGS = "updateSettings", e.VIEW_FULL_TERMS = "viewFullTerms", e.WINDOW_UNLOAD = "windowUnload", e;
    }();
  }, function (e, t, n) {
    var i = n(10),
        r = n(16);

    for (var o in (t = e.exports = function (e, t) {
      return new r(t).process(e);
    }).FilterCSS = r, i) t[o] = i[o];

    "undefined" != typeof window && (window.filterCSS = e.exports);
  }, function (e, t) {
    e.exports = {
      indexOf: function indexOf(e, t) {
        var n, i;
        if (Array.prototype.indexOf) return e.indexOf(t);

        for (n = 0, i = e.length; n < i; n++) if (e[n] === t) return n;

        return -1;
      },
      forEach: function forEach(e, t, n) {
        var i, r;
        if (Array.prototype.forEach) return e.forEach(t, n);

        for (i = 0, r = e.length; i < r; i++) t.call(n, e[i], i, e);
      },
      trim: function trim(e) {
        return String.prototype.trim ? e.trim() : e.replace(/(^\s*)|(\s*$)/g, "");
      },
      spaceIndex: function spaceIndex(e) {
        var t = /\s|\n|\t/.exec(e);
        return t ? t.index : -1;
      }
    };
  }, function (e, t, n) {
    "use strict";

    n.d(t, "b", function () {
      return r;
    }), n.d(t, "a", function () {
      return o;
    });

    var i = n(15),
        r = function r(e) {
      return i(e, {
        whiteList: {
          a: ["href", "title", "target", "class"],
          b: [],
          br: [],
          i: [],
          img: ["src", "alt"],
          p: [],
          small: [],
          span: [],
          strong: [],
          sub: [],
          sup: []
        }
      });
    },
        o = function o(e, t, n) {
      for (var i = !1, r = 0; r < n.length && !(i = a(e, t, n[r])); r++);

      return i;
    },
        a = function a(e, t, n) {
      return t[n] !== e[n];
    };
  }, function (e, t, n) {
    "use strict";

    var i,
        r = function r(e) {
      this.isVisible = !0;
      var t = e.on.match(/.*xywh=(\d*),(\d*),(\d*),(\d*)/);
      this.x = Number(t[1]), this.y = Number(t[2]), this.width = Number(t[3]), this.height = Number(t[4]), this.chars = e.resource.chars;
    },
        o = function () {
      function e(e, t) {
        this.rects = [], this.canvasIndex = t, this.addRect(e);
      }

      return e.prototype.addRect = function (e) {
        var t = new r(e);
        t.canvasIndex = this.canvasIndex, t.index = this.rects.length, this.rects.push(t), this.rects.sort(function (e, t) {
          return e.index - t.index;
        });
      }, e;
    }(),
        a = n(1),
        s = function () {
      function e() {
        this.isEnabled = !1, this.ranges = [], this.canvases = [];
      }

      return e.prototype.allCanvasesSelected = function () {
        return this.canvases.length > 0 && this.getAllSelectedCanvases().length === this.canvases.length;
      }, e.prototype.allRangesSelected = function () {
        return this.ranges.length > 0 && this.getAllSelectedRanges().length === this.ranges.length;
      }, e.prototype.allSelected = function () {
        return this.allRangesSelected() && this.allCanvasesSelected();
      }, e.prototype.getAll = function () {
        return this.canvases.concat(this.ranges);
      }, e.prototype.getAllSelectedCanvases = function () {
        return this.canvases.filter(function (e) {
          return e.multiSelected;
        });
      }, e.prototype.getAllSelectedRanges = function () {
        return this.ranges.filter(function (e) {
          return e.multiSelected;
        });
      }, e.prototype.getCanvasById = function (e) {
        return this.canvases.filter(function (t) {
          return a.Utils.normaliseUrl(t.id) === a.Utils.normaliseUrl(e);
        })[0];
      }, e.prototype.getCanvasesByIds = function (e) {
        for (var t = [], n = 0; n < e.length; n++) {
          var i = e[n];
          t.push(this.getCanvasById(i));
        }

        return t;
      }, e.prototype.getRangeCanvases = function (e) {
        var t = e.getCanvasIds();
        return this.getCanvasesByIds(t);
      }, e.prototype.selectAll = function (e) {
        this.selectRanges(this.ranges, e), this.selectCanvases(this.canvases, e);
      }, e.prototype.selectCanvas = function (e, t) {
        this.canvases.filter(function (t) {
          return t.id === e.id;
        })[0].multiSelected = t;
      }, e.prototype.selectAllCanvases = function (e) {
        this.selectCanvases(this.canvases, e);
      }, e.prototype.selectCanvases = function (e, t) {
        for (var n = 0; n < e.length; n++) {
          e[n].multiSelected = t;
        }
      }, e.prototype.selectRange = function (e, t) {
        var n = this.ranges.filter(function (t) {
          return t.id === e.id;
        })[0];
        n.multiSelected = t;
        var i = this.getRangeCanvases(n);
        this.selectCanvases(i, t);
      }, e.prototype.selectAllRanges = function (e) {
        this.selectRanges(this.ranges, e);
      }, e.prototype.selectRanges = function (e, t) {
        for (var n = 0; n < e.length; n++) {
          var i = e[n];
          i.multiSelected = t;
          var r = this.getCanvasesByIds(i.getCanvasIds());
          this.selectCanvases(r, t);
        }
      }, e.prototype.setEnabled = function (e) {
        this.isEnabled = e;

        for (var t = this.getAll(), n = 0; n < t.length; n++) {
          var i = t[n];
          i.multiSelectEnabled = this.isEnabled, e || (i.multiSelected = !1);
        }
      }, e;
    }(),
        c = function () {
      function e(e, t) {
        this.items = [], this.resource = e, this.label = t;
      }

      return e.prototype.addItem = function (e) {
        this.items.push(e);
      }, e.prototype.addMetadata = function (e, t) {
        void 0 === t && (t = !1);

        for (var n = 0; n < e.length; n++) {
          var i = e[n];
          i.isRootLevel = t, this.addItem(i);
        }
      }, e;
    }();

    !function (e) {
      e.DATE = "date", e.NONE = "none";
    }(i || (i = {}));

    var u = n(0),
        l = function () {
      function e() {}

      return e.manifestNotLoaded = "Manifest has not loaded yet", e;
    }(),
        f = function () {
      function e(e) {
        this.options = e, this.iiifResource = this.options.iiifResource, this.manifestUri = this.options.manifestUri, this.manifest = this.options.manifest, this.collectionIndex = this.options.collectionIndex || 0, this.manifestIndex = this.options.manifestIndex || 0, this.sequenceIndex = this.options.sequenceIndex || 0, this.canvasIndex = this.options.canvasIndex || 0;
      }

      return e.prototype.getAutoCompleteService = function () {
        var e = this.getSearchService(),
            t = null;
        return e && ((t = e.getService(u.e.SEARCH_0_AUTO_COMPLETE)) || (t = e.getService(u.e.SEARCH_1_AUTO_COMPLETE))), t;
      }, e.prototype.getAttribution = function () {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        var e = this.manifest.getAttribution();
        return e ? a.LanguageMap.getValue(e, this.options.locale) : null;
      }, e.prototype.getCanvases = function () {
        return this.getCurrentSequence().getCanvases();
      }, e.prototype.getCanvasById = function (e) {
        return this.getCurrentSequence().getCanvasById(e);
      }, e.prototype.getCanvasesById = function (e) {
        for (var t = [], n = 0; n < e.length; n++) {
          var i = e[n],
              r = this.getCanvasById(i);
          r && t.push(r);
        }

        return t;
      }, e.prototype.getCanvasByIndex = function (e) {
        return this.getCurrentSequence().getCanvasByIndex(e);
      }, e.prototype.getCanvasIndexById = function (e) {
        return this.getCurrentSequence().getCanvasIndexById(e);
      }, e.prototype.getCanvasIndexByLabel = function (e) {
        var t = this.getManifestType() === a.ManifestType.MANUSCRIPT;
        return this.getCurrentSequence().getCanvasIndexByLabel(e, t);
      }, e.prototype.getCanvasRange = function (e, t) {
        var n = this.getCanvasRanges(e);

        if (t) {
          for (var i = 0; i < n.length; i++) {
            var r = n[i];
            if (r.path === t) return r;
          }

          return null;
        }

        return n[0];
      }, e.prototype.getCanvasRanges = function (e) {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        return e.ranges || (e.ranges = this.manifest.getAllRanges().filter(function (t) {
          return t.getCanvasIds().some(function (t) {
            return a.Utils.normaliseUrl(t) === a.Utils.normaliseUrl(e.id);
          });
        })), e.ranges;
      }, e.prototype.getCollectionIndex = function (e) {
        if (!e.parentCollection || e.parentCollection.parentCollection) return e.parentCollection ? e.parentCollection.index : void 0;
      }, e.prototype.getCurrentCanvas = function () {
        return this.getCurrentSequence().getCanvasByIndex(this.canvasIndex);
      }, e.prototype.getCurrentSequence = function () {
        return this.getSequenceByIndex(this.sequenceIndex);
      }, e.prototype.getDescription = function () {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        var e = this.manifest.getDescription();
        return e ? a.LanguageMap.getValue(e, this.options.locale) : null;
      }, e.prototype.getLabel = function () {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        var e = this.manifest.getLabel();
        return e ? a.LanguageMap.getValue(e, this.options.locale) : null;
      }, e.prototype.getLastCanvasLabel = function (e) {
        return this.getCurrentSequence().getLastCanvasLabel(e);
      }, e.prototype.getFirstPageIndex = function () {
        return 0;
      }, e.prototype.getLastPageIndex = function () {
        return this.getTotalCanvases() - 1;
      }, e.prototype.getLicense = function () {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        return this.manifest.getLicense();
      }, e.prototype.getLogo = function () {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        return this.manifest.getLogo();
      }, e.prototype.getManifestType = function () {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        var e = this.manifest.getManifestType();
        return e === a.ManifestType.EMPTY && (e = a.ManifestType.MONOGRAPH), e;
      }, e.prototype.getMetadata = function (e) {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        var t = [],
            n = this.manifest.getMetadata(),
            i = new c(this.manifest),
            r = this.options.locale;
        (n && n.length && i.addMetadata(n, !0), this.manifest.getDescription().length) && ((u = new a.LabelValuePair(r)).label = [new a.Language("description", r)], u.value = this.manifest.getDescription(), u.isRootLevel = !0, i.addItem(u));
        this.manifest.getAttribution().length && ((u = new a.LabelValuePair(r)).label = [new a.Language("attribution", r)], u.value = this.manifest.getAttribution(), u.isRootLevel = !0, i.addItem(u));
        var o = this.manifest.getLicense();

        if (o) {
          var s = {
            label: "license",
            value: e && e.licenseFormatter ? e.licenseFormatter.format(o) : o
          };
          (u = new a.LabelValuePair(r)).parse(s), u.isRootLevel = !0, i.addItem(u);
        }

        if (this.manifest.getLogo()) {
          var u;
          s = {
            label: "logo",
            value: '<img src="' + this.manifest.getLogo() + '"/>'
          };
          (u = new a.LabelValuePair(r)).parse(s), u.isRootLevel = !0, i.addItem(u);
        }

        return t.push(i), e ? this._parseMetadataOptions(e, t) : t;
      }, e.prototype.getRequiredStatement = function () {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        var e = this.manifest.getRequiredStatement();
        return e ? {
          label: e.getLabel(),
          value: e.getValue()
        } : null;
      }, e.prototype._parseMetadataOptions = function (e, t) {
        var n = this.getCurrentSequence(),
            i = n.getMetadata();

        if (i && i.length) {
          var r = new c(n);
          r.addMetadata(i), t.push(r);
        }

        if (e.range) {
          var o = this._getRangeMetadata([], e.range);

          o = o.reverse(), t = t.concat(o);
        }

        if (e.canvases && e.canvases.length) for (var a = 0; a < e.canvases.length; a++) {
          var s = e.canvases[a],
              u = s.getMetadata();

          if (u && u.length) {
            var l = new c(s);
            l.addMetadata(s.getMetadata()), t.push(l);
          }

          for (var f = s.getImages(), p = 0; p < f.length; p++) {
            var h = f[p],
                d = h.getMetadata();

            if (d && d.length) {
              var g = new c(h);
              g.addMetadata(d), t.push(g);
            }
          }
        }
        return t;
      }, e.prototype._getRangeMetadata = function (e, t) {
        var n = t.getMetadata();

        if (n && n.length) {
          var i = new c(t);
          i.addMetadata(n), e.push(i);
        } else if (t.parentRange) return this._getRangeMetadata(e, t.parentRange);

        return e;
      }, e.prototype.getMultiSelectState = function () {
        return this._multiSelectState || (this._multiSelectState = new s(), this._multiSelectState.ranges = this.getRanges().slice(0), this._multiSelectState.canvases = this.getCurrentSequence().getCanvases().slice(0)), this._multiSelectState;
      }, e.prototype.getCurrentRange = function () {
        return this.rangeId ? this.getRangeById(this.rangeId) : null;
      }, e.prototype.getPosterCanvas = function () {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        return this.manifest.getPosterCanvas();
      }, e.prototype.getPosterImage = function () {
        var e = this.getPosterCanvas();

        if (e) {
          var t = e.getContent();
          if (t && t.length) return t[0].getBody()[0].id;
        }

        return null;
      }, e.prototype.getPreviousRange = function (e) {
        var t = null;

        if (t = e || this.getCurrentRange()) {
          var n = this.getFlattenedTree();
          if (n) for (var i = 0; i < n.length; i++) {
            var r = n[i];

            if (r && r.data.id === t.id) {
              for (; i > 0;) {
                return n[--i].data;
              }

              break;
            }
          }
        }

        return null;
      }, e.prototype.getNextRange = function (e) {
        var t = null;

        if (t = e || this.getCurrentRange()) {
          var n = this.getFlattenedTree();
          if (n) for (var i = 0; i < n.length; i++) {
            var r = n[i];

            if (r && r.data.id === t.id) {
              for (; i < n.length - 1;) {
                var o = n[++i];
                if (o.data.canvases && o.data.canvases.length) return o.data;
              }

              break;
            }
          }
        }

        return null;
      }, e.prototype.getFlattenedTree = function (e) {
        var t = null;
        return (t = e || this.getTree()) ? this._flattenTree(t, "nodes") : null;
      }, e.prototype._flattenTree = function (e, t) {
        var n = this,
            i = [e];
        return e[t] && e[t].length > 0 ? i.concat(e[t].map(function (e) {
          return n._flattenTree(e, t);
        }).reduce(function (e, t) {
          return e.concat(t);
        }, [])) : i;
      }, e.prototype.getRanges = function () {
        return this.manifest.getAllRanges();
      }, e.prototype.getRangeByPath = function (e) {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        return this.manifest.getRangeByPath(e);
      }, e.prototype.getRangeById = function (e) {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        return this.manifest.getRangeById(e);
      }, e.prototype.getRangeCanvases = function (e) {
        var t = e.getCanvasIds();
        return this.getCanvasesById(t);
      }, e.prototype.getRelated = function () {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        return this.manifest.getRelated();
      }, e.prototype.getSearchService = function () {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        var e = this.manifest.getService(u.e.SEARCH_0);
        return e || (e = this.manifest.getService(u.e.SEARCH_1)), e;
      }, e.prototype.getSeeAlso = function () {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        return this.manifest.getSeeAlso();
      }, e.prototype.getSequenceByIndex = function (e) {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        return this.manifest.getSequenceByIndex(e);
      }, e.prototype.getShareServiceUrl = function () {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        var e = null,
            t = this.manifest.getService(u.e.SHARE_EXTENSIONS);
        return t && (t.length && (t = t[0]), e = t.__jsonld.shareUrl), e;
      }, e.prototype._getSortedTreeNodesByDate = function (e, t) {
        var n = this.getFlattenedTree(t);

        if (n) {
          var i = n.filter(function (e) {
            return e.data.type === a.TreeNodeType.MANIFEST;
          });
          this.createDecadeNodes(e, n), this.sortDecadeNodes(e), this.createYearNodes(e, n), this.sortYearNodes(e), this.createMonthNodes(e, i), this.sortMonthNodes(e), this.createDateNodes(e, i), this.pruneDecadeNodes(e);
        }
      }, e.prototype.getStartCanvasIndex = function () {
        return this.getCurrentSequence().getStartCanvasIndex();
      }, e.prototype.getThumbs = function (e, t) {
        return this.getCurrentSequence().getThumbs(e, t);
      }, e.prototype.getTopRanges = function () {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        return this.manifest.getTopRanges();
      }, e.prototype.getTotalCanvases = function () {
        return this.getCurrentSequence().getTotalCanvases();
      }, e.prototype.getTrackingLabel = function () {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        return this.manifest.getTrackingLabel();
      }, e.prototype._getTopRanges = function () {
        return this.iiifResource.getTopRanges();
      }, e.prototype.getTree = function (e, t) {
        if (void 0 === e && (e = 0), void 0 === t && (t = i.NONE), !this.iiifResource) return null;
        var n;
        if (this.iiifResource.isCollection()) n = this.iiifResource.getDefaultTree();else {
          var r = this._getTopRanges(),
              o = new a.TreeNode();

          if (o.label = "root", o.data = this.iiifResource, !r.length) return o;
          n = r[e].getTree(o);
        }
        var s = new a.TreeNode();

        switch (t.toString()) {
          case i.DATE.toString():
            if (this.treeHasNavDates(n)) {
              this._getSortedTreeNodesByDate(s, n);

              break;
            }

          default:
            s = n;
        }

        return s;
      }, e.prototype.treeHasNavDates = function (e) {
        var t = this.getFlattenedTree(e);
        return !!t && t.some(function (e) {
          return !isNaN(e.navDate);
        });
      }, e.prototype.getViewingDirection = function () {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        var e = this.getCurrentSequence().getViewingDirection();
        return e || (e = this.manifest.getViewingDirection()), e;
      }, e.prototype.getViewingHint = function () {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        var e = this.getCurrentSequence().getViewingHint();
        return e || (e = this.manifest.getViewingHint()), e;
      }, e.prototype.hasParentCollection = function () {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        return !!this.manifest.parentCollection;
      }, e.prototype.hasRelatedPage = function () {
        var e = this.getRelated();
        return !!e && (e.length && (e = e[0]), "text/html" === e.format);
      }, e.prototype.hasResources = function () {
        return this.getCurrentCanvas().getResources().length > 0;
      }, e.prototype.isBottomToTop = function () {
        var e = this.getViewingDirection();
        return !!e && e === u.f.BOTTOM_TO_TOP;
      }, e.prototype.isCanvasIndexOutOfRange = function (e) {
        return this.getCurrentSequence().isCanvasIndexOutOfRange(e);
      }, e.prototype.isContinuous = function () {
        var e = this.getViewingHint();
        return !!e && e === u.g.CONTINUOUS;
      }, e.prototype.isFirstCanvas = function (e) {
        return void 0 !== e ? this.getCurrentSequence().isFirstCanvas(e) : this.getCurrentSequence().isFirstCanvas(this.canvasIndex);
      }, e.prototype.isHorizontallyAligned = function () {
        return this.isLeftToRight() || this.isRightToLeft();
      }, e.prototype.isLastCanvas = function (e) {
        return void 0 !== e ? this.getCurrentSequence().isLastCanvas(e) : this.getCurrentSequence().isLastCanvas(this.canvasIndex);
      }, e.prototype.isLeftToRight = function () {
        var e = this.getViewingDirection();
        return !!e && e === u.f.LEFT_TO_RIGHT;
      }, e.prototype.isMultiCanvas = function () {
        return this.getCurrentSequence().isMultiCanvas();
      }, e.prototype.isMultiSequence = function () {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        return this.manifest.isMultiSequence();
      }, e.prototype.isPaged = function () {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        var e = this.getViewingHint();
        return e ? e === u.g.PAGED : this.manifest.isPagingEnabled();
      }, e.prototype.isPagingAvailable = function () {
        return this.isPagingEnabled() && this.getTotalCanvases() > 2;
      }, e.prototype.isPagingEnabled = function () {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        return this.manifest.isPagingEnabled() || this.getCurrentSequence().isPagingEnabled();
      }, e.prototype.isRightToLeft = function () {
        var e = this.getViewingDirection();
        return !!e && e === u.f.RIGHT_TO_LEFT;
      }, e.prototype.isTopToBottom = function () {
        var e = this.getViewingDirection();
        return !!e && e === u.f.TOP_TO_BOTTOM;
      }, e.prototype.isTotalCanvasesEven = function () {
        return this.getCurrentSequence().isTotalCanvasesEven();
      }, e.prototype.isUIEnabled = function (e) {
        if (!this.manifest) throw new Error(l.manifestNotLoaded);
        var t = this.manifest.getService(u.e.UI_EXTENSIONS);

        if (t) {
          var n = t.getProperty("disableUI");
          if (n && (-1 !== n.indexOf(e) || -1 !== n.indexOf(e.toLowerCase()))) return !1;
        }

        return !0;
      }, e.prototype.isVerticallyAligned = function () {
        return this.isTopToBottom() || this.isBottomToTop();
      }, e.prototype.createDateNodes = function (e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n],
              r = this.getNodeYear(i),
              o = this.getNodeMonth(i),
              s = new a.TreeNode();
          s.id = i.id, s.label = this.getNodeDisplayDate(i), s.data = i.data, s.data.type = a.TreeNodeType.MANIFEST, s.data.year = r, s.data.month = o;
          var c = this.getDecadeNode(e, r);

          if (c) {
            var u = this.getYearNode(c, r);

            if (u) {
              var l = this.getMonthNode(u, o);
              l && l.addNode(s);
            }
          }
        }
      }, e.prototype.createDecadeNodes = function (e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];

          if (i.navDate) {
            var r = this.getNodeYear(i),
                o = Number(r.toString().substr(0, 3) + "9");

            if (!this.getDecadeNode(e, r)) {
              var s = new a.TreeNode();
              s.label = r + " - " + o, s.navDate = i.navDate, s.data.startYear = r, s.data.endYear = o, e.addNode(s);
            }
          }
        }
      }, e.prototype.createMonthNodes = function (e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];

          if (i.navDate) {
            var r = this.getNodeYear(i),
                o = this.getNodeMonth(i),
                s = this.getDecadeNode(e, r),
                c = null;

            if (s && (c = this.getYearNode(s, r)), s && c && !this.getMonthNode(c, o)) {
              var u = new a.TreeNode();
              u.label = this.getNodeDisplayMonth(i), u.navDate = i.navDate, u.data.year = r, u.data.month = o, c.addNode(u);
            }
          }
        }
      }, e.prototype.createYearNodes = function (e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];

          if (i.navDate) {
            var r = this.getNodeYear(i),
                o = this.getDecadeNode(e, r);

            if (o && !this.getYearNode(o, r)) {
              var s = new a.TreeNode();
              s.label = r.toString(), s.navDate = i.navDate, s.data.year = r, o.addNode(s);
            }
          }
        }
      }, e.prototype.getDecadeNode = function (e, t) {
        for (var n = 0; n < e.nodes.length; n++) {
          var i = e.nodes[n];
          if (t >= i.data.startYear && t <= i.data.endYear) return i;
        }

        return null;
      }, e.prototype.getMonthNode = function (e, t) {
        for (var n = 0; n < e.nodes.length; n++) {
          var i = e.nodes[n];
          if (t === this.getNodeMonth(i)) return i;
        }

        return null;
      }, e.prototype.getNodeDisplayDate = function (e) {
        return e.navDate.toDateString();
      }, e.prototype.getNodeDisplayMonth = function (e) {
        return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][e.navDate.getMonth()];
      }, e.prototype.getNodeMonth = function (e) {
        return e.navDate.getMonth();
      }, e.prototype.getNodeYear = function (e) {
        return e.navDate.getFullYear();
      }, e.prototype.getYearNode = function (e, t) {
        for (var n = 0; n < e.nodes.length; n++) {
          var i = e.nodes[n];
          if (t === this.getNodeYear(i)) return i;
        }

        return null;
      }, e.prototype.pruneDecadeNodes = function (e) {
        for (var t = [], n = 0; n < e.nodes.length; n++) {
          var i = e.nodes[n];
          i.nodes.length || t.push(i);
        }

        for (var r = 0; r < t.length; r++) {
          var o = t[r],
              a = e.nodes.indexOf(o);
          a > -1 && e.nodes.splice(a, 1);
        }
      }, e.prototype.sortDecadeNodes = function (e) {
        e.nodes = e.nodes.sort(function (e, t) {
          return e.data.startYear - t.data.startYear;
        });
      }, e.prototype.sortMonthNodes = function (e) {
        for (var t = this, n = 0; n < e.nodes.length; n++) for (var i = e.nodes[n], r = 0; r < i.nodes.length; r++) {
          var o = i.nodes[r];
          o.nodes = o.nodes.sort(function (e, n) {
            return t.getNodeMonth(e) - t.getNodeMonth(n);
          });
        }
      }, e.prototype.sortYearNodes = function (e) {
        for (var t = this, n = 0; n < e.nodes.length; n++) {
          var i = e.nodes[n];
          i.nodes = i.nodes.sort(function (e, n) {
            return t.getNodeYear(e) - t.getNodeYear(n);
          });
        }
      }, e;
    }(),
        p = function () {
      function e(e) {
        this._options = e, this._options.locale = this._options.locale || "en-GB";
      }

      return e.prototype.bootstrap = function (e, t) {
        var n = this;
        return new Promise(function (i, r) {
          e && t && (i = e, r = t), a.Utils.loadManifest(n._options.manifestUri).then(function (e) {
            n._loaded(n, e, i, r);
          });
        });
      }, e.prototype._loaded = function (e, t, n, i) {
        var r = a.Utils.parseManifest(t, {
          locale: e._options.locale
        });

        if (r) {
          e._options.iiifResource || (e._options.iiifResource = r);
          var o = e._options.collectionIndex,
              s = e._options.manifestIndex;

          if (r.getIIIFResourceType() === u.b.COLLECTION) {
            var c = r.getManifests(),
                l = r.getCollections();
            c.length || void 0 !== o || (o = 0), void 0 !== o && l && l.length ? r.getCollectionByIndex(o).then(function (t) {
              t || i("Collection index not found"), 0 === t.getTotalManifests() && 0 === s && t.getTotalCollections() > 0 ? (e._options.collectionIndex = 0, e._options.manifestUri = t.id, e.bootstrap(n, i)) : void 0 !== s && t.getManifestByIndex(s).then(function (t) {
                e._options.manifest = t;
                var i = new f(e._options);
                n(i);
              });
            }) : r.getManifestByIndex(e._options.manifestIndex).then(function (t) {
              e._options.manifest = t;
              var i = new f(e._options);
              n(i);
            });
          } else {
            e._options.manifest = r;
            var p = new f(e._options);
            n(p);
          }
        } else console.error("Unable to load IIIF resource");
      }, e;
    }(),
        h = n(2),
        d = function () {
      function e(e, t) {
        this.authHoldingPage = null, this.clickThroughService = null, this.externalService = null, this.isProbed = !1, this.isResponseHandled = !1, this.kioskService = null, this.loginService = null, this.logoutService = null, this.probeService = null, this.restrictedService = null, this.tokenService = null, e.externalResource = this, this.dataUri = this._getDataUri(e), this.index = e.index, this.authAPIVersion = t.authApiVersion, this._parseAuthServices(e), this._parseCanvasDimensions(e);
      }

      return e.prototype._getImageServiceDescriptor = function (e) {
        for (var t = null, n = 0; n < e.length; n++) {
          var i = e[n],
              r = i.id;
          r.endsWith("/") || (r += "/"), a.Utils.isImageProfile(i.getProfile()) && (t = r + "info.json");
        }

        return t;
      }, e.prototype._getDataUri = function (e) {
        var t = e.getContent(),
            n = e.getImages(),
            i = null;

        if (t && t.length) {
          var r = t[0].getBody();
          return r.length ? (o = r[0].getServices()).length && (i = this._getImageServiceDescriptor(o)) ? i : r[0].id : null;
        }

        if (n && n.length) {
          var o,
              a = n[0].getResource();
          return (o = a.getServices()).length && (i = this._getImageServiceDescriptor(o)) ? i : a.id;
        }

        var s = e.getService(u.e.IXIF);
        return s ? s.getInfoUri() : e.id;
      }, e.prototype._parseAuthServices = function (e) {
        if (.9 === this.authAPIVersion) this.clickThroughService = a.Utils.getService(e, u.e.AUTH_0_CLICK_THROUGH), this.loginService = a.Utils.getService(e, u.e.AUTH_0_LOGIN), this.restrictedService = a.Utils.getService(e, u.e.AUTH_0_RESTRICTED), this.clickThroughService ? (this.logoutService = this.clickThroughService.getService(u.e.AUTH_0_LOGOUT), this.tokenService = this.clickThroughService.getService(u.e.AUTH_0_TOKEN)) : this.loginService ? (this.logoutService = this.loginService.getService(u.e.AUTH_0_LOGOUT), this.tokenService = this.loginService.getService(u.e.AUTH_0_TOKEN)) : this.restrictedService && (this.logoutService = this.restrictedService.getService(u.e.AUTH_0_LOGOUT), this.tokenService = this.restrictedService.getService(u.e.AUTH_0_TOKEN));else {
          if (void 0 !== e.isCanvas && e.isCanvas()) {
            var t = e.getContent();

            if (t && t.length) {
              var n = t[0].getBody();
              if (n && n.length) e = n[0];
            }
          }

          this.clickThroughService = a.Utils.getService(e, u.e.AUTH_1_CLICK_THROUGH), this.loginService = a.Utils.getService(e, u.e.AUTH_1_LOGIN), this.externalService = a.Utils.getService(e, u.e.AUTH_1_EXTERNAL), this.kioskService = a.Utils.getService(e, u.e.AUTH_1_KIOSK), this.clickThroughService ? (this.logoutService = this.clickThroughService.getService(u.e.AUTH_1_LOGOUT), this.tokenService = this.clickThroughService.getService(u.e.AUTH_1_TOKEN), this.probeService = this.clickThroughService.getService(u.e.AUTH_1_PROBE)) : this.loginService ? (this.logoutService = this.loginService.getService(u.e.AUTH_1_LOGOUT), this.tokenService = this.loginService.getService(u.e.AUTH_1_TOKEN), this.probeService = this.loginService.getService(u.e.AUTH_1_PROBE)) : this.externalService ? (this.logoutService = this.externalService.getService(u.e.AUTH_1_LOGOUT), this.tokenService = this.externalService.getService(u.e.AUTH_1_TOKEN), this.probeService = this.externalService.getService(u.e.AUTH_1_PROBE)) : this.kioskService && (this.logoutService = this.kioskService.getService(u.e.AUTH_1_LOGOUT), this.tokenService = this.kioskService.getService(u.e.AUTH_1_TOKEN), this.probeService = this.kioskService.getService(u.e.AUTH_1_PROBE));
        }
      }, e.prototype._parseCanvasDimensions = function (e) {
        var t = e.getImages();

        if (t && t.length) {
          var n = t[0].getResource();
          this.width = n.getWidth(), this.height = n.getHeight();
        } else if ((t = e.getContent()).length) {
          var i = t[0].getBody();
          i.length && (this.width = i[0].getWidth(), this.height = i[0].getHeight());
        }
      }, e.prototype._parseDescriptorDimensions = function (e) {
        void 0 !== e.width && (this.width = e.width), void 0 !== e.height && (this.height = e.height);
      }, e.prototype.isAccessControlled = function () {
        return !!(this.clickThroughService || this.loginService || this.externalService || this.kioskService || this.probeService);
      }, e.prototype.hasServiceDescriptor = function () {
        return !!this.dataUri && this.dataUri.endsWith("info.json");
      }, e.prototype.getData = function (e) {
        var t = this;
        return t.data = {}, new Promise(function (n, i) {
          if (t.dataUri) {
            if (t.probeService) {
              t.isProbed = !0;
              var r = new XMLHttpRequest();
              r.open("GET", t.probeService.id, !0), r.withCredentials = !0, r.onload = function () {
                var e = JSON.parse(r.responseText);
                unescape(e.contentLocation) !== t.dataUri ? t.status = h.MOVED_TEMPORARILY : t.status = h.OK, n(t);
              }, r.onerror = function () {
                t.status = r.status, n(t);
              }, r.send();
            } else {
              var o = "GET";

              if (!t.hasServiceDescriptor()) {
                if (!t.isAccessControlled()) return t.status = h.OK, void n(t);
                o = "HEAD";
              }

              var a = new XMLHttpRequest();
              a.open(o, t.dataUri, !0), e && a.setRequestHeader("Authorization", "Bearer " + e.accessToken), a.onload = function () {
                var e = JSON.parse(a.responseText);

                if (e) {
                  var i = unescape(e["@id"]);
                  t.data = e, t._parseAuthServices(t.data), t._parseDescriptorDimensions(t.data), i.endsWith("/info.json") && (i = i.substr(0, i.lastIndexOf("/")));
                  var r = t.dataUri;
                  r && r.endsWith("/info.json") && (r = r.substr(0, r.lastIndexOf("/"))), i !== r && t.loginService ? t.status = h.MOVED_TEMPORARILY : t.status = h.OK, n(t);
                } else t.status = h.OK, n(t);
              }, a.onerror = function () {
                t.status = a.status, a.responseText && t._parseAuthServices(JSON.parse(a.responseText)), n(t);
              }, a.send();
            }
          } else i("There is no dataUri to fetch");
        });
      }, e;
    }(),
        g = function () {
      function e(e) {
        this.labels = e;
      }

      return e.prototype.format = function (e) {
        return -1 != e.indexOf("<a") ? e : '<a href="' + e + '">' + (this.labels[e] ? this.labels[e] : e) + "</a>";
      }, e;
    }();

    n.d(t, "e", function () {
      return v;
    }), n.d(t, "a", function () {
      return o;
    }), n.d(t, "b", function () {
      return d;
    }), n.d(t, "c", function () {
      return i;
    }), n.d(t, "d", function () {
      return g;
    });

    var v = function v(e) {
      return new p(e).bootstrap();
    };
  }, function (e, t, n) {
    var i = n(5).FilterCSS,
        r = n(5).getDefaultWhiteList,
        o = n(6);

    function a() {
      return {
        a: ["target", "href", "title"],
        abbr: ["title"],
        address: [],
        area: ["shape", "coords", "href", "alt"],
        article: [],
        aside: [],
        audio: ["autoplay", "controls", "loop", "preload", "src"],
        b: [],
        bdi: ["dir"],
        bdo: ["dir"],
        big: [],
        blockquote: ["cite"],
        br: [],
        caption: [],
        center: [],
        cite: [],
        code: [],
        col: ["align", "valign", "span", "width"],
        colgroup: ["align", "valign", "span", "width"],
        dd: [],
        del: ["datetime"],
        details: ["open"],
        div: [],
        dl: [],
        dt: [],
        em: [],
        font: ["color", "size", "face"],
        footer: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        header: [],
        hr: [],
        i: [],
        img: ["src", "alt", "title", "width", "height"],
        ins: ["datetime"],
        li: [],
        mark: [],
        nav: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        section: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        table: ["width", "border", "align", "valign"],
        tbody: ["align", "valign"],
        td: ["width", "rowspan", "colspan", "align", "valign"],
        tfoot: ["align", "valign"],
        th: ["width", "rowspan", "colspan", "align", "valign"],
        thead: ["align", "valign"],
        tr: ["rowspan", "align", "valign"],
        tt: [],
        u: [],
        ul: [],
        video: ["autoplay", "controls", "loop", "preload", "src", "height", "width"]
      };
    }

    var s = new i();

    function c(e) {
      return e.replace(u, "&lt;").replace(l, "&gt;");
    }

    var u = /</g,
        l = />/g,
        f = /"/g,
        p = /&quot;/g,
        h = /&#([a-zA-Z0-9]*);?/gim,
        d = /&colon;?/gim,
        g = /&newline;?/gim,
        v = /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a)\:/gi,
        _ = /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi,
        E = /u\s*r\s*l\s*\(.*/gi;

    function m(e) {
      return e.replace(f, "&quot;");
    }

    function y(e) {
      return e.replace(p, '"');
    }

    function I(e) {
      return e.replace(h, function (e, t) {
        return "x" === t[0] || "X" === t[0] ? String.fromCharCode(parseInt(t.substr(1), 16)) : String.fromCharCode(parseInt(t, 10));
      });
    }

    function b(e) {
      return e.replace(d, ":").replace(g, " ");
    }

    function T(e) {
      for (var t = "", n = 0, i = e.length; n < i; n++) t += e.charCodeAt(n) < 32 ? " " : e.charAt(n);

      return o.trim(t);
    }

    function O(e) {
      return e = T(e = b(e = I(e = y(e))));
    }

    function L(e) {
      return e = c(e = m(e));
    }

    var A = /<!--[\s\S]*?-->/g;
    t.whiteList = {
      a: ["target", "href", "title"],
      abbr: ["title"],
      address: [],
      area: ["shape", "coords", "href", "alt"],
      article: [],
      aside: [],
      audio: ["autoplay", "controls", "loop", "preload", "src"],
      b: [],
      bdi: ["dir"],
      bdo: ["dir"],
      big: [],
      blockquote: ["cite"],
      br: [],
      caption: [],
      center: [],
      cite: [],
      code: [],
      col: ["align", "valign", "span", "width"],
      colgroup: ["align", "valign", "span", "width"],
      dd: [],
      del: ["datetime"],
      details: ["open"],
      div: [],
      dl: [],
      dt: [],
      em: [],
      font: ["color", "size", "face"],
      footer: [],
      h1: [],
      h2: [],
      h3: [],
      h4: [],
      h5: [],
      h6: [],
      header: [],
      hr: [],
      i: [],
      img: ["src", "alt", "title", "width", "height"],
      ins: ["datetime"],
      li: [],
      mark: [],
      nav: [],
      ol: [],
      p: [],
      pre: [],
      s: [],
      section: [],
      small: [],
      span: [],
      sub: [],
      sup: [],
      strong: [],
      table: ["width", "border", "align", "valign"],
      tbody: ["align", "valign"],
      td: ["width", "rowspan", "colspan", "align", "valign"],
      tfoot: ["align", "valign"],
      th: ["width", "rowspan", "colspan", "align", "valign"],
      thead: ["align", "valign"],
      tr: ["rowspan", "align", "valign"],
      tt: [],
      u: [],
      ul: [],
      video: ["autoplay", "controls", "loop", "preload", "src", "height", "width"]
    }, t.getDefaultWhiteList = a, t.onTag = function (e, t, n) {}, t.onIgnoreTag = function (e, t, n) {}, t.onTagAttr = function (e, t, n) {}, t.onIgnoreTagAttr = function (e, t, n) {}, t.safeAttrValue = function (e, t, n, i) {
      if (n = O(n), "href" === t || "src" === t) {
        if ("#" === (n = o.trim(n))) return "#";
        if ("http://" !== n.substr(0, 7) && "https://" !== n.substr(0, 8) && "mailto:" !== n.substr(0, 7) && "tel:" !== n.substr(0, 4) && "#" !== n[0] && "/" !== n[0]) return "";
      } else if ("background" === t) {
        if (v.lastIndex = 0, v.test(n)) return "";
      } else if ("style" === t) {
        if (_.lastIndex = 0, _.test(n)) return "";
        if (E.lastIndex = 0, E.test(n) && (v.lastIndex = 0, v.test(n))) return "";
        !1 !== i && (n = (i = i || s).process(n));
      }

      return n = L(n);
    }, t.escapeHtml = c, t.escapeQuote = m, t.unescapeQuote = y, t.escapeHtmlEntities = I, t.escapeDangerHtml5Entities = b, t.clearNonPrintableCharacter = T, t.friendlyAttrValue = O, t.escapeAttrValue = L, t.onIgnoreTagStripAll = function () {
      return "";
    }, t.StripTagBody = function (e, t) {
      "function" != typeof t && (t = function t() {});
      var n = !Array.isArray(e),
          i = [],
          r = !1;
      return {
        onIgnoreTag: function onIgnoreTag(a, s, c) {
          if (function (t) {
            return !!n || -1 !== o.indexOf(e, t);
          }(a)) {
            if (c.isClosing) {
              var u = "[/removed]",
                  l = c.position + u.length;
              return i.push([!1 !== r ? r : c.position, l]), r = !1, u;
            }

            return r || (r = c.position), "[removed]";
          }

          return t(a, s, c);
        },
        remove: function remove(e) {
          var t = "",
              n = 0;
          return o.forEach(i, function (i) {
            t += e.slice(n, i[0]), n = i[1];
          }), t += e.slice(n);
        }
      };
    }, t.stripCommentTag = function (e) {
      return e.replace(A, "");
    }, t.stripBlankChar = function (e) {
      var t = e.split("");
      return (t = t.filter(function (e) {
        var t = e.charCodeAt(0);
        return 127 !== t && (!(t <= 31) || 10 === t || 13 === t);
      })).join("");
    }, t.cssFilter = s, t.getDefaultCSSWhiteList = r;
  }, function (e, t) {
    function n() {
      var e = {
        "align-content": !1,
        "align-items": !1,
        "align-self": !1,
        "alignment-adjust": !1,
        "alignment-baseline": !1,
        all: !1,
        "anchor-point": !1,
        animation: !1,
        "animation-delay": !1,
        "animation-direction": !1,
        "animation-duration": !1,
        "animation-fill-mode": !1,
        "animation-iteration-count": !1,
        "animation-name": !1,
        "animation-play-state": !1,
        "animation-timing-function": !1,
        azimuth: !1,
        "backface-visibility": !1,
        background: !0,
        "background-attachment": !0,
        "background-clip": !0,
        "background-color": !0,
        "background-image": !0,
        "background-origin": !0,
        "background-position": !0,
        "background-repeat": !0,
        "background-size": !0,
        "baseline-shift": !1,
        binding: !1,
        bleed: !1,
        "bookmark-label": !1,
        "bookmark-level": !1,
        "bookmark-state": !1,
        border: !0,
        "border-bottom": !0,
        "border-bottom-color": !0,
        "border-bottom-left-radius": !0,
        "border-bottom-right-radius": !0,
        "border-bottom-style": !0,
        "border-bottom-width": !0,
        "border-collapse": !0,
        "border-color": !0,
        "border-image": !0,
        "border-image-outset": !0,
        "border-image-repeat": !0,
        "border-image-slice": !0,
        "border-image-source": !0,
        "border-image-width": !0,
        "border-left": !0,
        "border-left-color": !0,
        "border-left-style": !0,
        "border-left-width": !0,
        "border-radius": !0,
        "border-right": !0,
        "border-right-color": !0,
        "border-right-style": !0,
        "border-right-width": !0,
        "border-spacing": !0,
        "border-style": !0,
        "border-top": !0,
        "border-top-color": !0,
        "border-top-left-radius": !0,
        "border-top-right-radius": !0,
        "border-top-style": !0,
        "border-top-width": !0,
        "border-width": !0,
        bottom: !1,
        "box-decoration-break": !0,
        "box-shadow": !0,
        "box-sizing": !0,
        "box-snap": !0,
        "box-suppress": !0,
        "break-after": !0,
        "break-before": !0,
        "break-inside": !0,
        "caption-side": !1,
        chains: !1,
        clear: !0,
        clip: !1,
        "clip-path": !1,
        "clip-rule": !1,
        color: !0,
        "color-interpolation-filters": !0,
        "column-count": !1,
        "column-fill": !1,
        "column-gap": !1,
        "column-rule": !1,
        "column-rule-color": !1,
        "column-rule-style": !1,
        "column-rule-width": !1,
        "column-span": !1,
        "column-width": !1,
        columns: !1,
        contain: !1,
        content: !1,
        "counter-increment": !1,
        "counter-reset": !1,
        "counter-set": !1,
        crop: !1,
        cue: !1,
        "cue-after": !1,
        "cue-before": !1,
        cursor: !1,
        direction: !1,
        display: !0,
        "display-inside": !0,
        "display-list": !0,
        "display-outside": !0,
        "dominant-baseline": !1,
        elevation: !1,
        "empty-cells": !1,
        filter: !1,
        flex: !1,
        "flex-basis": !1,
        "flex-direction": !1,
        "flex-flow": !1,
        "flex-grow": !1,
        "flex-shrink": !1,
        "flex-wrap": !1,
        float: !1,
        "float-offset": !1,
        "flood-color": !1,
        "flood-opacity": !1,
        "flow-from": !1,
        "flow-into": !1,
        font: !0,
        "font-family": !0,
        "font-feature-settings": !0,
        "font-kerning": !0,
        "font-language-override": !0,
        "font-size": !0,
        "font-size-adjust": !0,
        "font-stretch": !0,
        "font-style": !0,
        "font-synthesis": !0,
        "font-variant": !0,
        "font-variant-alternates": !0,
        "font-variant-caps": !0,
        "font-variant-east-asian": !0,
        "font-variant-ligatures": !0,
        "font-variant-numeric": !0,
        "font-variant-position": !0,
        "font-weight": !0,
        grid: !1,
        "grid-area": !1,
        "grid-auto-columns": !1,
        "grid-auto-flow": !1,
        "grid-auto-rows": !1,
        "grid-column": !1,
        "grid-column-end": !1,
        "grid-column-start": !1,
        "grid-row": !1,
        "grid-row-end": !1,
        "grid-row-start": !1,
        "grid-template": !1,
        "grid-template-areas": !1,
        "grid-template-columns": !1,
        "grid-template-rows": !1,
        "hanging-punctuation": !1,
        height: !0,
        hyphens: !1,
        icon: !1,
        "image-orientation": !1,
        "image-resolution": !1,
        "ime-mode": !1,
        "initial-letters": !1,
        "inline-box-align": !1,
        "justify-content": !1,
        "justify-items": !1,
        "justify-self": !1,
        left: !1,
        "letter-spacing": !0,
        "lighting-color": !0,
        "line-box-contain": !1,
        "line-break": !1,
        "line-grid": !1,
        "line-height": !1,
        "line-snap": !1,
        "line-stacking": !1,
        "line-stacking-ruby": !1,
        "line-stacking-shift": !1,
        "line-stacking-strategy": !1,
        "list-style": !0,
        "list-style-image": !0,
        "list-style-position": !0,
        "list-style-type": !0,
        margin: !0,
        "margin-bottom": !0,
        "margin-left": !0,
        "margin-right": !0,
        "margin-top": !0,
        "marker-offset": !1,
        "marker-side": !1,
        marks: !1,
        mask: !1,
        "mask-box": !1,
        "mask-box-outset": !1,
        "mask-box-repeat": !1,
        "mask-box-slice": !1,
        "mask-box-source": !1,
        "mask-box-width": !1,
        "mask-clip": !1,
        "mask-image": !1,
        "mask-origin": !1,
        "mask-position": !1,
        "mask-repeat": !1,
        "mask-size": !1,
        "mask-source-type": !1,
        "mask-type": !1,
        "max-height": !0,
        "max-lines": !1,
        "max-width": !0,
        "min-height": !0,
        "min-width": !0,
        "move-to": !1,
        "nav-down": !1,
        "nav-index": !1,
        "nav-left": !1,
        "nav-right": !1,
        "nav-up": !1,
        "object-fit": !1,
        "object-position": !1,
        opacity: !1,
        order: !1,
        orphans: !1,
        outline: !1,
        "outline-color": !1,
        "outline-offset": !1,
        "outline-style": !1,
        "outline-width": !1,
        overflow: !1,
        "overflow-wrap": !1,
        "overflow-x": !1,
        "overflow-y": !1,
        padding: !0,
        "padding-bottom": !0,
        "padding-left": !0,
        "padding-right": !0,
        "padding-top": !0,
        page: !1,
        "page-break-after": !1,
        "page-break-before": !1,
        "page-break-inside": !1,
        "page-policy": !1,
        pause: !1,
        "pause-after": !1,
        "pause-before": !1,
        perspective: !1,
        "perspective-origin": !1,
        pitch: !1,
        "pitch-range": !1,
        "play-during": !1,
        position: !1,
        "presentation-level": !1,
        quotes: !1,
        "region-fragment": !1,
        resize: !1,
        rest: !1,
        "rest-after": !1,
        "rest-before": !1,
        richness: !1,
        right: !1,
        rotation: !1,
        "rotation-point": !1,
        "ruby-align": !1,
        "ruby-merge": !1,
        "ruby-position": !1,
        "shape-image-threshold": !1,
        "shape-outside": !1,
        "shape-margin": !1,
        size: !1,
        speak: !1,
        "speak-as": !1,
        "speak-header": !1,
        "speak-numeral": !1,
        "speak-punctuation": !1,
        "speech-rate": !1,
        stress: !1,
        "string-set": !1,
        "tab-size": !1,
        "table-layout": !1,
        "text-align": !0,
        "text-align-last": !0,
        "text-combine-upright": !0,
        "text-decoration": !0,
        "text-decoration-color": !0,
        "text-decoration-line": !0,
        "text-decoration-skip": !0,
        "text-decoration-style": !0,
        "text-emphasis": !0,
        "text-emphasis-color": !0,
        "text-emphasis-position": !0,
        "text-emphasis-style": !0,
        "text-height": !0,
        "text-indent": !0,
        "text-justify": !0,
        "text-orientation": !0,
        "text-overflow": !0,
        "text-shadow": !0,
        "text-space-collapse": !0,
        "text-transform": !0,
        "text-underline-position": !0,
        "text-wrap": !0,
        top: !1,
        transform: !1,
        "transform-origin": !1,
        "transform-style": !1,
        transition: !1,
        "transition-delay": !1,
        "transition-duration": !1,
        "transition-property": !1,
        "transition-timing-function": !1,
        "unicode-bidi": !1,
        "vertical-align": !1,
        visibility: !1,
        "voice-balance": !1,
        "voice-duration": !1,
        "voice-family": !1,
        "voice-pitch": !1,
        "voice-range": !1,
        "voice-rate": !1,
        "voice-stress": !1,
        "voice-volume": !1,
        volume: !1,
        "white-space": !1,
        widows: !1,
        width: !0,
        "will-change": !1,
        "word-break": !0,
        "word-spacing": !0,
        "word-wrap": !0,
        "wrap-flow": !1,
        "wrap-through": !1,
        "writing-mode": !1,
        "z-index": !1
      };
      return e;
    }

    var i = /javascript\s*\:/gim;
    t.whiteList = n(), t.getDefaultWhiteList = n, t.onAttr = function (e, t, n) {}, t.onIgnoreAttr = function (e, t, n) {}, t.safeAttrValue = function (e, t) {
      return i.test(t) ? "" : t;
    };
  }, function (e, t) {
    e.exports = {
      indexOf: function indexOf(e, t) {
        var n, i;
        if (Array.prototype.indexOf) return e.indexOf(t);

        for (n = 0, i = e.length; n < i; n++) if (e[n] === t) return n;

        return -1;
      },
      forEach: function forEach(e, t, n) {
        var i, r;
        if (Array.prototype.forEach) return e.forEach(t, n);

        for (i = 0, r = e.length; i < r; i++) t.call(n, e[i], i, e);
      },
      trim: function trim(e) {
        return String.prototype.trim ? e.trim() : e.replace(/(^\s*)|(\s*$)/g, "");
      },
      trimRight: function trimRight(e) {
        return String.prototype.trimRight ? e.trimRight() : e.replace(/(\s*$)/g, "");
      }
    };
  }, function (e, t, n) {
    var i = n(6);

    function r(e) {
      var t = i.spaceIndex(e);
      if (-1 === t) var n = e.slice(1, -1);else n = e.slice(1, t + 1);
      return "/" === (n = i.trim(n).toLowerCase()).slice(0, 1) && (n = n.slice(1)), "/" === n.slice(-1) && (n = n.slice(0, -1)), n;
    }

    function o(e) {
      return "</" === e.slice(0, 2);
    }

    var a = /[^a-zA-Z0-9_:\.\-]/gim;

    function s(e, t) {
      for (; t < e.length; t++) {
        var n = e[t];
        if (" " !== n) return "=" === n ? t : -1;
      }
    }

    function c(e, t) {
      for (; t > 0; t--) {
        var n = e[t];
        if (" " !== n) return "=" === n ? t : -1;
      }
    }

    function u(e) {
      return function (e) {
        return '"' === e[0] && '"' === e[e.length - 1] || "'" === e[0] && "'" === e[e.length - 1];
      }(e) ? e.substr(1, e.length - 2) : e;
    }

    t.parseTag = function (e, t, n) {
      var i = "",
          a = 0,
          s = !1,
          c = !1,
          u = 0,
          l = e.length,
          f = "",
          p = "";

      for (u = 0; u < l; u++) {
        var h = e.charAt(u);

        if (!1 === s) {
          if ("<" === h) {
            s = u;
            continue;
          }
        } else if (!1 === c) {
          if ("<" === h) {
            i += n(e.slice(a, u)), s = u, a = u;
            continue;
          }

          if (">" === h) {
            i += n(e.slice(a, s)), f = r(p = e.slice(s, u + 1)), i += t(s, i.length, f, p, o(p)), a = u + 1, s = !1;
            continue;
          }

          if (('"' === h || "'" === h) && "=" === e.charAt(u - 1)) {
            c = h;
            continue;
          }
        } else if (h === c) {
          c = !1;
          continue;
        }
      }

      return a < e.length && (i += n(e.substr(a))), i;
    }, t.parseAttr = function (e, t) {
      var n = 0,
          r = [],
          o = !1,
          l = e.length;

      function f(e, n) {
        if (!((e = (e = i.trim(e)).replace(a, "").toLowerCase()).length < 1)) {
          var o = t(e, n || "");
          o && r.push(o);
        }
      }

      for (var p = 0; p < l; p++) {
        var h,
            d = e.charAt(p);
        if (!1 !== o || "=" !== d) {
          if (!1 === o || p !== n || '"' !== d && "'" !== d || "=" !== e.charAt(p - 1)) {
            if (/\s|\n|\t/.test(d)) {
              if (e = e.replace(/\s|\n|\t/g, " "), !1 === o) {
                if (-1 === (h = s(e, p))) {
                  f(i.trim(e.slice(n, p))), o = !1, n = p + 1;
                  continue;
                }

                p = h - 1;
                continue;
              }

              if (-1 === (h = c(e, p - 1))) {
                f(o, u(i.trim(e.slice(n, p)))), o = !1, n = p + 1;
                continue;
              }
            } else ;
          } else {
            if (-1 === (h = e.indexOf(d, p + 1))) break;
            f(o, i.trim(e.slice(n + 1, h))), o = !1, n = (p = h) + 1;
          }
        } else o = e.slice(n, p), n = p + 1;
      }

      return n < e.length && (!1 === o ? f(e.slice(n)) : f(o, u(i.trim(e.slice(n))))), i.trim(r.join(" "));
    };
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return i;
    });

    var i = function () {
      function e(e) {
        this.options = e, this.options.data = Object.assign({}, this.data(), e.data);
      }

      return e.prototype._init = function () {
        return this.el = this.options.target, this.el ? (this.el.innerHTML = "", !0) : (console.warn("element not found"), !1);
      }, e.prototype.data = function () {
        return {};
      }, e.prototype.on = function (e, t, n) {
        var i = this._e || (this._e = {});
        (i[e] || (i[e] = [])).push({
          fn: t,
          ctx: n
        });
      }, e.prototype.fire = function (e) {
        for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];

        for (var i = [].slice.call(arguments, 1), r = ((this._e || (this._e = {}))[e] || []).slice(), o = 0, a = r.length; o < a; o++) r[o].fn.apply(r[o].ctx, i);
      }, e.prototype._resize = function () {}, e.prototype.set = function (e) {}, e;
    }();
  }, function (e, t, n) {
    e.exports = n(20);
  }, function (e, t, n) {
    var i = n(9),
        r = n(12),
        o = n(18);

    for (var a in (t = e.exports = function (e, t) {
      return new o(t).process(e);
    }).FilterXSS = o, i) t[a] = i[a];

    for (var a in r) t[a] = r[a];

    "undefined" != typeof window && (window.filterXSS = e.exports), "undefined" != typeof self && "undefined" != typeof DedicatedWorkerGlobalScope && self instanceof DedicatedWorkerGlobalScope && (self.filterXSS = e.exports);
  }, function (e, t, n) {
    var i = n(10),
        r = n(17);
    n(11);

    function o(e) {
      return null == e;
    }

    function a(e) {
      (e = function (e) {
        var t = {};

        for (var n in e) t[n] = e[n];

        return t;
      }(e || {})).whiteList = e.whiteList || i.whiteList, e.onAttr = e.onAttr || i.onAttr, e.onIgnoreAttr = e.onIgnoreAttr || i.onIgnoreAttr, e.safeAttrValue = e.safeAttrValue || i.safeAttrValue, this.options = e;
    }

    a.prototype.process = function (e) {
      if (!(e = (e = e || "").toString())) return "";
      var t = this.options,
          n = t.whiteList,
          i = t.onAttr,
          a = t.onIgnoreAttr,
          s = t.safeAttrValue;
      return r(e, function (e, t, r, c, u) {
        var l = n[r],
            f = !1;

        if (!0 === l ? f = l : "function" == typeof l ? f = l(c) : l instanceof RegExp && (f = l.test(c)), !0 !== f && (f = !1), c = s(r, c)) {
          var p,
              h = {
            position: t,
            sourcePosition: e,
            source: u,
            isWhite: f
          };
          return f ? o(p = i(r, c, h)) ? r + ":" + c : p : o(p = a(r, c, h)) ? void 0 : p;
        }
      });
    }, e.exports = a;
  }, function (e, t, n) {
    var i = n(11);

    e.exports = function (e, t) {
      ";" !== (e = i.trimRight(e))[e.length - 1] && (e += ";");
      var n = e.length,
          r = !1,
          o = 0,
          a = 0,
          s = "";

      function c() {
        if (!r) {
          var n = i.trim(e.slice(o, a)),
              c = n.indexOf(":");

          if (-1 !== c) {
            var u = i.trim(n.slice(0, c)),
                l = i.trim(n.slice(c + 1));

            if (u) {
              var f = t(o, s.length, u, l, n);
              f && (s += f + "; ");
            }
          }
        }

        o = a + 1;
      }

      for (; a < n; a++) {
        var u = e[a];

        if ("/" === u && "*" === e[a + 1]) {
          var l = e.indexOf("*/", a + 2);
          if (-1 === l) break;
          o = (a = l + 1) + 1, r = !1;
        } else "(" === u ? r = !0 : ")" === u ? r = !1 : ";" === u ? r || c() : "\n" === u && c();
      }

      return i.trim(s);
    };
  }, function (e, t, n) {
    var i = n(5).FilterCSS,
        r = n(9),
        o = n(12),
        a = o.parseTag,
        s = o.parseAttr,
        c = n(6);

    function u(e) {
      return null == e;
    }

    function l(e) {
      (e = function (e) {
        var t = {};

        for (var n in e) t[n] = e[n];

        return t;
      }(e || {})).stripIgnoreTag && (e.onIgnoreTag && console.error('Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time'), e.onIgnoreTag = r.onIgnoreTagStripAll), e.whiteList = e.whiteList || r.whiteList, e.onTag = e.onTag || r.onTag, e.onTagAttr = e.onTagAttr || r.onTagAttr, e.onIgnoreTag = e.onIgnoreTag || r.onIgnoreTag, e.onIgnoreTagAttr = e.onIgnoreTagAttr || r.onIgnoreTagAttr, e.safeAttrValue = e.safeAttrValue || r.safeAttrValue, e.escapeHtml = e.escapeHtml || r.escapeHtml, this.options = e, !1 === e.css ? this.cssFilter = !1 : (e.css = e.css || {}, this.cssFilter = new i(e.css));
    }

    l.prototype.process = function (e) {
      if (!(e = (e = e || "").toString())) return "";
      var t = this.options,
          n = t.whiteList,
          i = t.onTag,
          o = t.onIgnoreTag,
          l = t.onTagAttr,
          f = t.onIgnoreTagAttr,
          p = t.safeAttrValue,
          h = t.escapeHtml,
          d = this.cssFilter;
      t.stripBlankChar && (e = r.stripBlankChar(e)), t.allowCommentTag || (e = r.stripCommentTag(e));
      var g = !1;

      if (t.stripIgnoreTagBody) {
        g = r.StripTagBody(t.stripIgnoreTagBody, o);
        o = g.onIgnoreTag;
      }

      var v = a(e, function (e, t, r, a, g) {
        var v,
            _ = {
          sourcePosition: e,
          position: t,
          isClosing: g,
          isWhite: n.hasOwnProperty(r)
        };
        if (!u(v = i(r, a, _))) return v;

        if (_.isWhite) {
          if (_.isClosing) return "</" + r + ">";

          var E = function (e) {
            var t = c.spaceIndex(e);
            if (-1 === t) return {
              html: "",
              closing: "/" === e[e.length - 2]
            };
            var n = "/" === (e = c.trim(e.slice(t + 1, -1)))[e.length - 1];
            return n && (e = c.trim(e.slice(0, -1))), {
              html: e,
              closing: n
            };
          }(a),
              m = n[r],
              y = s(E.html, function (e, t) {
            var n,
                i = -1 !== c.indexOf(m, e);
            return u(n = l(r, e, t, i)) ? i ? (t = p(r, e, t, d)) ? e + '="' + t + '"' : e : u(n = f(r, e, t, i)) ? void 0 : n : n;
          });

          a = "<" + r;
          return y && (a += " " + y), E.closing && (a += " /"), a += ">";
        }

        return u(v = o(r, a, _)) ? h(a) : v;
      }, h);
      return g && (v = g.remove(v)), v;
    }, e.exports = l;
  }, function (e, t) {
    !function (e) {
      e.fn.checkboxButton = function (t) {
        return this.each(function () {
          e(this).on("click", function (n) {
            var i = n.target.tagName,
                r = e(this).find(":checkbox");
            "INPUT" !== i && (n.preventDefault(), r.prop("checked", !r.prop("checked")));
            var o = r.is(":checked");
            t.call(this, o);
          });
        });
      }, e.fn.disable = function () {
        return this.each(function () {
          var t = e(this);
          t.addClass("disabled"), t.data("tabindex", t.attr("tabindex")), t.removeAttr("tabindex");
        });
      }, e.fn.ellipsis = function (t) {
        return this.each(function () {
          var n = e(this),
              i = n.text();

          if (i.length > t) {
            var r = i.substr(0, t);
            r = r.substr(0, Math.min(r.length, r.lastIndexOf(" "))), n.empty().html(r + "&hellip;");
          }
        });
      }, e.fn.ellipsisFill = function (t) {
        var n = !0;
        return t || (n = !1), this.each(function () {
          var i = e(this);
          n || (t = i.text()), i.empty();
          var r = e('<span title="' + t + '"></span>');
          if (i.append(r), i.css("overflow", "hidden"), r.css("white-space", "nowrap"), r.html(t), r.width() > i.width()) for (var o = null; r.width() > i.width();) {
            var a = r.html();
            if ((a = a.substring(0, a.lastIndexOf(" ")) + "&hellip;") === o) break;
            r.html(a), o = a;
          }
        });
      }, e.fn.ellipsisHtmlFixed = function (t, n) {
        return this.each(function () {
          var i = e(this),
              r = i.html(),
              o = e("<span></span>");

          if (o.html(i.html().replace(/\s[\s]*/g, " ").trim()), !(o.text().trim().length <= t)) {
            for (; o.text().trim().length > t;) o.removeLastWord(t);

            var a = o.html(),
                s = !1;
            i.toggle = function () {
              i.empty();
              var t = e('<a href="#" class="toggle"></a>');
              s ? (i.html(r + " "), t.text("less"), t.switchClass("less", "more")) : (i.html(a + "&hellip; "), t.text("more"), t.switchClass("more", "less")), t.one("click", function (e) {
                e.preventDefault(), i.toggle();
              }), s = !s, i.append(t), n && n();
            }, i.toggle();
          }
        });
      }, e.fn.enable = function () {
        return this.each(function () {
          var t = e(this);
          t.removeClass("disabled"), t.attr("tabindex", t.data("tabindex"));
        });
      }, e.fn.equaliseHeight = function (t, n) {
        var i = -1,
            r = Number.MAX_VALUE,
            o = [];
        t && this.each(function () {
          e(this).height("auto");
        }), this.each(function () {
          var t = e(this).height();
          o.push(t), i = i > t ? i : t, r = r < t ? r : t;
        });
        var a = i;

        if (n) {
          o.sort(function (e, t) {
            return e - t;
          });
          var s = Math.floor(o.length / 2);
          a = o.length % 2 ? o[s] : (o[s - 1] + o[s]) / 2;
        }

        return this.each(function () {
          e(this).height(a);
        }), this;
      }, e.fn.getVisibleElementWithGreatestTabIndex = function () {
        var t = e(this),
            n = 0,
            i = null;
        return t.find("*:visible[tabindex]").each(function (t, r) {
          var o = e(r),
              a = parseInt(o.attr("tabindex"));
          a > n && (n = a, i = o);
        }), i;
      }, e.fn.horizontalMargins = function () {
        var t = e(this);
        return parseInt(t.css("marginLeft")) + parseInt(t.css("marginRight"));
      }, e.fn.leftMargin = function () {
        var t = e(this);
        return parseInt(t.css("marginLeft"));
      }, e.fn.rightMargin = function () {
        var t = e(this);
        return parseInt(t.css("marginRight"));
      }, e.fn.horizontalPadding = function () {
        var t = e(this);
        return parseInt(t.css("paddingLeft")) + parseInt(t.css("paddingRight"));
      }, e.fn.leftPadding = function () {
        var t = e(this);
        return parseInt(t.css("paddingLeft"));
      }, e.fn.rightPadding = function () {
        var t = e(this);
        return parseInt(t.css("paddingRight"));
      }, e.mlp = {
        x: 0,
        y: 0
      }, e(function t() {
        var n = this === document ? e(this) : e(this).contents();
        n.mousemove(function (e) {
          jQuery.mlp = {
            x: e.pageX,
            y: e.pageY
          };
        }), n.find("iframe").on("load", t);
      }), e.fn.ismouseover = function () {
        var t = !1;
        return this.eq(0).each(function () {
          var n = e(this).is("iframe") ? e(this).contents().find("body") : e(this),
              i = n.offset();
          t = i.left <= e.mlp.x && i.left + n.outerWidth() > e.mlp.x && i.top <= e.mlp.y && i.top + n.outerHeight() > e.mlp.y;
        }), t;
      };
      var t,
          n = e.fn.on;
      e.fn.on = function () {
        var e = Array.apply(null, arguments),
            i = e[e.length - 1];
        if (isNaN(i) || 1 === i && e.pop()) return n.apply(this, e);
        var r = e.pop(),
            o = e.pop();
        return e.push(function () {
          var e = this,
              n = arguments;
          clearTimeout(t), t = setTimeout(function () {
            o.apply(e, n);
          }, r);
        }), n.apply(this, e);
      }, e.fn.onEnter = function (t) {
        return this.each(function () {
          e(this).on("keyup", function (e) {
            13 === e.keyCode && (e.preventDefault(), t());
          });
        });
      }, e.fn.onPressed = function (t) {
        return this.each(function () {
          var n = e(this);
          n.on("touchstart click", function (e) {
            e.preventDefault(), t(e);
          }), n.on("keyup", function (e) {
            13 === e.keyCode && (e.preventDefault(), t(e));
          });
        });
      }, e.fn.removeLastWord = function (t, n) {
        return void 0 === t && (t = 8), void 0 === n && (n = 0), this.each(function () {
          var i = e(this);

          if (i.contents().length > 0) {
            var r = i.contents().last();

            if (3 === r[0].nodeType) {
              var o = r.text().trim().split(" ");
              if (o.length > 1) return o.splice(o.length - 1, 1), void (r[0].data = o.join(" "));
              if (void 0 !== t && 1 === o.length && o[0].length > t) return void (r[0].data = o.join(" ").substring(0, t));
            }

            r.removeLastWord(t, n + 1);
          } else n > 0 && i.remove();
        });
      }, e.fn.switchClass = function (t, n) {
        return this.each(function () {
          e(this).removeClass(t).addClass(n);
        });
      }, e.fn.targetBlank = function () {
        return this.each(function () {
          e(this).find("a").prop("target", "_blank");
        });
      }, e.fn.toggleExpandText = function (t, n, i, r) {
        return this.each(function () {
          var o = e(this),
              a = o.html();

          if (!(t > a.length)) {
            var s = !1,
                c = a.substr(0, t);
            c = c.substr(0, Math.min(c.length, c.lastIndexOf(" "))), o.toggle = function () {
              o.empty();
              var t = e('<a href="#" class="toggle"></a>');
              s ? (o.html(a + "&nbsp;"), t.text(n), t.switchClass("less", "more")) : (o.html(c + "&nbsp;"), t.text(i), t.switchClass("more", "less")), t.one("click", function (e) {
                e.preventDefault(), o.toggle();
              }), s = !s, o.append(t), r && r();
            }, o.toggle();
          }
        });
      }, e.fn.toggleExpandTextByLines = function (t, n, i, r) {
        return this.each(function () {
          for (var o = e(this), a = o.html(), s = e('<span>&hellip; <a href="#" class="toggle more">morepad</a></span>'), c = [a], u = o.height(); o.text().length > 0;) {
            o.removeLastWord();
            var l = o.html();
            o.append(s), u > o.height() && (c.unshift(l), u = o.height()), s.remove();
          }

          if (c.length <= t) o.html(a);else {
            var f = c[t - 1],
                p = !1;
            o.toggle = function () {
              o.empty();
              var t = e('<a href="#" class="toggle"></a>');
              p ? (o.html(a + " "), t.text(n), t.switchClass("less", "more")) : (o.html(f + "&hellip; "), t.text(i), t.switchClass("more", "less")), t.one("click", function (e) {
                e.preventDefault(), o.toggle();
              }), p = !p, o.append(t), r && r();
            }, o.toggle();
          }
        });
      }, e.fn.toggleText = function (t, n) {
        return this.each(function () {
          e(this).text() === t ? e(this).text(n) : e(this).text(t);
        });
      }, e.fn.updateAttr = function (t, n, i) {
        return this.each(function () {
          var r = e(this),
              o = r.attr(t);
          o && 0 === o.indexOf(n) && (o = o.replace(n, i), r.attr(t, o));
        });
      }, e.fn.verticalMargins = function () {
        var t = e(this);
        return parseInt(t.css("marginTop")) + parseInt(t.css("marginBottom"));
      }, e.fn.verticalPadding = function () {
        var t = e(this);
        return parseInt(t.css("paddingTop")) + parseInt(t.css("paddingBottom"));
      };
    }(jQuery);
  }, function (e, t, n) {
    "use strict";

    n.r(t);

    var _i18,
        r,
        o = function () {
      function e(e) {
        this.readonly = !1, this.readonly = e;
      }

      return e.prototype.get = function (e, t) {
        return null;
      }, e.prototype.set = function (e, t) {}, e;
    }(),
        a = n(3),
        s = (_i18 = function i(e, t) {
      return (_i18 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
      })(e, t);
    }, function (e, t) {
      function n() {
        this.constructor = e;
      }

      _i18(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
    }),
        c = function (e) {
      function t(t) {
        return void 0 === t && (t = !1), e.call(this, t) || this;
      }

      return s(t, e), t.prototype.get = function (e, t) {
        return a.o.getHashParameter(e, document) || t;
      }, t.prototype.set = function (e, t) {
        this.readonly || (t ? a.o.setHashParameter(e, t.toString(), document) : a.o.setHashParameter(e, "", document));
      }, t;
    }(o),
        u = n(4),
        l = function () {
      function e() {
        this.events = {};
      }

      return e.prototype.publish = function (e, t) {
        var n = this,
            i = this.events[e];
        void 0 !== i && i.forEach(function (e) {
          e.call(n, t);
        });
      }, e.prototype.subscribe = function (e, t) {
        var n = this.events[e];
        void 0 === n && (n = this.events[e] = []), n.push(t);
      }, e.prototype.unsubscribe = function (e, t) {
        var n = this.events[e];

        if (void 0 !== n) {
          var i = n.indexOf(t);
          n.splice(i);
        }
      }, e.prototype.dispose = function () {
        this.events = {};
      }, e;
    }(),
        f = n(7),
        p = n(0),
        h = n(8),
        d = n(13);

    n(19);
    !function () {
      if ("function" == typeof window.CustomEvent) return !1;

      function e(e, t) {
        t = t || {
          bubbles: !1,
          cancelable: !1,
          detail: void 0
        };
        var n = document.createEvent("CustomEvent");
        return n.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), n;
      }

      e.prototype = window.Event.prototype, window.CustomEvent = e, Element.prototype.scrollIntoViewIfNeeded || (Element.prototype.scrollIntoViewIfNeeded = function (e) {
        e = 0 === arguments.length || !!e;
        var t = this.parentNode,
            n = window.getComputedStyle(t, void 0),
            i = parseInt(n.getPropertyValue("border-top-width")),
            r = parseInt(n.getPropertyValue("border-left-width")),
            o = this.offsetTop - t.offsetTop < t.scrollTop,
            a = this.offsetTop - t.offsetTop + this.clientHeight - i > t.scrollTop + t.clientHeight,
            s = this.offsetLeft - t.offsetLeft < t.scrollLeft,
            c = this.offsetLeft - t.offsetLeft + this.clientWidth - r > t.scrollLeft + t.clientWidth,
            u = o && !a;
        (o || a) && e && (t.scrollTop = this.offsetTop - t.offsetTop - t.clientHeight / 2 - i + this.clientHeight / 2), (s || c) && e && (t.scrollLeft = this.offsetLeft - t.offsetLeft - t.clientWidth / 2 - r + this.clientWidth / 2), (o || a || s || c) && !e && this.scrollIntoView(u);
      });
    }(), r = navigator.userAgent || navigator.vendor || window.opera, (jQuery.browser = jQuery.browser || {}).mobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|android|ipad|playbook|silk|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(r) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(r.substr(0, 4)), window.browserDetect = {
      init: function init() {
        this.browser = this.searchString(this.dataBrowser) || "Other", this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "Unknown", "Explorer" == this.browser && "7" == this.version && navigator.userAgent.match(/Trident/i) && (this.version = this.searchVersionIE());
      },
      searchString: function searchString(e) {
        for (var t = 0; t < e.length; t++) {
          var n = e[t].string;
          if (this.versionSearchString = e[t].subString, -1 != n.indexOf(e[t].subString)) return e[t].identity;
        }
      },
      searchVersion: function searchVersion(e) {
        var t = e.indexOf(this.versionSearchString);
        if (-1 != t) return parseFloat(e.substring(t + this.versionSearchString.length + 1));
      },
      searchVersionIE: function searchVersionIE() {
        var e,
            t = navigator.userAgent.toString().toLowerCase(),
            n = /(trident)(?:.*rv:([\w.]+))?/.exec(t) || /(msie) ([\w.]+)/.exec(t) || ["", null, -1];

        try {
          e = n[2].split(".")[0];
        } catch (t) {
          e = "unknown";
        }

        return e;
      },
      dataBrowser: [{
        string: navigator.userAgent,
        subString: "Chrome",
        identity: "Chrome"
      }, {
        string: navigator.userAgent,
        subString: "MSIE",
        identity: "Explorer"
      }, {
        string: navigator.userAgent,
        subString: "Trident",
        identity: "Explorer"
      }, {
        string: navigator.userAgent,
        subString: "Firefox",
        identity: "Firefox"
      }, {
        string: navigator.userAgent,
        subString: "Safari",
        identity: "Safari"
      }, {
        string: navigator.userAgent,
        subString: "Opera",
        identity: "Opera"
      }]
    }, window.browserDetect.init();

    var g,
        v = function () {
      var _e = function e(t, n) {
        return (_e = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        })(t, n);
      };

      return function (t, n) {
        function i() {
          this.constructor = t;
        }

        _e(t, n), t.prototype = null === n ? Object.create(n) : (i.prototype = n.prototype, new i());
      };
    }(),
        _ = function _(e, t, n, i) {
      return new (n || (n = Promise))(function (r, o) {
        function a(e) {
          try {
            c(i.next(e));
          } catch (e) {
            o(e);
          }
        }

        function s(e) {
          try {
            c(i.throw(e));
          } catch (e) {
            o(e);
          }
        }

        function c(e) {
          var t;
          e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
            e(t);
          })).then(a, s);
        }

        c((i = i.apply(e, t || [])).next());
      });
    },
        E = function E(e, t) {
      var n,
          i,
          r,
          o,
          a = {
        label: 0,
        sent: function sent() {
          if (1 & r[0]) throw r[1];
          return r[1];
        },
        trys: [],
        ops: []
      };
      return o = {
        next: s(0),
        throw: s(1),
        return: s(2)
      }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
        return this;
      }), o;

      function s(o) {
        return function (s) {
          return function (o) {
            if (n) throw new TypeError("Generator is already executing.");

            for (; a;) try {
              if (n = 1, i && (r = 2 & o[0] ? i.return : o[0] ? i.throw || ((r = i.return) && r.call(i), 0) : i.next) && !(r = r.call(i, o[1])).done) return r;

              switch (i = 0, r && (o = [2 & o[0], r.value]), o[0]) {
                case 0:
                case 1:
                  r = o;
                  break;

                case 4:
                  return a.label++, {
                    value: o[1],
                    done: !1
                  };

                case 5:
                  a.label++, i = o[1], o = [0];
                  continue;

                case 7:
                  o = a.ops.pop(), a.trys.pop();
                  continue;

                default:
                  if (!(r = a.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                    a = 0;
                    continue;
                  }

                  if (3 === o[0] && (!r || o[1] > r[0] && o[1] < r[3])) {
                    a.label = o[1];
                    break;
                  }

                  if (6 === o[0] && a.label < r[1]) {
                    a.label = r[1], r = o;
                    break;
                  }

                  if (r && a.label < r[2]) {
                    a.label = r[2], a.ops.push(o);
                    break;
                  }

                  r[2] && a.ops.pop(), a.trys.pop();
                  continue;
              }

              o = t.call(e, a);
            } catch (e) {
              o = [6, e], i = 0;
            } finally {
              n = r = 0;
            }

            if (5 & o[0]) throw o[1];
            return {
              value: o[0] ? o[1] : void 0,
              done: !0
            };
          }([o, s]);
        };
      }
    };

    !function (e) {
      e.ALEPH = "uv-aleph-extension", e.DEFAULT = "uv-default-extension", e.EBOOK = "uv-ebook-extension", e.MEDIAELEMENT = "uv-mediaelement-extension", e.MODELVIEWER = "uv-model-viewer-extension", e.OSD = "uv-openseadragon-extension", e.PDF = "uv-pdf-extension";
    }(g || (g = {}));

    var m = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        return n.isFullScreen = !1, n.dataProvider = new c(), n._pubsub = new l(), n._init(), n._resize(), n;
      }

      return v(t, e), t.prototype._init = function () {
        var t,
            i = this;
        return e.prototype._init.call(this), this._extensions = ((t = {})[g.ALEPH] = function () {
          return _(i, void 0, void 0, function () {
            var e, t;
            return E(this, function (i) {
              switch (i.label) {
                case 0:
                  return [4, Promise.all([n.e(3), n.e(25), n.e(2), n.e(17)]).then(n.bind(null, 291))];

                case 1:
                  return e = i.sent(), (t = new e.default()).name = g.ALEPH, [2, t];
              }
            });
          });
        }, t[g.DEFAULT] = function () {
          return _(i, void 0, void 0, function () {
            var e, t;
            return E(this, function (i) {
              switch (i.label) {
                case 0:
                  return [4, Promise.all([n.e(3), n.e(2), n.e(18)]).then(n.bind(null, 296))];

                case 1:
                  return e = i.sent(), (t = new e.default()).name = g.DEFAULT, [2, t];
              }
            });
          });
        }, t[g.EBOOK] = function () {
          return _(i, void 0, void 0, function () {
            var e, t;
            return E(this, function (i) {
              switch (i.label) {
                case 0:
                  return [4, Promise.all([n.e(3), n.e(26), n.e(2), n.e(19)]).then(n.bind(null, 292))];

                case 1:
                  return e = i.sent(), (t = new e.default()).name = g.EBOOK, [2, t];
              }
            });
          });
        }, t[g.MEDIAELEMENT] = function () {
          return _(i, void 0, void 0, function () {
            var e, t;
            return E(this, function (i) {
              switch (i.label) {
                case 0:
                  return [4, Promise.all([n.e(3), n.e(27), n.e(2), n.e(20)]).then(n.bind(null, 295))];

                case 1:
                  return e = i.sent(), (t = new e.default()).name = g.MEDIAELEMENT, [2, t];
              }
            });
          });
        }, t[g.MODELVIEWER] = function () {
          return _(i, void 0, void 0, function () {
            var e, t;
            return E(this, function (i) {
              switch (i.label) {
                case 0:
                  return [4, Promise.all([n.e(3), n.e(4), n.e(28), n.e(2), n.e(21)]).then(n.bind(null, 294))];

                case 1:
                  return e = i.sent(), (t = new e.default()).name = g.MODELVIEWER, [2, t];
              }
            });
          });
        }, t[g.OSD] = function () {
          return _(i, void 0, void 0, function () {
            var e, t;
            return E(this, function (i) {
              switch (i.label) {
                case 0:
                  return [4, Promise.all([n.e(3), n.e(4), n.e(29), n.e(2), n.e(22)]).then(n.bind(null, 290))];

                case 1:
                  return e = i.sent(), (t = new e.default()).name = g.OSD, [2, t];
              }
            });
          });
        }, t[g.PDF] = function () {
          return _(i, void 0, void 0, function () {
            var e, t;
            return E(this, function (i) {
              switch (i.label) {
                case 0:
                  return [4, Promise.all([n.e(3), n.e(2), n.e(23)]).then(n.bind(null, 293))];

                case 1:
                  return e = i.sent(), (t = new e.default()).name = g.PDF, [2, t];
              }
            });
          });
        }, t), this._extensionRegistry = {}, this._extensionRegistry[p.a.CANVAS] = {
          load: this._extensions[g.OSD]
        }, this._extensionRegistry[p.a.DOCUMENT] = {
          load: this._extensions[g.PDF]
        }, this._extensionRegistry[p.a.IMAGE] = {
          load: this._extensions[g.OSD]
        }, this._extensionRegistry[p.a.MOVING_IMAGE] = {
          load: this._extensions[g.MEDIAELEMENT]
        }, this._extensionRegistry[p.a.PHYSICAL_OBJECT] = {
          load: this._extensions[g.MODELVIEWER]
        }, this._extensionRegistry[p.a.SOUND] = {
          load: this._extensions[g.MEDIAELEMENT]
        }, this._extensionRegistry[p.d.PDF] = {
          load: this._extensions[g.PDF]
        }, this._extensionRegistry[p.c.AUDIO_MP4] = {
          load: this._extensions[g.MEDIAELEMENT]
        }, this._extensionRegistry.default = {
          load: this._extensions[g.DEFAULT]
        }, this._extensionRegistry[p.c.DRACO] = {
          load: this._extensions[g.MODELVIEWER]
        }, this._extensionRegistry[p.c.GLB] = {
          load: this._extensions[g.MODELVIEWER]
        }, this._extensionRegistry[p.c.GLTF] = {
          load: this._extensions[g.MODELVIEWER]
        }, this._extensionRegistry[p.c.JPG] = {
          load: this._extensions[g.OSD]
        }, this._extensionRegistry[p.c.MP3] = {
          load: this._extensions[g.MEDIAELEMENT]
        }, this._extensionRegistry[p.c.PDF] = {
          load: this._extensions[g.PDF]
        }, this._extensionRegistry[p.c.USDZ] = {
          load: this._extensions[g.MODELVIEWER]
        }, this._extensionRegistry[p.c.VIDEO_MP4] = {
          load: this._extensions[g.MEDIAELEMENT]
        }, this._extensionRegistry[p.c.EPUB] = {
          load: this._extensions[g.EBOOK]
        }, this._extensionRegistry[p.c.OPF] = {
          load: this._extensions[g.EBOOK]
        }, this.set(this.options.data), !0;
      }, t.prototype.data = function () {
        return {
          annotations: void 0,
          assetsDir: "./uv-assets/",
          canvasIndex: 0,
          collectionIndex: void 0,
          config: void 0,
          configUri: void 0,
          embedded: !1,
          isLightbox: !1,
          isReload: !1,
          limitLocales: !1,
          manifestUri: "",
          locales: [{
            name: "en-GB"
          }],
          manifestIndex: 0,
          rangeId: void 0,
          rotation: 0,
          sequenceIndex: 0,
          xywh: ""
        };
      }, t.prototype.set = function (e) {
        if (this.extension) Object(f.a)(e, this.extension.data, ["collectionIndex", "manifestIndex", "config", "configUri", "domain", "embedDomain", "embedScriptUri", "manifestUri", "isHomeDomain", "isLightbox", "isOnlyInstance", "isReload", "locales", "root"]) ? (this.extension.data = Object.assign({}, this.extension.data, e), this._reload(this.extension.data)) : (this.extension.data = Object.assign({}, this.extension.data, e), this.extension.render());else {
          if (!e.manifestUri) return void this._error("manifestUri is required.");
          e.assetsDir && e.assetsDir.endsWith("/") && (e.assetsDir = e.assetsDir.substring(0, e.assetsDir.length - 1)), this._reload(e);
        }
      }, t.prototype._getExtension = function (e) {
        return this._extensionRegistry[e] || (e = "default"), this._extensionRegistry[e].load();
      }, t.prototype.get = function (e) {
        if (this.extension) return this.extension.data[e];
      }, t.prototype.publish = function (e, t) {
        this._pubsub.publish(e, t);
      }, t.prototype.subscribe = function (e, t) {
        this._pubsub.subscribe(e, t);
      }, t.prototype._reload = function (e) {
        return _(this, void 0, void 0, function () {
          var t,
              n,
              i,
              r,
              o,
              a,
              s,
              c,
              l,
              f,
              p,
              d,
              g = this;
          return E(this, function (v) {
            switch (v.label) {
              case 0:
                return this._pubsub.dispose(), this.subscribe(u.a.RELOAD, function (e) {
                  g.fire(u.a.RELOAD, e);
                }), (t = $(this.options.target)).empty(), t.addClass("loading"), n = this, [4, Object(h.e)({
                  manifestUri: e.manifestUri,
                  collectionIndex: e.collectionIndex,
                  manifestIndex: e.manifestIndex || 0,
                  sequenceIndex: e.sequenceIndex || 0,
                  canvasIndex: e.canvasIndex || 0,
                  rangeId: e.rangeId,
                  locale: e.locales ? e.locales[0].name : void 0
                })];

              case 1:
                return i = v.sent(), (r = i.getTrackingLabel()) && (r += document.referrer, window.trackingLabel = r), void 0 === e.sequenceIndex || i.getSequenceByIndex(e.sequenceIndex) ? (void 0 !== e.canvasIndex && (o = i.getCanvasByIndex(e.canvasIndex)), o ? (a = void 0, (s = o.getContent()).length ? (c = s[0], (l = c.getBody()) && l.length ? (d = l[0].getFormat()) ? [4, n._getExtension(d)] : [3, 5] : [3, 7]) : [3, 8]) : (n._error("Canvas " + e.canvasIndex + " not found."), [2])) : (n._error("Sequence " + e.sequenceIndex + " not found."), [2]);

              case 2:
                return (a = v.sent()) ? [3, 4] : (f = l[0].getType()) ? [4, n._getExtension(f)] : [3, 4];

              case 3:
                a = v.sent(), v.label = 4;

              case 4:
                return [3, 7];

              case 5:
                return (f = l[0].getType()) ? [4, n._getExtension(f)] : [3, 7];

              case 6:
                a = v.sent(), v.label = 7;

              case 7:
                return [3, 12];

              case 8:
                return (p = o.getType()) ? [4, n._getExtension(p)] : [3, 10];

              case 9:
                a = v.sent(), v.label = 10;

              case 10:
                return a ? [3, 12] : (d = o.getProperty("format"), [4, n._getExtension(d)]);

              case 11:
                a = v.sent(), v.label = 12;

              case 12:
                return a ? [3, 14] : [4, n._getExtension("default")];

              case 13:
                a = v.sent(), v.label = 14;

              case 14:
                return n._configure(e, a, function (t) {
                  e.config = t, n._injectCss(e, a, function () {
                    n._createExtension(a, e, i);
                  });
                }), [2];
            }
          });
        });
      }, t.prototype._error = function (e) {
        this.fire(u.a.ERROR, e);
      }, t.prototype._configure = function (e, t, n) {
        var i = this;

        this._getConfigExtension(e, t, function (r) {
          if (e.locales) {
            var o = e.assetsDir + "/config/" + t.name + "." + e.locales[0].name + ".config.json";
            $.getJSON(o, function (o) {
              i._extendConfig(e, t, o, r, n);
            });
          }
        });
      }, t.prototype._extendConfig = function (e, t, n, i, r) {
        n.name = t.name, i && (n.uri = e.configUri, $.extend(!0, n, i)), r(n);
      }, t.prototype._getConfigExtension = function (e, t, n) {
        if (e.locales) {
          var i = sessionStorage.getItem(t.name + "." + e.locales[0].name),
              r = e.configUri;
          i ? n(JSON.parse(i)) : r ? $.getJSON(r, function (e) {
            n(e);
          }) : n(null);
        }
      }, t.prototype._injectCss = function (e, t, n) {
        if (e.locales) {
          var i = e.assetsDir + "/themes/" + e.config.options.theme + "/css/" + t.name + "/theme.css",
              r = e.locales[0].name,
              o = t.name.toLowerCase() + "-theme-" + r.toLowerCase();
          $("#" + o.toLowerCase()).length || $("head").append('<link rel="stylesheet" id="' + o + '" href="' + i.toLowerCase() + '" />'), n();
        }
      }, t.prototype._createExtension = function (e, t, n) {
        this.extension = e, this.extension && (this.extension.component = this, this.extension.data = t, this.extension.helper = n, this.extension.create());
      }, t.prototype.exitFullScreen = function () {
        this.extension && this.extension.exitFullScreen();
      }, t.prototype.resize = function () {
        this.extension && this.extension.resize();
      }, t;
    }(d.a),
        y = function y(e, t) {
      var n,
          i = !1,
          r = "string" == typeof e ? document.getElementById(e) : e;
      if (!r) throw new Error("UV target element not found");
      r.innerHTML = "";
      var o = document.createElement("div");
      r.appendChild(o);
      var s = document.createElement("div");
      o.appendChild(s);

      var c = function c() {
        n && (i ? (o.style.width = window.innerWidth + "px", o.style.height = window.innerHeight + "px") : (o.style.width = r.offsetWidth + "px", o.style.height = r.offsetHeight + "px"), n.resize());
      };

      return window.addEventListener("resize", function () {
        c();
      }), window.addEventListener("orientationchange", function () {
        setTimeout(function () {
          c();
        }, 100);
      }), (n = new m({
        target: s,
        data: t
      })).on("created", function (e) {
        c();
      }, !1), n.on("openedMedia", function () {
        setTimeout(function () {
          c();
        }, 100);
      }, !1), n.on("collectionIndexChanged", function (e) {
        n.dataProvider.set("c", e);
      }, !1), n.on("manifestIndexChanged", function (e) {
        n.dataProvider.set("m", e);
      }, !1), n.on("canvasIndexChanged", function (e) {
        n.dataProvider.set("cv", e);
      }, !1), n.on("rangeChanged", function (e) {
        n.dataProvider.set("rid", e);
      }, !1), n.on("reload", function (e) {
        e.isReload = !0, n.set(e);
      }, !1), n.on("toggleFullScreen", function (e) {
        if (i = e.isFullScreen, !e.overrideFullScreen) if (i) {
          var t = function (e) {
            if (e.webkitRequestFullscreen) return e.webkitRequestFullscreen;
            if (e.mozRequestFullScreen) return e.mozRequestFullScreen;
            if (e.msRequestFullscreen) return e.msRequestFullscreen;
            if (e.requestFullscreen) return e.requestFullscreen;
            return !1;
          }(o);

          t && (t.call(o), c());
        } else {
          var n = function () {
            if (document.webkitExitFullscreen) return document.webkitExitFullscreen;
            if (document.msExitFullscreen) return document.msExitFullscreen;
            if (document.mozCancelFullScreen) return document.mozCancelFullScreen;
            if (document.exitFullscreen) return document.exitFullscreen;
            return !1;
          }();

          n && (n.call(document), setTimeout(function () {
            c();
          }, 100), setTimeout(function () {
            c();
          }, 1e3));
        }
      }, !1), n.on("error", function (e) {
        console.error(e);
      }, !1), n.on("bookmark", function (e) {
        var t = o.ownerDocument.URL,
            n = a.o.getUrlParts(t),
            i = n.pathname + n.search + o.ownerDocument.location.hash;
        i.startsWith("/") || (i = "/" + i), e.path = i, console.log("bookmark", e);
      }, !1), $(document).on("fullscreenchange webkitfullscreenchange mozfullscreenchange MSFullscreenChange", function (e) {
        ("webkitfullscreenchange" === e.type && !document.webkitIsFullScreen || "fullscreenchange" === e.type && !document.fullscreenElement || "mozfullscreenchange" === e.type && !document.mozFullScreen || "MSFullscreenChange" === e.type && null === document.msFullscreenElement) && n.exitFullScreen();
      }), n;
    };

    n.d(t, "URLDataProvider", function () {
      return c;
    }), n.d(t, "Viewer", function () {
      return m;
    }), n.d(t, "init", function () {
      return y;
    });
  }]);
});